(function ()
{
    'use strict';

    angular
        .module('app.workflow', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.workflow', {
                url    : '/workflow',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/workflow/views/workflow.html',
                        controller : 'WorkflowController as vm'
                    }
                },
                authenticate: true
            })
            .state('app.workflow.variables', {
                url    : '/vars',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/workflow/views/variables/workflow-variables.html',
                        controller : 'WorkflowVariablesController as vm'
                    }
                },
                authenticate: true
            });

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow')
        .controller('WorkflowDialogController', WorkflowDialogController);

    /** @ngInject */
    function WorkflowDialogController($mdDialog, $translate, selectedWorkflow, geocitizenDTO, workflowDTO, workflowService, $cookies)
    {
        var vm = this;

        // Data
        var workflowData = {
                            "name": null,
                            "description": null,
                            "subgeo_id": geocitizenDTO.selectedProject.id,
                            "user_id": geocitizenDTO.user.id
                         };

        vm.workflowDetails = selectedWorkflow ? copyDataToJsonApi() : workflowData;
        vm.languages = geocitizenDTO.languages;

        vm.theme = $cookies.get('selectedTheme');

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveWorkflow = saveWorkflow;

        //////////
        function saveWorkflow(){
            workflowService.saveWorkflow(vm.workflowDetails).then(function(result){
                workflowDTO.reloadWorkflows();
                closeDialog();                                
            });
        }

        function copyDataToJsonApi(){
            var copyData =  {
                                "id": selectedWorkflow.id,
                                "name": selectedWorkflow.name,
                                "description": selectedWorkflow.description
                            };

            return copyData;
        }

        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.workflow')
        .controller('VariableDialogController', VariableDialogController);

    /** @ngInject */
    function VariableDialogController($mdDialog, $translate, $timeout, selectedVariable, allVariables, geocitizenDTO, workflowDTO, workflowService, $cookies)
    {
        var vm = this;

        // Data
        var variableData = {
                            "name": null,
                            "definition": null,
                            "workflow_id": workflowDTO.selectedWorkflow.id,
                            "data_type": null
                         };
        
        var mathField = null;

        vm.otherVariables = _.clone(allVariables);

        vm.variableDetails = selectedVariable ? copyDataToJsonApi() : variableData;
        vm.languages = geocitizenDTO.languages;

        vm.theme = $cookies.get('selectedTheme');

        vm.variableTypes = [    { description: $translate.instant('SHARED.NUMERIC'), value: "numeric"},
                                { description: $translate.instant('SHARED.BOOLEAN'), value: "boolean"},
                                { description: $translate.instant('SHARED.TEXT'), value: "text"}
                            ];

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveVariable = saveVariable;

        initMath();

        function initMath(){
            var htmlElement = document.getElementById('mathquillDiv');

            if(htmlElement){
                var config = {
                    handlers: { 
                        edit: function(mathField) {
                            var enteredMath = mathField.latex(); // Get entered math in LaTeX format
                            
                            if(vm.otherVariableSelected){
                                var varName = vm.otherVariableSelected.name.replace(new RegExp(' ', 'g'), '');
                                enteredMath = enteredMath.replace(new RegExp(varName, 'g'), 'otherVarId_'+vm.otherVariableSelected.id);
                            }
                            
                            //console.log(enteredMath);
                            vm.variableDetails.definition = enteredMath;

                            console.log('mathfield', mathField);

                            console.log(enteredMath);
                        }
                    },
                    restrictMismatchedBrackets: true
                };
                mathField = MQ.MathField(htmlElement, config);

                console.log(mathField);
            }else{
                setTimeout(initMath, 1000);
            }
        }

        function isLetter(c) {
            return c.toLowerCase() != c.toUpperCase();
        }

        vm.addSymbol = function(symbol, cmd){
            if(cmd){
                mathField.cmd("\\"+symbol);
            }else{
                mathField.write(symbol);
            }

            $timeout(function(){
                mathField.focus();
            }, 200);
        }

        vm.addOtherVariable = function(){

            var varName = vm.otherVariableSelected.name.replace(new RegExp(' ', 'g'), '');

            mathField.write(varName);

            $timeout(function(){
                mathField.focus();

                //vm.otherVariableSelected = null;
            }, 200);
        }

        function saveVariable(){
            workflowService.saveVariable(vm.variableDetails).then(function(result){
                workflowDTO.reloadVariables();
                closeDialog();                                
            });
        }

        function copyDataToJsonApi(){
            var copyData =  {
                                "id": selectedVariable.id,
                                "name": selectedVariable.name,
                                "definition": selectedVariable.definition,
                                "data_type": selectedVariable.data_type
                            };

            _.remove(vm.otherVariables, { id: selectedVariable.id });

            return copyData;
        }

        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.survey_new', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.survey-new', {
                url    : '/survey-new',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/survey-new/views/survey.html',
                        controller : 'SurveysNewController as vm'
                    }
                },
                authenticate: true
            })
            .state('app.survey-new.questions', {
                url    : '/questions',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/survey-new/views/questions/questions.html',
                        controller : 'QuestionsNewController as vm'
                    }
                },
                authenticate: true
            })
            .state('app.survey-new.copyquestions', {
                url    : '/copy-questions',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/question/views/questions.html',
                        controller : 'QuestionsLibraryController as vm'
                    }
                },
                authenticate: true
            })
            .state('app.survey-new.others', {
                url    : '/other-surveys',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/survey-new/views/other-surveys/other-surveys.html',
                        controller : 'OtherSurveysNewController as vm'
                    }
                },
                authenticate: true
            })
            .state('app.survey-new.assign', {
                url    : '/assign-surveys',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/survey-new/views/assign/assign-surveys.html',
                        controller : 'AssignSurveysNewController as vm'
                    }
                },
                authenticate: true
            });

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.survey_new')
        .controller('SurveyPreviewDialogNewController', SurveyPreviewDialogNewController);

    /** @ngInject */
    function SurveyPreviewDialogNewController($mdDialog, selectedSurvey, geocitizenDTO, surveyDTO, surveyNewService, $cookies)
    {
        var vm = this;

        // Data
        vm.survey = selectedSurvey;
        
        vm.theme = $cookies.get('selectedTheme');

        // Methods
        vm.closeDialog = closeDialog;

        loadData();

        function loadData(){
            vm.languages = {};
            _.each(geocitizenDTO.languages, function(lang){
                vm.languages[lang.code] = lang.name;
            });
        }

        vm.changeQuestionsOrder = function(){

            vm.loading = true;
            var count = 1;
            var totalQuestions = vm.survey.survey_configurations.length;

            _.each(vm.survey.survey_configurations, function(conf){
                surveyNewService.saveQuestionConfig({ id: conf.id, question_order: conf.question_order }).then(function(result){
                    if(count == totalQuestions){
                        vm.loading = false;
                    }else{
                        count++;
                    }
                });
            });            
        }

        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.survey_new')
        .controller('RoundsDialogController', RoundsDialogController);

    /** @ngInject */
    function RoundsDialogController($mdDialog, $translate, selectedSurvey, geocitizenDTO, surveyDTO, surveyNewService, notificationsDTO, $cookies)
    {
        var vm = this;

        // Data
        vm.survey = selectedSurvey;
        
        vm.theme = $cookies.get('selectedTheme');

        // Methods
        vm.closeDialog = closeDialog;

        loadRounds();

        //////////
        function loadRounds(){

            vm.loadingRounds = true;

            surveyNewService.getSurveyRounds(vm.survey.id, geocitizenDTO.selectedProject.id).then(function(result) {
                
                vm.rounds = [];
                result.data.forEach(function(element) {
                    
                    element.start_at = new Date(element.start_at);
                    element.end_at = new Date(element.end_at);

                    vm.rounds.push(element);
                });
            });
        }

        vm.deleteRound = function(round){

            if(round.id != null){
                surveyNewService.deleteRound(round.id, geocitizenDTO.selectedProject.id).then(function(result) {

                    _.remove(vm.rounds, { id: round.id });

                    notificationsDTO.showSimpleToast($translate.instant('SHARED.INFO_DELETED'));
                });
            }else{
                _.remove(vm.rounds, { tempId: round.tempId });

                notificationsDTO.showSimpleToast($translate.instant('SHARED.INFO_DELETED'));
            }            
        }

        vm.addRound = function(){

            var date = new Date();
            var id = date.getMilliseconds();

            vm.rounds.push({ id: null, round: '', survey_id: vm.survey.id, start_at: null, end_at: null, survey_pendings_count: 0, tempId: id });
        }

        vm.saveRounds = function(){
            surveyNewService.saveRounds(vm.rounds, geocitizenDTO.selectedProject.id).then(function(result) {

                notificationsDTO.showSimpleToast($translate.instant('SHARED.INFO_SAVED'));

                closeDialog();
            });
        }

        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.survey_new')
        .controller('SurveyDialogNewController', SurveyDialogNewController);

    /** @ngInject */
    function SurveyDialogNewController($mdDialog, $translate, api, selectedSurvey, geocitizenDTO, surveyDTO, surveyNewService, groupService, $cookies)
    {
        var vm = this;

        // Data
        var surveyData = {
                            "title": null,
                            "description": null,
                            "language_id": geocitizenDTO.currentLanguage,
                            "share": true,
                            "status": "edit",
                            "subgeo_id": geocitizenDTO.selectedProject.id,
                            "user_id": geocitizenDTO.user.id,
                            "final_msg": "",
                            "start_at": moment().toDate(),
                            "default": true
                         };

        vm.surveyDetails = selectedSurvey ? copySurveyDataToJsonApi() : surveyData;
        vm.languages = geocitizenDTO.languages;
        vm.groupsLabel = $translate.instant("SURVEY.GROUPS");
        vm.api = api;

        vm.theme = $cookies.get('selectedTheme');

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveSurvey = saveSurvey;

        loadGroups();

        function loadGroups(){
            groupService.getGroupsByRegion(geocitizenDTO.selectedProject.id, geocitizenDTO.user.id).then(function(result) {
                vm.groups = result.data;
            });
        }

        //////////
        function saveSurvey(){
            surveyNewService.saveSurvey(vm.surveyDetails).then(function(result){
                
                if(result.data.default == 1){
                    surveyNewService.setDefaultSurvey(result.data.id, geocitizenDTO.selectedProject.id).then(function(result){
                        surveyDTO.reloadSurveys();
                        closeDialog();
                    });   
                }else{
                    surveyDTO.reloadSurveys();
                    closeDialog();
                }                             
            });
        }

        function copySurveyDataToJsonApi(){

            var copyData =  {
                                "id": selectedSurvey.id,
                                "title": selectedSurvey.title,
                                "description": selectedSurvey.description,
                                "language_id": selectedSurvey.language_id,
                                "share": selectedSurvey.share,
                                "status": selectedSurvey.status,
                                "start_at": new Date(selectedSurvey.start_at),
                                "end_at": new Date(selectedSurvey.end_at),
                                "final_msg": selectedSurvey.final_msg,
                                "groups": selectedSurvey.groups,
                                "default": selectedSurvey.default,
                                "groupIds": []
                            };

            _.each(selectedSurvey.groups, function(group){
                copyData.groupIds.push(group.id);
            });

            return copyData;
        }

        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.survey_new')
        .controller('QuestionDialogNewController', QuestionDialogNewController);

    /** @ngInject */
    function QuestionDialogNewController($mdDialog, $translate, selectedSurveyConfiguration, questionOrder, geocitizenDTO, surveyDTO, surveyNewService, $cookies)
    {
        var vm = this;

        // Data
        vm.selectedSurvey = surveyDTO.selectedSurvey;
        vm.mandatoryQuestion = 1; 
        vm.questionData =  {
                                "question": null,
                                "language_id": vm.selectedSurvey.language_id,
                                "answer_type": null,
                                "choices": [],
                                "configuration": { 
                                                    "question_order": questionOrder, 
                                                    "mandatory": vm.mandatoryQuestion,
                                                    "survey_id": surveyDTO.selectedSurvey.id
                                                }                              
                            };

        vm.theme = $cookies.get('selectedTheme');

        if(selectedSurveyConfiguration){
            prepareQuestionJson(selectedSurveyConfiguration);
        }
        //vm.surveyDetails.type = "surveyQuestion";

        vm.answerTypes = [  { answer: $translate.instant('QUESTION.LIKERT_SCALE'), code: "likert"},
                            { answer: $translate.instant('QUESTION.SINGLE_CHOICE'), code: "single_choice"},
                            { answer: $translate.instant('QUESTION.MULTI_CHOICE'), code: "multiple_choice"},
                            { answer: $translate.instant('QUESTION.TEXT'), code: "input"},
                            { answer: $translate.instant('QUESTION.NUMBER'), code: "number"},
                            //{ answer: $translate.instant('QUESTION.HEADLINE'), code: "headline"},
                            { answer: $translate.instant('QUESTION.YES_NO'), code: "boolean"}
                         ];

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveQuestion = saveQuestion;
        vm.changeAnswerType = changeAnswerType;
        vm.addChoice = addChoice;
        vm.removeChoice = removeChoice;

        //////////
        function saveQuestion(){

            var okToSave = true;
            switch (vm.questionData.answer_type) {
                case "single_choice": case "multiple_choice":
                    if(vm.questionData.choices.length <= 1){
                        okToSave = false;
                        vm.errorMsg = $translate.instant('QUESTION.ERRORS.NO_CHOICES');
                    }
                    break;
            } 

            if(okToSave){
                //set mandatory value
                vm.questionData.configuration.mandatory = vm.mandatoryQuestion;

                if(vm.questionData.id){
                    surveyNewService.deleteQuestion(vm.questionData.id, geocitizenDTO.user.id).then(function(result){
                        delete vm.questionData.id;
                        createQuestion();                            
                    });
                }else{
                    createQuestion();
                }
            }            
        }

        function createQuestion(){
            surveyNewService.saveQuestion(vm.questionData).then(function(result){
                //surveyDTO.reloadQuestions();
                
                surveyDTO.reloadQuestions();
                closeDialog();             
            });
        }

        function closeDialog()
        {
            $mdDialog.hide();
        }

        //On answer type change
        function changeAnswerType(){
            vm.showChoices = false;

            switch (vm.questionData.answer_type) {
                case "single_choice": case "multiple_choice":
                    vm.showChoices = true;
                    break;
            }
        }

        function addChoice(){
            if(vm.questionChoice && vm.questionChoice.length > 0){
                vm.questionData.choices.push({ number: vm.questionData.choices.length + 1, text: vm.questionChoice });
                vm.questionChoice = null;
            }            
        }

        function removeChoice(choice){
            /*if (choice.id) {
                surveyNewService.deleteChoice(choice.id).then(function(result){
                    _.remove(vm.questionData.choices, { number: choice.number });                    
                });
            } else {*/
                _.remove(vm.questionData.choices, { number: choice.number });                    
            //}                        
        }

        function prepareQuestionJson(surveyConfiguration){
            vm.questionData.id = surveyConfiguration.survey_question_id;
            vm.questionData.question = surveyConfiguration.survey_question.question;
            vm.questionData.answer_type = surveyConfiguration.survey_question.answer_type;
            vm.questionData.configuration.question_order = surveyConfiguration.question_order;
            vm.questionData.configuration.mandatory = surveyConfiguration.mandatory;

            switch (surveyConfiguration.survey_question.answer_type) {
                case "single_choice": case "multiple_choice":
                    vm.showChoices = true;
                    //Load choices
                    _.each(surveyConfiguration.survey_question.survey_choices, function(choice){
                        vm.questionData.choices.push({ number: vm.questionData.choices.length + 1, id: choice.id, text: choice.choice });
                    });
                    break;
            } 
        }   
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.survey', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.survey', {
                url    : '/survey',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/survey/views/survey.html',
                        controller : 'SurveysController as vm'
                    }
                },
                authenticate: true
            })
            .state('app.survey.questions', {
                url    : '/questions',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/survey/views/questions/questions.html',
                        controller : 'QuestionsController as vm'
                    }
                },
                authenticate: true
            })
            .state('app.survey.copyquestions', {
                url    : '/copy-questions',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/question/views/questions.html',
                        controller : 'QuestionsLibraryController as vm'
                    }
                },
                authenticate: true
            })
            .state('app.survey.others', {
                url    : '/other-surveys',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/survey/views/other-surveys/other-surveys.html',
                        controller : 'OtherSurveysController as vm'
                    }
                },
                authenticate: true
            });

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.survey')
        .controller('SurveyPreviewDialogController', SurveyPreviewDialogController);

    /** @ngInject */
    function SurveyPreviewDialogController($mdDialog, selectedSurvey, geocitizenDTO, surveyDTO, surveyService, $cookies)
    {
        var vm = this;

        // Data
        vm.survey = selectedSurvey; 

        vm.theme = $cookies.get('selectedTheme');

        // Methods
        vm.closeDialog = closeDialog;

        loadData();

        function loadData(){
            vm.languages = {};
            _.each(geocitizenDTO.languages, function(lang){
                vm.languages[lang.code] = lang.name;
            });
        }

        vm.changeQuestionsOrder = function(){

            vm.loading = true;
            var count = 1;
            var totalQuestions = vm.survey.survey_configurations.length;

            _.each(vm.survey.survey_configurations, function(conf){
                surveyService.saveQuestionConfig({ id: conf.id, question_order: conf.question_order }).then(function(result){
                    if(count == totalQuestions){
                        vm.loading = false;
                    }else{
                        count++;
                    }
                });
            });            
        }

        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.survey')
        .controller('SurveyDialogController', SurveyDialogController);

    /** @ngInject */
    function SurveyDialogController($mdDialog, $translate, selectedSurvey, geocitizenDTO, surveyDTO, surveyService, groupService, $cookies)
    {
        var vm = this;

        // Data
        var surveyData = {
                            "title": null,
                            "description": null,
                            "language_id": geocitizenDTO.currentLanguage,
                            "share": true,
                            "status": "edit",
                            "subgeo_id": geocitizenDTO.selectedProject.id,
                            "user_id": geocitizenDTO.user.id,
                            "final_msg": "",
                            "start_at": moment().toDate()
                         };

        vm.surveyDetails = selectedSurvey ? copySurveyDataToJsonApi() : surveyData;
        vm.languages = geocitizenDTO.languages;
        vm.groupsLabel = $translate.instant("SURVEY.GROUPS");

        vm.theme = $cookies.get('selectedTheme');

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveSurvey = saveSurvey;

        loadGroups();

        function loadGroups(){
            groupService.getGroupsByRegion(geocitizenDTO.selectedProject.id, geocitizenDTO.user.id).then(function(result) {
                vm.groups = result.data;
            });
        }

        //////////
        function saveSurvey(){
            surveyService.saveSurvey(vm.surveyDetails).then(function(result){
                surveyService.associateGroups(result.data.id, vm.surveyDetails.groupIds).then(function(result){
                    surveyDTO.reloadSurveys();
                    closeDialog();
                });
            });
        }

        function copySurveyDataToJsonApi(){
            var copyData =  {
                                "id": selectedSurvey.id,
                                "title": selectedSurvey.title,
                                "description": selectedSurvey.description,
                                "language_id": selectedSurvey.language_id,
                                "share": selectedSurvey.share,
                                "status": selectedSurvey.status,
                                "start_at": new Date(selectedSurvey.start_at),
                                "end_at": new Date(selectedSurvey.end_at),
                                "final_msg": selectedSurvey.final_msg,
                                "groups": selectedSurvey.groups,
                                "groupIds": []
                            };

            _.each(selectedSurvey.groups, function(group){
                copyData.groupIds.push(group.id);
            });

            return copyData;
        }

        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.survey')
        .controller('QuestionDialogController', QuestionDialogController);

    /** @ngInject */
    function QuestionDialogController($mdDialog, $translate, selectedSurveyConfiguration, questionOrder, geocitizenDTO, surveyDTO, surveyService, $cookies)
    {
        var vm = this;

        // Data
        vm.selectedSurvey = surveyDTO.selectedSurvey;
        vm.mandatoryQuestion = 1; 
        vm.questionData =  {
                                "question": null,
                                "language_id": vm.selectedSurvey.language_id,
                                "answer_type": null,
                                "choices": [],
                                "configuration": { 
                                                    "question_order": questionOrder, 
                                                    "mandatory": vm.mandatoryQuestion,
                                                    "survey_id": surveyDTO.selectedSurvey.id
                                                }                              
                            };

        vm.theme = $cookies.get('selectedTheme');

        if(selectedSurveyConfiguration){
            prepareQuestionJson(selectedSurveyConfiguration);
        }
        //vm.surveyDetails.type = "surveyQuestion";

        vm.answerTypes = [  { answer: $translate.instant('QUESTION.LIKERT_SCALE'), code: "likert"},
                            { answer: $translate.instant('QUESTION.SINGLE_CHOICE'), code: "single_choice"},
                            { answer: $translate.instant('QUESTION.MULTI_CHOICE'), code: "multiple_choice"},
                            { answer: $translate.instant('QUESTION.TEXT'), code: "input"},
                            { answer: $translate.instant('QUESTION.NUMBER'), code: "number"},
                            //{ answer: $translate.instant('QUESTION.HEADLINE'), code: "headline"},
                            { answer: $translate.instant('QUESTION.YES_NO'), code: "boolean"}
                         ];

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveQuestion = saveQuestion;
        vm.changeAnswerType = changeAnswerType;
        vm.addChoice = addChoice;
        vm.removeChoice = removeChoice;

        //////////
        function saveQuestion(){

            var okToSave = true;
            switch (vm.questionData.answer_type) {
                case "single_choice": case "multiple_choice":
                    if(vm.questionData.choices.length <= 1){
                        okToSave = false;
                        vm.errorMsg = $translate.instant('QUESTION.ERRORS.NO_CHOICES');
                    }
                    break;
            } 

            if(okToSave){
                //set mandatory value
                vm.questionData.configuration.mandatory = vm.mandatoryQuestion;

                if(vm.questionData.id){
                    surveyService.deleteQuestion(vm.questionData.id, geocitizenDTO.user.id).then(function(result){
                        delete vm.questionData.id;
                        createQuestion();                            
                    });
                }else{
                    createQuestion();
                }
            }            
        }

        function createQuestion(){
            surveyService.saveQuestion(vm.questionData).then(function(result){
                //surveyDTO.reloadQuestions();
                
                surveyDTO.reloadQuestions();
                closeDialog();             
            });
        }

        function closeDialog()
        {
            $mdDialog.hide();
        }

        //On answer type change
        function changeAnswerType(){
            vm.showChoices = false;

            switch (vm.questionData.answer_type) {
                case "single_choice": case "multiple_choice":
                    vm.showChoices = true;
                    break;
            }
        }

        function addChoice(){
            if(vm.questionChoice && vm.questionChoice.length > 0){
                vm.questionData.choices.push({ number: vm.questionData.choices.length + 1, text: vm.questionChoice });
                vm.questionChoice = null;
            }            
        }

        function removeChoice(choice){
            /*if (choice.id) {
                surveyService.deleteChoice(choice.id).then(function(result){
                    _.remove(vm.questionData.choices, { number: choice.number });                    
                });
            } else {*/
                _.remove(vm.questionData.choices, { number: choice.number });                    
            //}                        
        }

        function prepareQuestionJson(surveyConfiguration){
            vm.questionData.id = surveyConfiguration.survey_question_id;
            vm.questionData.question = surveyConfiguration.survey_question.question;
            vm.questionData.answer_type = surveyConfiguration.survey_question.answer_type;
            vm.questionData.configuration.question_order = surveyConfiguration.question_order;
            vm.questionData.configuration.mandatory = surveyConfiguration.mandatory;

            switch (surveyConfiguration.survey_question.answer_type) {
                case "single_choice": case "multiple_choice":
                    vm.showChoices = true;
                    //Load choices
                    _.each(surveyConfiguration.survey_question.survey_choices, function(choice){
                        vm.questionData.choices.push({ number: vm.questionData.choices.length + 1, id: choice.id, text: choice.choice });
                    });
                    break;
            } 
        }   
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.reports', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.reports', {
                url    : '/reports',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/reports/views/reports.html',
                        controller : 'ReportsController as vm'
                    }
                },
                authenticate: true
            })
            .state('app.public-reports', {
                url    : '/public-reports',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/reports/views/public-reports/public-reports.html',
                        controller : 'PublicReportsController as vm'
                    }
                },
                authenticate: false
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportDialogController', ReportDialogController);

    /** @ngInject */
    function ReportDialogController($scope, $mdDialog, geocitizenDTO, $cookies, 
                                    Upload, selectedReport, reportsService, api)
    {
        var vm = this;

        // Data
        vm.selectedProject = geocitizenDTO.selectedProject;
        vm.file = null;

        var reportData = {
                            title: null, 
                            description: null,
                            year: null,
                            url: null,
                            public: null,
                            user_id: geocitizenDTO.user.id,
                            subgeo_id: vm.selectedProject.id
                        };
        
        vm.theme = $cookies.get('selectedTheme');

        vm.reportDetails = selectedReport ? copyReportDataToJsonApi() : reportData;

        // Methods
        vm.closeDialog = closeDialog;
        vm.upload = upload;

        //////////    
        function upload() {
            if (vm.file) {
                if (!vm.file.$error) {

                    vm.saveInProgress = true;

                    Upload.upload({
                        url: api.fileManagementUrl,
                        disableProgress: true,
                        data: {
                          files: vm.file  
                        }
                    }).then(function (resp) {
                        
                        vm.reportDetails.url = resp.data.files[0].name;
                        save();

                    }, null, function (evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                    });
                }
            }
        };

        function save(){

            vm.reportDetails.public = vm.accessData.private == 0 ? true : false;

            reportsService.saveReport(vm.reportDetails).then(function(result){
                
                closeDialog(true);
            });                  
        }

        function copyReportDataToJsonApi(){

            var copyData =  {
                                id: selectedReport.id,
                                title: selectedReport.title, 
                                description: selectedReport.description,
                                year: selectedReport.year,
                                url: selectedReport.url,
                                public: selectedReport.public
                            };

            return copyData;
        }

        function closeDialog(success)
        {
            if(success){
                $mdDialog.hide();
            }else{
                $mdDialog.cancel();
            }            
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.question', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.question', {
                url    : '/question-library',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/question/views/questions.html',
                        controller : 'QuestionsLibraryController as vm'
                    }
                },
                authenticate: true
            });

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.question')
        .controller('QuestionImportDialogController', QuestionImportDialogController);

    /** @ngInject */
    function QuestionImportDialogController($mdDialog, $state, selectedQuestions, geocitizenDTO, surveyDTO, surveyService, questionService, $cookies)
    {
        var vm = this;

        // Data
        vm.questions = selectedQuestions; 
        vm.theme = $cookies.get('selectedTheme');
        //vm.selectedSurvey = surveyDTO.selectedSurvey;

        // Methods
        vm.closeDialog = closeDialog;
        vm.importQuestions = importQuestions;

        loadData();

        function loadData(){

            /*if(vm.selectedSurvey){
                vm.survey = vm.selectedSurvey.id;
            }*/

            vm.languages = {};
            _.each(geocitizenDTO.languages, function(lang){
                vm.languages[lang.code] = lang.name;
            });

            surveyService.getSurveysByRegion(geocitizenDTO.selectedProject.id, geocitizenDTO.user.id).then(function(result) {
                vm.surveys = result.data;
            });
        }

        //////////

        function importQuestions(){

            var ids = [];
            _.each(vm.questions, function(q){
                ids.push(q.id);
            });

            questionService.importSurveyQuestions(vm.survey.id, ids).then(function(result) {
                closeDialog();
                surveyDTO.selectedSurvey = vm.survey;
                $state.go('app.survey.questions');
            });
        }

        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.question')
        .controller('QuestionPreviewDialogController', QuestionPreviewDialogController);

    /** @ngInject */
    function QuestionPreviewDialogController($mdDialog, selectedQuestion, geocitizenDTO, $cookies)
    {
        var vm = this;

        // Data
        vm.question = selectedQuestion; 
        vm.theme = $cookies.get('selectedTheme');

        // Methods
        vm.closeDialog = closeDialog;

        loadData();

        function loadData(){
            vm.languages = {};
            _.each(geocitizenDTO.languages, function(lang){
                vm.languages[lang.code] = lang.name;
            });
        }

        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.process', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.process', {
                url    : '/process',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/process/views/process.html',
                        controller : 'ProcessController as vm'
                    }
                },
                authenticate: true
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.process')
        .controller('ProcessDialogController', ProcessDialogController);

    /** @ngInject */
    function ProcessDialogController($mdDialog, $translate, geocitizenDTO, processService, $cookies)
    {
        var vm = this;

        // Data
        vm.selectedProject = geocitizenDTO.selectedProject;

        vm.accessData = {
                            id: vm.selectedProject.id, 
                            proposal_days: vm.selectedProject.proposal_days,
                            proposal_participants: vm.selectedProject.proposal_participants,
                            private: vm.selectedProject.private,
                            allow_anonymous: vm.selectedProject.allow_anonymous
                        };
        
        vm.theme = $cookies.get('selectedTheme');

        // Methods
        vm.closeDialog = closeDialog;
        vm.save = save;

        //////////
        function save(){

            vm.accessData.private = vm.accessData.private == 1 ? true : false;
            vm.accessData.allow_anonymous = vm.accessData.allow_anonymous == 1 ? true : false;

            processService.saveSubgeo(vm.accessData).then(function(result){
                
                geocitizenDTO.selectedProject.proposal_days = result.data.proposal_days;
                geocitizenDTO.selectedProject.proposal_participants = result.data.proposal_participants;
                geocitizenDTO.selectedProject.private = result.data.private;
                geocitizenDTO.selectedProject.allow_anonymous = result.data.allow_anonymous;

                closeDialog();
            });                       
        }

        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.group', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.group', {
                url    : '/group',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/group/views/group.html',
                        controller : 'GroupController as vm'
                    }
                },
                authenticate: true
            })
            .state('app.group.users', {
                url    : '/users',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/group/views/users/users.html',
                        controller : 'UsersGroupController as vm'
                    }
                },
                authenticate: true
            });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.group')
        .controller('GroupNotificationDialogController', GroupNotificationDialogController);

    /** @ngInject */
    function GroupNotificationDialogController($mdDialog, $state, $translate, selectedGroup, geocitizenDTO, groupService, groupDTO, notificationsDTO, $cookies)
    {
        var vm = this;

        // Data
        vm.group = selectedGroup;

        vm.scheduleOptions = [  { type: 1, description: $translate.instant('GROUP.NOW')},
                                { type: 2, description: $translate.instant('GROUP.DATE_TIME')}
                             ];

        vm.schedule = { type: 1, datetime: null };

        vm.theme = $cookies.get('selectedTheme');

        vm.changeSchedule = function(){
            if(vm.schedule.type == 2){
                vm.schedule.datetime = null;
            }else{
                vm.schedule.datetime = 'now';
            }
        }

        vm.sendNotification = function(){

            var date = null;
            if(vm.schedule.type == 2){
                date = vm.schedule.date_details.gDate;
            }

            groupService.sendNotification(vm.group.id, vm.notificationMsg, date).then(function(result) {
                vm.groups = result.data;

                vm.closeDialog();
                
                notificationsDTO.showSimpleToast($translate.instant('GROUP.NOTIFICATION_SENT'));
            });
        }
        
        vm.closeDialog = function()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.participants', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.participants', {
                url    : '/participants',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/participants/views/participants.html',
                        controller : 'ParticipantsController as vm'
                    }
                },
                authenticate: true
            });
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.participants')
        .controller('AssignRoleDialogController', AssignRoleDialogController);

    /** @ngInject */
    function AssignRoleDialogController($mdDialog, $state, $translate, participant, geocitizenDTO, participantsService, participantsDTO, $cookies)
    {
        var vm = this;

        // Data
        vm.participant = participant;

        var allRoles =  [ 
                            {id: 1, name: $translate.instant('PARTICIPANTS.ADMIN')},
                            {id: 2, name: $translate.instant('PARTICIPANTS.MODERATOR')},
                            {id: 3, name: $translate.instant('PARTICIPANTS.GEOUSER')},
                            {id: 4, name: $translate.instant('PARTICIPANTS.FACILITATOR')},
                            {id: 6, name: $translate.instant('PARTICIPANTS.GEOEXPERT')}
                        ];
        vm.roles = [];

        vm.theme = $cookies.get('selectedTheme');

        getRoles();

        // Methods
        vm.closeDialog = closeDialog;

        function getRoles(){
            participantsService.getRoles(geocitizenDTO.selectedProject.id).then(function(result) {
                _.each(result.data.roles, function(roleId){
                    var role = _.find(allRoles, { id: roleId });
                    if(role){
                        vm.roles.push(role);    
                    }                    
                });
            });
        }

        //////////
        vm.assignRole = function(){
            participantsService.assignParticipantRole(geocitizenDTO.selectedProject.id, participant.user_id, vm.selectedRoleId).then(function(result) {
                participantsDTO.reloadParticipants();
                closeDialog();
            });
        }
        
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.group')
        .controller('GroupDialogController', GroupDialogController);

    /** @ngInject */
    function GroupDialogController($mdDialog, $state, $translate, selectedGroup, geocitizenDTO, groupService, groupDTO, $cookies)
    {
        var vm = this;

        // Data
        var groupData = {
                            "name": null,
                            "description": null,
                            "subgeo_id": geocitizenDTO.selectedProject.id,
                            "user_id": geocitizenDTO.user.id
                         };

        vm.theme = $cookies.get('selectedTheme');

        var currentYear = moment().year();
        var years = [];
        for (var i = currentYear; i >= 1930; i--) {
            years.push({ label: i, value: i });
        }

        var autoFilter = {
            filters: 
                    [
                        { label: $translate.instant('GROUP.BIRTHYEAR'), 
                            variable: 'birth_year', comparators: [1,2,3,4,5,6], type: 'select', typeValues: years },
                        { label: $translate.instant('GROUP.GENDER'), 
                            variable: 'gender', comparators: [5], 
                            type: 'select', typeValues: [ 
                                                            { label: $translate.instant('GROUP.FEMININE'), value: 'female'},
                                                            { label: $translate.instant('GROUP.MASCULINE'), value: 'male'}
                                                        ]  },
                        { label: $translate.instant('GROUP.SINCE'), variable: 'created_at', comparators: [1,2,3,4,5,6], type: 'date' }
                    ],
            comparators: 
                    [
                        { id: 1, label: '>', operator: '>', values: 1 },
                        { id: 2, label: '>=', operator: '>=', values: 1 },
                        { id: 3, label: '<', operator: '<', values: 1 },
                        { id: 4, label: '<=', operator: '<=', values: 1 },
                        { id: 5, label: '=', operator: '=', values: 1 },
                        { id: 6, label: $translate.instant('GROUP.BETWEEN'), operator: 'between', values: 2 }
                    ]
        };
        vm.currentFilterId = 1;

        vm.createdFilters = [];

        vm.groupDetails = selectedGroup ? copyGroupDataToJsonApi() : groupData;

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 10,
            scrollY     : 'auto',
            responsive  : true,
            language    : {
                url : "/app/data/i18n/datatables/" + geocitizenDTO.currentLanguageCode + ".json"
            }
        };

        // Methods
        vm.closeDialog = closeDialog;
        vm.filterTypeChange = filterTypeChange;

        //////////

        function filterTypeChange(){
            if(vm.addUsersType == 'auto'){
                vm.createdFilters = [];

                var userFilter = angular.copy(autoFilter);
                userFilter.id = vm.currentFilterId;

                vm.createdFilters.push(userFilter);

            }else{
                groupService.getUsersByRegion(geocitizenDTO.selectedProject.id).then(function(result){
                    vm.usersByRegion = result.data;

                    _.each(selectedGroup.users, function(user){
                        var tempUser = _.find(vm.usersByRegion, { id: user.id });
                        if(tempUser){
                            tempUser.inGroup = true;
                        }   
                    });
                });
            }
        }

        vm.addFilter = function(){
            vm.currentFilterId++;
            var userFilter = angular.copy(autoFilter);
            userFilter.id = vm.currentFilterId;
            vm.createdFilters.push(userFilter);
        }

        vm.removeFilter = function(filterToRemove){
            var index = vm.createdFilters.indexOf(filterToRemove);
            vm.createdFilters.splice(index, 1);
        }

        vm.showComparator = function(selectedFilter, comparatorId) {
           return selectedFilter.comparators.indexOf(comparatorId) !== -1;
        }

        vm.saveGroup = function(){
            groupService.saveGroup(vm.groupDetails).then(function(result){
                vm.groupDetails.id = result.data.id;

                if(vm.addUsersType == 'auto'){
                    saveFilters();
                }else if(vm.addUsersType == 'manual'){
                    saveManualUsers();                    
                }
            });
        }

        function saveManualUsers(){
            var ids = [];
            _.each(vm.usersByRegion, function(user){
                if(user.inGroup){
                    ids.push(user.id);
                }
            });

            groupService.associateUsers(vm.groupDetails.id, ids).then(function(result){
                groupDTO.reloadGroups();
                closeDialog();
            });
        }

        function saveFilters(){
            var filters = [];

            //format filters before request
            _.each(vm.createdFilters, function(createdFilter){
                filters.push({  
                                filter: { 
                                            variable: createdFilter.selectedFilter.variable,
                                            firstValue: createdFilter.selectedFilter.firstValue,
                                            secondValue: createdFilter.selectedFilter.secondValue,
                                            dataType: createdFilter.selectedFilter.type
                                        }, 
                                comparator: {
                                                operator: createdFilter.selectedComparator.operator,
                                                values:  createdFilter.selectedComparator.values
                                            }
                            });
            });

            groupService.saveGroupFilters(vm.groupDetails.id, filters).then(function(result){
                groupDTO.reloadGroups();
                closeDialog();
            });
        }

        function copyGroupDataToJsonApi(){
            var copyData =  {
                                "id": selectedGroup.id,
                                "name": selectedGroup.name,
                                "description": selectedGroup.description
                            };

            if(selectedGroup.filters.length > 0){
                vm.addUsersType = 'auto';
                var currentId = 1;

                _.each(selectedGroup.filters, function(filter){
                    var userFilter = angular.copy(autoFilter);
                    userFilter.id = currentId;

                    userFilter.selectedFilter = _.find(userFilter.filters, { variable: filter.variable });
                    userFilter.selectedComparator = _.find(userFilter.comparators, { operator: filter.comparator });

                    if(userFilter.selectedFilter.type == 'date'){                        
                        userFilter.selectedFilter.secondValue = moment(filter.second_value, "YYYY-MM-DD").toDate();

                        if(userFilter.selectedComparator.values > 1){
                            userFilter.selectedFilter.firstValue = moment(filter.first_value, "YYYY-MM-DD").toDate();
                        }
                    }else{
                        userFilter.selectedFilter.firstValue = filter.first_value;
                        userFilter.selectedFilter.secondValue = filter.second_value;
                    } 

                    vm.createdFilters.push(userFilter);

                    currentId++;
                });

                vm.currentFilterId = vm.createdFilters.length;                

            }else if(selectedGroup.users.length > 0){
                vm.addUsersType = 'manual';
                filterTypeChange();
            }

            return copyData;
        }
        
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.flags', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.flags', {
                url    : '/flags',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/flags/views/flags.html',
                        controller : 'FlagsController as vm'
                    }
                },
                authenticate: true
            });        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.flags')
        .controller('ShowDescriptionDialogController', ShowDescriptionDialogController);

    /** @ngInject */
    function ShowDescriptionDialogController($mdDialog, selectedFlag, geocitizenDTO, flagsService, $cookies)
    {
        var vm = this;

        // Data
        vm.flag = selectedFlag; 

        vm.theme = $cookies.get('selectedTheme');

        // Methods
        vm.closeDialog = closeDialog;

        changeSeenByModStatus();

        function changeSeenByModStatus(){
            selectedFlag.seen_by_mod = true;
            flagsService.saveFlag(selectedFlag).then(function(result) {
                console.log('saved');
            });
        }

        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.flags')
        .controller('EditFlagDialogController', EditFlagDialogController);

    /** @ngInject */
    function EditFlagDialogController($mdDialog, selectedFlag, editMode, geocitizenDTO, flagsService, flagsDTO, $cookies)
    {
        var vm = this;

        // Data
        vm.flag = selectedFlag;
        vm.editMode = editMode; 
        vm.element = selectedFlag.uploadable;
        var model = selectedFlag.uploadable_type.split('\\').pop();
        vm.theme = $cookies.get('selectedTheme');

        loadData();

        // Methods
        vm.closeDialog = closeDialog;

        //////////

        function loadData(){
            vm.title = vm.element.title ? true : false;
            vm.text = vm.element.text ? true : false;
            vm.description = vm.element.description ? true : false;
        }

        function closeDialog()
        {
            $mdDialog.hide();
        }

        vm.saveElement = function(){
            flagsService.saveEditedElement(vm.element, model).then(function(result) {
                selectedFlag.solved = true;
                flagsService.saveFlag(selectedFlag).then(function(result) {
                    flagsDTO.removeFlag(selectedFlag.id);
                    closeDialog();
                });
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.workflow')
        .controller('WorkflowVariablesController', WorkflowVariablesController);

    /** @ngInject */
    function WorkflowVariablesController($state, $mdDialog, $document, $translate, $timeout, workflowService, workflowDTO, geocitizenDTO)
    {
        var vm = this;

        // Data
        vm.selectedProject = geocitizenDTO.selectedProject;
        vm.topBgClass = geocitizenDTO.style.topBgClass;
        vm.selectedWorkflow = workflowDTO.selectedWorkflow;
        vm.mqInitialized = false;

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function ()
            {
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 10,
            scrollY     : 'auto',
            responsive  : true,
            language    : {
                url : "/app/data/i18n/datatables/" + geocitizenDTO.currentLanguageCode + ".json"
            }
        };

        // Methods
        workflowDTO.reloadVariables = loadVariables;
        vm.goToVariableDetail = goToVariableDetail;
        vm.goToWorkflows = goToWorkflows;

        loadVariables();

        //////////
        function loadVariables(){
            vm.selectedProject = geocitizenDTO.selectedProject;
            
            workflowService.getVariablesByWorkflow(geocitizenDTO.selectedProject.id, workflowDTO.selectedWorkflow.id).then(function(result) {
                vm.variables = result.data;

                var tempVariables = _.clone(vm.variables);
                tempVariables.forEach(function(varToSearch){
                    
                    vm.variables.forEach(function(item){

                        if(item.definition.includes('otherVarId_'+varToSearch.id)){
                            item.definitionToShow = item.definition.replace(new RegExp('otherVarId_'+varToSearch.id, 'g'), varToSearch.name);
                        }
                        
                        if(item.report_type){
                            var onReport = item.report_type.split(',');
                            onReport.forEach(function(value) {
                                switch (value) {
                                    case 'all':
                                        item.reportAll = true;
                                        break;
                                    case 'text':
                                        item.reportText = true;
                                        break;
                                    case 'chart':
                                        item.reportChart = true;
                                        break;
                                    case 'map':
                                        item.reportMap = true;
                                        break;
                                }
                            });
                        } 
                    });                                       
                });

                vm.variables.forEach(function(variable){
                    if(!variable.definitionToShow){
                        variable.definitionToShow = variable.definition;    
                    }
                });

                $timeout(initMQ, 1000);
            });
        }

        function initMQ(){
            vm.variables.forEach(function(variable){
                var htmlElement = document.getElementById('definition-'+variable.id);
                MQ.StaticMath(htmlElement);
            });

            vm.mqInitialized = true;
        }
        /**
         * Go to product detail
         *
         * @param id
         */
        function goToVariableDetail(variable)
        {
            var data = variable ? variable : undefined;

            $mdDialog.show({
                controller         : 'VariableDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedVariable: data,
                    allVariables   : vm.variables
                },
                templateUrl        : 'app/main/workflow/views/dialogs/variable/variable-dialog.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false
            });
        }

        function goToWorkflows(){
            workflowDTO.selectedWorkflow = null;
            $state.go('app.workflow');
        }

        vm.deleteVariable = function(variable){

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title($translate.instant('QUESTION.DELETE'))
                .textContent($translate.instant('WORKFLOW.DELETE_VARIABLE'))
                .ariaLabel('Delete')
                .ok($translate.instant('QUESTION.OK'))
                .cancel($translate.instant('QUESTION.CANCEL'));

            $mdDialog.show(confirm).then(function() {
                workflowService.deleteVariable(geocitizenDTO.selectedProject.id, variable.id).then(function(result) {
                    loadVariables();
                });
            }, function() {
                
            });               
        }

        vm.viewHideVariable = function(option, variable){
            variable.view = option;

            saveVariable(variable);
        }

        vm.onReportVariableChange = function(variable){
            if(variable.reportAll){
                variable.reportText = false;
                variable.reportChart = false;
                variable.reportMap = false;

                variable.report_type = 'all';

            }else{
                variable.report_type = '';

                if(variable.reportText){
                    variable.report_type += 'text,';
                }
                if(variable.reportChart){
                    variable.report_type += 'chart,';
                }
                if(variable.reportMap){
                    variable.report_type += 'map,';
                }
            }

            saveVariable(variable);
        }

        function saveVariable(variable){
            workflowService.saveVariable(variable).then(function(result){});
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.survey_new')
        .controller('OtherSurveysNewController', OtherSurveysNewController);

    /** @ngInject */
    function OtherSurveysNewController($state, $mdDialog, $document, $translate, surveyNewService, surveyDTO, geocitizenDTO)
    {
        var vm = this;

        // Data
        vm.selectedProject = geocitizenDTO.selectedProject;
        vm.topBgClass = geocitizenDTO.style.topBgClass;

        vm.surveyStatus = { edit: $translate.instant('SURVEY.EDIT_MODE'),
                            started: $translate.instant('SURVEY.STARTED_MODE'),
                            ended: $translate.instant('SURVEY.ENDED_MODE')
                        };

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function ()
            {
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 10,
            scrollY     : 'auto',
            responsive  : true,
            language    : {
                url : "/app/data/i18n/datatables/" + geocitizenDTO.currentLanguageCode + ".json"
            }
        };

        // Methods
        vm.gotoSurveyPreview = gotoSurveyPreview;
        vm.importSurvey = importSurvey;

        loadSurveys();

        //////////
        function loadSurveys(){

            vm.languages = {};
            _.each(geocitizenDTO.languages, function(lang){
                vm.languages[lang.code] = lang.name;
            });

            surveyNewService.getPublicSurveys(geocitizenDTO.user.id, geocitizenDTO.currentLanguage).then(function(result) {
                vm.surveys = result.data;
            });
        }

        /**
         * Go to product detail
         *
         * @param id
         */
        function gotoSurveyPreview(survey)
        {
            var data = survey;

            $mdDialog.show({
                controller         : 'SurveyPreviewDialogNewController',
                controllerAs       : 'vm',
                locals             : {
                    selectedSurvey: data
                },
                templateUrl        : 'app/main/survey-new/views/dialogs/survey-preview/survey-preview-dialog.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true
            });
        }

        //Import public survey
        function importSurvey(survey){
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title($translate.instant('SURVEY.IMPORT_SURVEY'))
                .textContent($translate.instant('SURVEY.IMPORT_SURVEY_CONFIRM'))
                .ariaLabel('Import survey')
                .ok($translate.instant('QUESTION.OK'))
                .cancel($translate.instant('QUESTION.CANCEL'));

            $mdDialog.show(confirm).then(function() {
                surveyNewService.importSurvey(survey.id, geocitizenDTO.selectedProject.id, geocitizenDTO.user.id).then(function(result){
                    $state.go('app.survey-new');
                });
            }, function() {
                
            }); 
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.survey_new')
        .controller('QuestionsNewController', QuestionsNewController);

    /** @ngInject */
    function QuestionsNewController($state, $mdDialog, $document, $translate, $scope, surveyNewService, surveyDTO, geocitizenDTO, notificationsDTO)
    {
        var vm = this;

        // Data
        vm.selectedSurvey = surveyDTO.selectedSurvey;
        vm.selectedProject = geocitizenDTO.selectedProject;
        vm.topBgClass = geocitizenDTO.style.topBgClass;
        vm.readOnly = false;

        vm.answerTypes = [  
                            { value: 'likert', name : $translate.instant('QUESTION.LIKERT_SCALE')},
                            { value: 'single_choice', name : $translate.instant('QUESTION.SINGLE_CHOICE')},
                            { value: 'multiple_choice', name : $translate.instant('QUESTION.MULTI_CHOICE')},
                            { value: 'input', name : $translate.instant('QUESTION.TEXT')},
                            { value: 'boolean', name : $translate.instant('QUESTION.YES_NO')},
                            { value: 'number', name : $translate.instant('QUESTION.NUMBER')}
                        ];

        vm.possibleSelectors = {
            boolean: [
                { value: "default", name: $translate.instant('QUESTION.DEFAULT') },
                { value: "is_empty", name: $translate.instant('QUESTION.IS_EMPTY') },
                { value: "has_value", name: $translate.instant('QUESTION.HAS_VALUE') },
                { value: "value_equals", name: $translate.instant('QUESTION.VALUE_EQUALS') }
            ], //boolean value equals 0 or 1 
            input: [
                { value: "default", name: $translate.instant('QUESTION.DEFAULT') },
                { value: "is_empty", name: $translate.instant('QUESTION.IS_EMPTY') },
                { value: "has_value", name: $translate.instant('QUESTION.HAS_VALUE') }, 
                { value: "text_length_greater", name: $translate.instant('QUESTION.TEXT_LENGTH_GREATER') }, 
                { value: "text_length_smaller", name: $translate.instant('QUESTION.TEXT_LENGTH_SMALLER') }
            ],
            number:[
                { value: "default", name: $translate.instant('QUESTION.DEFAULT') },
                { value: "is_empty", name: $translate.instant('QUESTION.IS_EMPTY') },
                { value: "has_value", name: $translate.instant('QUESTION.HAS_VALUE') },
                { value: "value_equals", name: $translate.instant('QUESTION.VALUE_EQUALS') },
                { value: "value_greater", name: $translate.instant('QUESTION.VALUE_GREATER') }, 
                { value: "value_greater_equal", name: $translate.instant('QUESTION.VALUE_GREATER_EQUAL') }, 
                { value: "value_smaller", name: $translate.instant('QUESTION.VALUE_SMALLER') }, 
                { value: "value_smaller_equal", name: $translate.instant('QUESTION.VALUE_SMALLER_EQUAL') }, 
                { value: "value_between", name: $translate.instant('QUESTION.VALUE_BETWEEN') }
            ],
            likert: [
                { value: "default", name: $translate.instant('QUESTION.DEFAULT') },
                { value: "is_empty", name: $translate.instant('QUESTION.IS_EMPTY') },
                { value: "has_value", name: $translate.instant('QUESTION.HAS_VALUE') },
                { value: "value_equals", name: $translate.instant('QUESTION.VALUE_EQUALS') },
                { value: "value_greater", name: $translate.instant('QUESTION.VALUE_GREATER') }, 
                { value: "value_greater_equal", name: $translate.instant('QUESTION.VALUE_GREATER_EQUAL') }, 
                { value: "value_smaller", name: $translate.instant('QUESTION.VALUE_SMALLER') }, 
                { value: "value_smaller_equal", name: $translate.instant('QUESTION.VALUE_SMALLER_EQUAL') }, 
                { value: "value_between", name: $translate.instant('QUESTION.VALUE_BETWEEN') }
            ],
            single_choice: [
                { value: "default", name: $translate.instant('QUESTION.DEFAULT') },
                { value: "is_empty", name: $translate.instant('QUESTION.IS_EMPTY') },
                { value: "has_value", name: $translate.instant('QUESTION.HAS_VALUE') }, 
                { value: "one_of_rel_choices", name: $translate.instant('QUESTION.ONE_OF_REL_CHOICES') }
            ],
            multiple_choice: [
                { value: "default", name: $translate.instant('QUESTION.DEFAULT') },
                { value: "is_empty", name: $translate.instant('QUESTION.IS_EMPTY') },
                { value: "has_value", name: $translate.instant('QUESTION.HAS_VALUE') },
                { value: "value_equals", name: $translate.instant('QUESTION.VALUE_EQUALS') },
                { value: "value_greater", name: $translate.instant('QUESTION.VALUE_GREATER') }, 
                { value: "value_greater_equal", name: $translate.instant('QUESTION.VALUE_GREATER_EQUAL') }, 
                { value: "value_smaller", name: $translate.instant('QUESTION.VALUE_SMALLER') }, 
                { value: "value_smaller_equal", name: $translate.instant('QUESTION.VALUE_SMALLER_EQUAL') }, 
                { value: "value_between", name: $translate.instant('QUESTION.VALUE_BETWEEN') }
            ]
            //if selector field is null, then this is the default option, that is applied if all other guards failed
        }

        vm.ERRORS={
            noQuestion: $translate.instant('QUESTION.ERRORS.NO_QUESTION'),
            noAnswerType: $translate.instant('QUESTION.ERRORS.NO_ANSWER_TYPE'),
            noOutgoingGuards: $translate.instant('QUESTION.ERRORS.NO_OUTGOING_GUARDS'),
            noIncomingGuards: $translate.instant('QUESTION.ERRORS.NO_INCOMING_GUARDS'),
            multiStart: $translate.instant('QUESTION.ERRORS.MULTI_START'),
            noParent: $translate.instant('QUESTION.ERRORS.NO_PARENT'),
            noVal1: $translate.instant('QUESTION.ERRORS.NO_VAL_1'),
            noVal2: $translate.instant('QUESTION.ERRORS.NO_VAL_2'),
            val2TooSmall: $translate.instant('QUESTION.ERRORS.VAL_2_TOO_SMALL'),
            multiDef: $translate.instant('QUESTION.ERRORS.MULTI_DEF'),
            multiEmpty: $translate.instant('QUESTION.ERRORS.MULTI_EMPTY'),
            multiFilled: $translate.instant('QUESTION.ERRORS.MULTI_FILLED'),
            noTotChoices: $translate.instant('QUESTION.ERRORS.NO_TOT_CHOICES'),
            noChoices: $translate.instant('QUESTION.ERRORS.NO_CHOICES_CONNECTOR'),
            parentNotSet: $translate.instant('QUESTION.ERRORS.PARENT_NOT_SET'),
            noSelector: $translate.instant('QUESTION.ERRORS.NO_SELECTOR')
        }
        //TODO
        vm.INFOS={
            null: $translate.instant('QUESTION.INFO.NULL'),
            is_empty: $translate.instant('QUESTION.INFO.IS_EMPTY'),
            has_value: $translate.instant('QUESTION.INFO.HAS_VALUE'),
            value_equals: $translate.instant('QUESTION.INFO.VALUE_EQUALS'),            
            text_length_greater: $translate.instant('QUESTION.INFO.TEXT_LENGTH_GREATER'), 
            text_length_smaller: $translate.instant('QUESTION.INFO.TEXT_LENGTH_SMALLER'), 
            value_greater: $translate.instant('QUESTION.INFO.VALUE_GREATER'), 
            value_greater_equal: $translate.instant('QUESTION.INFO.VALUE_GREATER_EQUAL'), 
            value_smaller: $translate.instant('QUESTION.INFO.VALUE_SMALLER'), 
            value_smaller_equal: $translate.instant('QUESTION.INFO.VALUE_SMALLER_EQUAL'), 
            value_between: $translate.instant('QUESTION.INFO.VALUE_BETWEEN'),
            one_of_rel_choices: $translate.instant('QUESTION.INFO.ONE_OF_REL_CHOICES')
        }
    
        vm.currentlyPossibleSelectors = [];
        vm.questionsRetrieved = [];
        vm.choicesRetrieved = [];
        vm.questions = [];
        vm.selectedItem = null;
        vm.hasErrors = false;

        vm.surveyStatus = { edit: $translate.instant('SURVEY.EDIT_MODE'),
                            started: $translate.instant('SURVEY.STARTED_MODE'),
                            ended: $translate.instant('SURVEY.ENDED_MODE')
                        };

        // Methods
        vm.goToSurveys = goToSurveys;
        vm.deleteQuestion = deleteQuestion;

        loadQuestions();

        //////////
        function loadQuestions(){

            switch (vm.selectedSurvey.status) {
                case "started": case "ended":
                    vm.readOnly = true;
                    break;
            }

            surveyNewService.getSurveyQuestions(surveyDTO.selectedSurvey.id).then(function(result) {
                var configs = result.data;   
                
                configs.forEach(function(config){
                    //vm.addQuestion()
                    var question = vm.addQuestion(config.survey_question.question);
                    question.attributes.survey_config = config;
                    config.element = question;
                });

                configs.forEach(function(config){

                    config.survey_configuration_guards.forEach(function(guard){
                        if(guard.next_survey_configuration_id){
                            var nextQ = _.find(configs, { id: guard.next_survey_configuration_id });

                            if(nextQ){
                                var newLink = createLink();
                                newLink.set({
                                    source: { id: config.element.id, port: 'out' },
                                    target: { id: nextQ.element.id, port: 'in'}
                                });

                                newLink.attributes.guard = guard;

                                if(newLink.attributes.guard.val_1){
                                    newLink.attributes.guard.val_1 = parseInt(guard.val_1);
                                }

                                if(newLink.attributes.guard.val_2){
                                    newLink.attributes.guard.val_2 = parseInt(guard.val_2);
                                }
                                
                                newLink.addTo(graph);
                            }
                        }else{
                            config.element.attributes.guard = guard;

                            if(config.element.attributes.guard.val_1){
                                config.element.attributes.guard.val_1 = parseInt(guard.val_1);
                            }

                            if(config.element.attributes.guard.val_2){
                                config.element.attributes.guard.val_2 = parseInt(guard.val_2);
                            }
                        }
                    });            
                });    
                
                vm.orderGraph();
            });
        }
        
        function deleteQuestion(question){
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title($translate.instant('QUESTION.DELETE_QUESTION'))
                .textContent($translate.instant('QUESTION.DELETE_CONFIRM'))
                .ariaLabel('Delete question')
                .ok($translate.instant('QUESTION.OK'))
                .cancel($translate.instant('QUESTION.CANCEL'));

            $mdDialog.show(confirm).then(function() {
                surveyNewService.deleteQuestion(question.survey_question.id, geocitizenDTO.user.id).then(function(result){
                    _.remove(vm.questions, { survey_question_id: question.survey_question.id });                    
                });
            }, function() {
                
            });            
        }

        function goToSurveys(){
            surveyDTO.selectedSurvey = null;
            $state.go('app.survey-new');
        }        
    
        /**************************************** Graph ****************************************************** */
    
        function createLink(){
            return new joint.dia.Link({
                attrs: { 
                    '.marker-target': { d: 'M 10 0 L 0 5 L 10 10 z' },
                    '.link-tools': {
                        display: 'none'
                    },
                    '.connection': { stroke: 'black', 'stroke-width': 1 }
                },
                labels: [
                    { position: 0.5, attrs: { text: { text: $translate.instant('QUESTION.CONNECTOR'), 'font-family': 'sans-serif' } }}
                ],
                guard: {
                    selector: null,
                    choices: []
                },
                elementType: "link"
            });
        }

        var divPaperContainer = document.getElementById('divPaperWrapper');
        var previousElement = null;
            
        var graph = new joint.dia.Graph;
        var paper = new joint.dia.Paper({ 
            el: document.getElementById('paper-parent-restriction'), 
            width: divPaperContainer.clientWidth - 5, 
            height: 9999999999, 
            gridSize: 1, 
            model: graph,
            defaultLink: createLink(),
            validateConnection: function(cellViewS, magnetS, cellViewT, magnetT, end, linkView) {
                // Prevent linking from input ports.
                if (magnetS && magnetS.getAttribute('port-group') === 'in') return false;
                // Prevent linking from output ports to input ports within one element.
                if (cellViewS === cellViewT) return false;
                // Prevent linking to input ports.
                return magnetT && magnetT.getAttribute('port-group') === 'in';
            },
            // Enable link snapping within 75px lookup radius
            snapLinks: { radius: 70 } 
        });
    
        paper.on('cell:pointerdown', function(cellView) {

            var element = previousElement ? paper.findViewByModel(previousElement) : null;
            if(element) element.unhighlight();

            cellView.highlight();
        });

        paper.on('blank:pointerclick', function(cellView) {

            var element = vm.selectedItem ? paper.findViewByModel(vm.selectedItem) : null;
            if(element) element.unhighlight();

            vm.selectedItem = null;

            $scope.$apply();
        });
            
        graph.on('batch:start', function(eventName, cell) {
            //console.log(eventName, arguments);
            
            if(eventName.batchName == "pointer"){
                //console.log("cell", eventName.cell);
                
                //if(eventName.cell.attributes.type == "devs.Model"){
                    selectItem(eventName.cell);
                //}
            }
        });
    
        graph.on('batch:stop', function(eventName, cell) {
            //console.log('event', eventName);
            
            if(eventName.batchName == "pointer"){
                //console.log("cell", eventName.cell);
                
                if(eventName.cell.attributes.type == "link"){
                    if(eventName.cell.attributes.target.port != 'in' || eventName.cell.attributes.source.port != 'out'){
                        eventName.cell.remove();

                    }else{
                        var wasRemoved = false;
                        _.each(graph.getLinks(), function(link) {
                            if(eventName.cell.attributes.source.id == link.attributes.source.id && eventName.cell.attributes.target.id == link.attributes.target.id
                                && eventName.cell.id != link.id){
                                eventName.cell.remove();
                                wasRemoved = true;
                            }
                        });
                        
                        if(!wasRemoved){
                            var sourceElement = eventName.cell.getSourceElement();
                            if(sourceElement && !eventName.cell.attributes.guard.selector){
                                eventName.cell.attributes.guard = sourceElement.attributes.guard;
                                sourceElement.attributes.guard = { selector: null, choices: [] };

                                vm.checkValidity();
                            }

                            vm.selectedItem = eventName.cell;

                            $scope.$apply();
                        }
                    }
                }
            }
        });
        
        vm.createModel = function(type, position, size, label){
    
            var inPorts = ['in'];
            var outPorts = ['out'];
            var color = "#A9E2F3";
                
            var model = new joint.shapes.devs.Model({
                position: position,
                size: size,
                inPorts: inPorts,
                outPorts: outPorts,
                ports: {
                    groups: {
                        'in': {
                            attrs: {
                                '.port-body': {
                                    fill: '#16A085',
                                    magnet: 'passive'
                                },
                                '.port-label': {
                                    display: 'none'
                                }
                            },
                            'position': 'top'                    
                        },
                        'out': {
                            attrs: {
                                '.port-body': {
                                    fill: '#FA8258'
                                },
                                '.port-label': {
                                    display: 'none'
                                }
                            },
                            'position': 'bottom'
                        }
                    }
                },
                attrs: {
                    '.label': { 
                        textWrap: {
                            text: label,
                            width: -10 // reference width minus 10
                            
                        }    
                    },
                    rect: { 
                            fill: color, 
                            stroke: 'gray',
                            'stroke-width': 1
                        }
                },
                elementType: type,
                survey_config: {
                    survey_question: {
                        question: label
                    }                
                },
                guard: {
                    selector: null,
                    choices: []
                }
            });
    
            return model;
        }
            
        vm.updateQuestion = function(){        
            vm.selectedItem.attr('.label/textWrap/text', vm.selectedItem.attributes.survey_config.survey_question.question);                        
        }
    
        function selectItem(element){
    
            previousElement = vm.selectedItem;
            vm.selectedItem = element;
            vm.canBeLastQuestion = false;

            //get possible selector values
            if(vm.selectedItem.attributes.type == "link"){
                setPossibleSelectors(element);                       
            }else{
                var questionLinks = graph.getConnectedLinks(element, { outbound: true });
                if(questionLinks.length == 0){
                    vm.canBeLastQuestion = true;
                }
            }

            if(vm.canBeLastQuestion){
                setPossibleSelectors(element);
            }

            vm.checkValidity();

            $scope.$apply();     
        }

        function setPossibleSelectors(element){
            vm.currentlyPossibleSelectors = [];
            vm.parentConfigNode = element.attributes.elementType == "question" ? element : element.getSourceElement();
            if(vm.parentConfigNode && vm.parentConfigNode.attributes.survey_config.survey_question 
                && vm.parentConfigNode.attributes.survey_config.survey_question.answer_type){

                vm.currentlyPossibleSelectors = vm.possibleSelectors[vm.parentConfigNode.attributes.survey_config.survey_question.answer_type];
            }
        }
    
        vm.addQuestion = function(label){
                
            var size = { width: 120, height: 100 };
    
            var posX = 50;
            var posY = 50;

            _.each(graph.getElements(), function(element) {
                if(element.attributes.position.x == posX && element.attributes.position.y == posY){
                    posX += 20;
                    posY += 20;
                }
            });

            var question = vm.createModel('question', { x: posX, y : posY }, size, label);
    
            graph.addCells([question]);
    
            return question;
        }

        vm.deleteItem = function(){

            var deleteData = { guards: [] };

            if(vm.selectedItem.attributes.elementType == "question"){

                if(vm.selectedItem.attributes.survey_config.id){
                    deleteData.survey_config = { 
                                                id: vm.selectedItem.attributes.survey_config.id,
                                                survey_question_id: vm.selectedItem.attributes.survey_config.survey_question_id,
                                            }
                }                
                
                var connectedLinks = graph.getConnectedLinks(vm.selectedItem);

                connectedLinks.forEach(function(link){

                    if(link.attributes.guard.id){
                        deleteData.guards.push(link.attributes.guard);
                    }
                });

            }else if(vm.selectedItem.attributes.guard.id){
                deleteData.guards.push(vm.selectedItem.attributes.guard);
            }
            

            surveyNewService.deleteElement(deleteData).then(function(result) {
                    
                vm.selectedItem.remove();
                vm.selectedItem = null;
            });            
        }

        vm.addChoice = function(){
            //check if the choice already exist
            if(!_.some(vm.selectedItem.attributes.guard.choices, { choice : vm.newChoice })){
                vm.selectedItem.attributes.guard.choices.push({ choice : vm.newChoice });
                vm.newChoice = null;
            }

            vm.checkValidity();
        }

        vm.deleteChoice = function(choice){
            _.remove(vm.selectedItem.attributes.guard.choices, { choice: choice.choice });

            vm.checkValidity();
        }
        
        vm.orderGraph = function(){
    
            joint.layout.DirectedGraph.layout(graph, {
                setLinkVertices: false,
                rankDir: 'TB',
                marginX: 20,
                marginY: 20,
                clusterPadding: { top: 30, left: 20, right: 20, bottom: 20 }
            });
        }

        vm.answerTypeChange = function(){
            setPossibleSelectors(vm.selectedItem);

            vm.checkValidity();
        }

        vm.checkValidity = function(){


            var hasStartingConfig = false;
            var hasErrors = false;
            //configs
            _.each(graph.getElements(), function(element) {
                //console.log("checkConfigValidity",d)
    
                element.attributes.errors=[];
                if(!element.attributes.survey_config.survey_question || 
                    !element.attributes.survey_config.survey_question.question || 
                    element.attributes.survey_config.survey_question.question.trim()=="" ){

                    element.attributes.errors.push(vm.ERRORS["noQuestion"]);
                }

                if(!element.attributes.survey_config.survey_question || 
                    element.attributes.survey_config.survey_question && !element.attributes.survey_config.survey_question.answer_type ){

                    element.attributes.errors.push(vm.ERRORS["noAnswerType"]);
                }
                
                //check if survey has outgoing guards
                var outgoingGuards = graph.getConnectedLinks(element, { outbound: true });
                if(outgoingGuards.length == 0){
                    if(!element.attributes.guard.selector){
                        element.attributes.errors.push(vm.ERRORS["noSelector"]);
                    }          
                    
                    if((element.attributes.survey_config.survey_question.answer_type == "single_choice" || element.attributes.survey_config.survey_question.answer_type == "multiple_choice")
                        && element.attributes.guard.choices.length == 0){

                        element.attributes.errors.push(vm.ERRORS["noChoices"]);
                    }
                }
    
                //check that there are not unconnected parts that cannot be reached
                var incomingGuards = graph.getConnectedLinks(element, { inbound: true });
                if(incomingGuards.length == 0){
    
                     //check that there are not multiple starting configs
                    if(hasStartingConfig){
                        element.attributes.errors.push(vm.ERRORS["noIncomingGuards"]);
                        element.attributes.errors.push(vm.ERRORS["multiStart"]);
                    }
    
                    hasStartingConfig = true;
                }
    
                
    
                if(element.attributes.errors.length > 0){
                    element.attr('rect/stroke', 'red').attr('rect/stroke-width', 2);
                    hasErrors = true;
                }else{
                    element.attr('rect/stroke', 'gray').attr('rect/stroke-width', 1);
                }
            })
    
            //guards
    
            _.each(graph.getLinks(), function(link) {
                //console.log("checkGuardValidity", link);
    
                link.attributes.guard.errors=[];
    
                //check id selector and values are fitting
                var parentConfigNode = link.getSourceElement();
                if(!parentConfigNode){
                    link.attributes.guard.errors.push(vm.ERRORS["noParent"]);
                
                } else if(parentConfigNode.attributes.survey_config.survey_question  && parentConfigNode.attributes.survey_config.survey_question.answer_type){
                   
                    if(!link.attributes.guard.selector){
                        link.attributes.guard.errors.push(vm.ERRORS["noSelector"]);
                    }
                    //check if val 1 and val 2 are filled when necessary
                    if((link.attributes.guard.selector == 'value_equals' 
                        || link.attributes.guard.selector == 'text_length_greater'
                        || link.attributes.guard.selector == 'text_length_smaller'
                        || link.attributes.guard.selector == 'value_greater'
                        || link.attributes.guard.selector == 'value_greater_equal'
                        || link.attributes.guard.selector == 'value_smaller'
                        || link.attributes.guard.selector == 'value_smaller_equal'
                        || link.attributes.guard.selector == 'value_between') 
                        && (!link.attributes.guard.val_1)
                    ){
                        if(link.attributes.guard.val_1 !== 0)
                            link.attributes.guard.errors.push(vm.ERRORS["noVal1"])
                    }
                    if(link.attributes.guard.selector == 'value_between' && !link.attributes.guard.val_2  ){
                        if(link.attributes.guard.val_2 !== 0 )
                            link.attributes.guard.errors.push(vm.ERRORS["noVal2"])
                        
                    }
                    if(link.attributes.guard.selector == 'value_between' && link.attributes.guard.val_1 >= link.attributes.guard.val_2)
                            link.attributes.guard.errors.push(vm.ERRORS["val2TooSmall"])
                
    
    
                    //check sibling guards
                    //check if more than one guards with default selector (null)
                    var siblingGuardNodes = graph.getConnectedLinks(parentConfigNode, { outbound: true });
                    var defaultGuards = 0, isEmptyGuards = 0, hasValueGuards = 0;
                    var totalChoices = [];
                    siblingGuardNodes.forEach(function(siblingGuardNode) {
                        if(siblingGuardNode.attributes.guard.selector == 'default'){
                            defaultGuards++;
                        }else if(siblingGuardNode.attributes.guard.selector == 'is_empty'){
                            isEmptyGuards++;
                        }
                        else if(siblingGuardNode.attributes.guard.selector == 'has_value'){
                            hasValueGuards++;
                        }
    
                        if(siblingGuardNode.attributes.guard.choices)
                            totalChoices = totalChoices.concat(siblingGuardNode.attributes.guard.choices); 
                    });
    
                    if(defaultGuards > 1 && link.attributes.guard.selector == 'default')
                        link.attributes.guard.errors.push(vm.ERRORS["multiDef"]);

                    if(isEmptyGuards > 1 && link.attributes.guard.selector == 'is_empty')
                        link.attributes.guard.errors.push(vm.ERRORS["multiEmpty"]);

                    if(hasValueGuards > 1 && link.attributes.guard.selector == 'has_value')
                        link.attributes.guard.errors.push(vm.ERRORS["multiFilled"])
                    
    
                    //check choices
                    //console.log("totalChoices",totalChoices)
                    if(parentConfigNode.attributes.survey_config.survey_question.answer_type == 'single_choice' || 
                        parentConfigNode.attributes.survey_config.survey_question.answer_type == 'multiple_choice'){

                        if(totalChoices.length == 0){
                            link.attributes.guard.errors.push(vm.ERRORS["noTotChoices"]);

                        }else if ((!link.attributes.guard.choices || link.attributes.guard.choices.length==0) && (link.attributes.guard.selector != 'is_empty' && link.attributes.guard.selector)){
                            link.attributes.guard.errors.push(vm.ERRORS["noChoices"])
                        }
                    }
                 }else{
                    link.attributes.guard.errors.push(vm.ERRORS["parentNotSet"])
                 }
    
                
                if(link.attributes.guard.errors.length > 0) {
                    link.attr('.connection/stroke', 'red').attr('.connection/stroke-width', 2).attr('.marker-target/fill', "red").attr('.marker-target/stroke', "red");
                    hasErrors = true;
                }else{
                    link.attr('.connection/stroke', 'black').attr('.connection/stroke-width', 1).attr('.marker-target/fill', "black").attr('.marker-target/stroke', "black");
                }
            });

            vm.hasErrors = hasErrors;
        }

        vm.saveQuestions = function(){

            var rootNode = null;
            var allQuestions = graph.getElements();
            var questionsSaved = 0;

            //Get the root config
            allQuestions.forEach(function(element) {
            
                /*let incomingGuards = graph.getConnectedLinks(element, { inbound: true });
                if(incomingGuards.length == 0){
                    rootNode = element;
                }*/                

                surveyNewService.saveQuestion(element.attributes.survey_config.survey_question).then(function(question) {
                    
                    element.attributes.survey_config.survey_question = question.data;
                    element.attributes.survey_config.survey_question_id = question.data.id;

                    surveyNewService.saveQuestionConfig({id: element.attributes.survey_config.id, survey_id: vm.selectedSurvey.id, survey_question_id: question.data.id}).then(function(config) {
                    
                        questionsSaved++;
                        element.attributes.survey_config.id = config.data.id;
    
                        if(allQuestions.length == questionsSaved){
                            saveGuards();
                        }
                    });
                });
            });
        }

        function saveGuards(){

            var allLinks = graph.getLinks();
            var guardsSaved = 0;

            _.each(allLinks, function(link) {
    
                //get source and target elements
                var sourceConfigNode = link.getSourceElement();
                var targetConfigNode = link.getTargetElement();

                var guard = link.attributes.guard;
                guard.survey_configuration_id = sourceConfigNode.attributes.survey_config.id;
                guard.next_survey_configuration_id = targetConfigNode.attributes.survey_config.id;

                surveyNewService.saveGuards(guard).then(function(guardResult) {
                    
                    guardsSaved++;
                    link.attributes.guard = guardResult.data.data;
/*
                    if(allLinks.length == guardsSaved){
                        //finish
                    }*/
                    notificationsDTO.showSimpleToast($translate.instant('SHARED.INFO_SAVED'));
                });
            });

            var allQuestions = graph.getElements();

            allQuestions.forEach(function(question){
                if(question.attributes.guard.selector){

                    var guard = question.attributes.guard;
                    guard.survey_configuration_id = question.attributes.survey_config.id;
                    guard.next_survey_configuration_id = null;

                    surveyNewService.saveGuards(guard).then(function(guardResult) {
                        
                        guardsSaved++;
                        question.attributes.guard = guardResult.data.data;
                    });
                }
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.survey_new')
        .controller('AssignSurveysNewController', AssignSurveysNewController);

    /** @ngInject */
    function AssignSurveysNewController($state, $mdDialog, $document, $translate, surveyNewService, surveyDTO, geocitizenDTO, notificationsDTO)
    {
        var vm = this;

        // Data
        vm.selectedProject = geocitizenDTO.selectedProject;
        vm.topBgClass = geocitizenDTO.style.topBgClass;
        vm.selectedSurvey = surveyDTO.selectedSurvey;
        vm.farmers = [];

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"pagination"p>>>',
            initComplete: function ()
            {
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            paging      : false,
            scrollY     : 'auto',
            responsive  : true,
            language    : {
                url : "/app/data/i18n/datatables/" + geocitizenDTO.currentLanguageCode + ".json"
            }
        };

        // Methods
        
        loadRounds();

        //////////
        function loadRounds(){

            vm.loadingRounds = true;

            surveyNewService.getSurveyRounds(vm.selectedSurvey.id, vm.selectedProject.id).then(function(result) {
                vm.rounds = result.data;
                vm.loadingRounds = false;

                vm.selectedRound = _.maxBy(vm.rounds, 'id');

                if(vm.rounds.length > 0){
                    loadFarmers();
                }
            });
        }

        function loadFarmers(){
            surveyNewService.getRoundFarmers(vm.selectedRound.id, vm.selectedProject.id).then(function(result) {
                vm.roundPending = result.data.round;
                vm.farmers = result.data.farmers;

                _.each(vm.farmers, function(farmer){

                    farmer.pending = _.find(vm.roundPending.survey_pendings, { farmer_id: farmer.id });

                    if(farmer.pending){

                        if(!farmer.pending.finished){
                            farmer.pending_round = true;
                        }
                    }else{
                        farmer.pending = {};
                    }
                });

                vm.countSelected();
            });
        }

        vm.toggleAll = function(){
            
            _.each(vm.farmers, function(farmer){
                if(!farmer.pending.finished)
                    farmer.pending_round = vm.checkboxAll;
            });     
            
            vm.countSelected();
        }

        vm.savePendings = function(){
            var data = { roundId: vm.selectedRound.id, pendings: []};

            _.each(vm.farmers, function(farmer){
                if(!farmer.pending.finished){
                    data.pendings.push({ farmerId: farmer.id, pending: farmer.pending_round });
                }                
            }); 

            surveyNewService.assignFarmers(data, vm.selectedProject.id).then(function(result) {

                notificationsDTO.showSimpleToast($translate.instant('SHARED.INFO_SAVED'));
            });
        }

        vm.goBack = function(){
            history.back();
        }

        vm.countSelected = function(){
            var farmers = _.filter(vm.farmers, { pending_round: true });
            vm.selectedFarmersCount = farmers ? farmers.length : 0;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.survey')
        .controller('QuestionsController', QuestionsController);

    /** @ngInject */
    function QuestionsController($state, $mdDialog, $document, $translate, surveyService, surveyDTO, geocitizenDTO)
    {
        var vm = this;

        // Data
        vm.selectedSurvey = surveyDTO.selectedSurvey;
        vm.selectedProject = geocitizenDTO.selectedProject;
        vm.topBgClass = geocitizenDTO.style.topBgClass;
        vm.readOnly = false;

        vm.answerTypes = {  likert: $translate.instant('QUESTION.LIKERT_SCALE'),
                            single_choice: $translate.instant('QUESTION.SINGLE_CHOICE'),
                            multiple_choice: $translate.instant('QUESTION.MULTI_CHOICE'),
                            input: $translate.instant('QUESTION.TEXT'),
                            boolean: $translate.instant('QUESTION.YES_NO'),
                            number: $translate.instant('QUESTION.NUMBER'),
                            headline: $translate.instant('QUESTION.HEADLINE')
                         };

        vm.surveyStatus = { edit: $translate.instant('SURVEY.EDIT_MODE'),
                            started: $translate.instant('SURVEY.STARTED_MODE'),
                            ended: $translate.instant('SURVEY.ENDED_MODE')
                        };

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs  : [
                {
                    // Target the id column
                    targets: 0,
                    width  : '50px'
                }
            ],
            initComplete: function ()
            {
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 10,
            scrollY     : 'auto',
            responsive  : true,
            language    : {
                url : "/app/data/i18n/datatables/" + geocitizenDTO.currentLanguageCode + ".json"
            }
        };

        // Methods
        surveyDTO.reloadQuestions = loadQuestions;
        vm.gotoQuestionDetail = gotoQuestionDetail;
        vm.goToSurveys = goToSurveys;
        vm.deleteQuestion = deleteQuestion;

        loadQuestions();

        //////////
        function loadQuestions(){

            switch (vm.selectedSurvey.status) {
                case "started": case "ended":
                    vm.readOnly = true;
                    break;
            }

            surveyService.getSurveyQuestions(surveyDTO.selectedSurvey.id).then(function(result) {
                vm.questions = result.data;                
            });
        }
        
        /**
         * Go to question detail
         *
         * @param id
         */
        function gotoQuestionDetail(question)
        {
            var data = question ? question : undefined;
            var qOrder = 1;
            if(vm.questions.length > 0){
                var lastQuestion = _.maxBy(vm.questions, 'question_order');

                qOrder = lastQuestion ? lastQuestion.question_order + 1 : null;
            }
            
            $mdDialog.show({
                controller         : 'QuestionDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedSurveyConfiguration: data,
                    questionOrder   : qOrder
                },
                templateUrl        : 'app/main/survey/views/dialogs/question/question-dialog.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false
            });
        }

        function deleteQuestion(question){
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title($translate.instant('QUESTION.DELETE_QUESTION'))
                .textContent($translate.instant('QUESTION.DELETE_CONFIRM'))
                .ariaLabel('Delete question')
                .ok($translate.instant('QUESTION.OK'))
                .cancel($translate.instant('QUESTION.CANCEL'));

            $mdDialog.show(confirm).then(function() {
                surveyService.deleteQuestion(question.survey_question.id, geocitizenDTO.user.id).then(function(result){
                    _.remove(vm.questions, { survey_question_id: question.survey_question.id });                    
                });
            }, function() {
                
            });            
        }

        function goToSurveys(){
            surveyDTO.selectedSurvey = null;
            $state.go('app.survey');
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.survey')
        .controller('OtherSurveysController', OtherSurveysController);

    /** @ngInject */
    function OtherSurveysController($state, $mdDialog, $document, $translate, surveyService, surveyDTO, geocitizenDTO)
    {
        var vm = this;

        // Data
        vm.selectedProject = geocitizenDTO.selectedProject;
        vm.topBgClass = geocitizenDTO.style.topBgClass;

        vm.surveyStatus = { edit: $translate.instant('SURVEY.EDIT_MODE'),
                            started: $translate.instant('SURVEY.STARTED_MODE'),
                            ended: $translate.instant('SURVEY.ENDED_MODE')
                        };

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function ()
            {
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 10,
            scrollY     : 'auto',
            responsive  : true,
            language    : {
                url : "/app/data/i18n/datatables/" + geocitizenDTO.currentLanguageCode + ".json"
            }
        };

        // Methods
        vm.gotoSurveyPreview = gotoSurveyPreview;
        vm.importSurvey = importSurvey;

        loadSurveys();

        //////////
        function loadSurveys(){

            vm.languages = {};
            _.each(geocitizenDTO.languages, function(lang){
                vm.languages[lang.code] = lang.name;
            });

            surveyService.getPublicSurveys(geocitizenDTO.user.id, geocitizenDTO.currentLanguage).then(function(result) {
                vm.surveys = result.data;
            });
        }

        /**
         * Go to product detail
         *
         * @param id
         */
        function gotoSurveyPreview(survey)
        {
            var data = survey;

            $mdDialog.show({
                controller         : 'SurveyPreviewDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedSurvey: data
                },
                templateUrl        : 'app/main/survey/views/dialogs/survey-preview/survey-preview-dialog.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true
            });
        }

        //Import public survey
        function importSurvey(survey){
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title($translate.instant('SURVEY.IMPORT_SURVEY'))
                .textContent($translate.instant('SURVEY.IMPORT_SURVEY_CONFIRM'))
                .ariaLabel('Import survey')
                .ok($translate.instant('QUESTION.OK'))
                .cancel($translate.instant('QUESTION.CANCEL'));

            $mdDialog.show(confirm).then(function() {
                surveyService.importSurvey(survey.id, geocitizenDTO.selectedProject.id, geocitizenDTO.user.id).then(function(result){
                    $state.go('app.survey');
                });
            }, function() {
                
            }); 
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.reports')
        .controller('PublicReportsController', PublicReportsController);

    /** @ngInject */
    function PublicReportsController($mdDialog, $document, $sce, $templateRequest, $compile, $timeout, geocitizenDTO, api, reportsService)
    {
        var vm = this;

        // Data
        vm.selectedProject = geocitizenDTO.selectedProject;
        vm.topBgClass = geocitizenDTO.style.topBgClass;
        vm.api = api;
        vm.index = 0;

        loadProjects();

        //////////
        function loadProjects(){
            reportsService.getProjectsWithPublicReports(geocitizenDTO.selectedProject.id).then(function(result) {
                vm.projects = result.data;
            });
        }

        vm.loadReports = function(){

            reportsService.getPublicReportsByRegion(vm.selectedProject.id).then(function(result) {
                vm.reports = result.data;

                vm.showIframe = false;
                vm.selectedReport = null;
                vm.selectedYear = null;
                vm.years = [];
                vm.yearReports = [];

                var allYears = [];

                vm.reports.forEach(function(report) {
                    allYears.push({ year: report.year });
                });

                allYears = _.uniqBy(allYears, 'year');
                vm.years = _.orderBy(allYears, ['year'], ['asc']);
            });
        }

        // Methods

        vm.changeSelectedYear = function(){
            var reports = _.filter(vm.reports, { year: vm.selectedYear.year });
            vm.yearReports = _.orderBy(reports, ['created_at'], ['desc']);
            vm.showIframe = false;
            vm.selectedReport = null;
            //select the first report
            vm.selectedReport = vm.yearReports[0];
            vm.index = 0;
            vm.changeSelectedReport();
        }

        vm.iframeLoaded = function(){
            vm.loadingReport = false;
        };

        vm.changeSelectedReport = function(){

            vm.loadingReport = true;

            var parentDiv = document.getElementById('reports');
            var iframeContainer = document.getElementById('iframe-container');
            iframeContainer.style.height = (parentDiv.clientHeight - 250) + 'px';

            vm.showIframe = false;
            vm.selectedReport.safeUrl = $sce.trustAsResourceUrl(vm.selectedReport.url);

            $templateRequest(vm.selectedReport.safeUrl).then(function(template) {
                // template is the HTML template as a string

                vm.showIframe = true;
                
                $timeout(function(){
                    var blob = new Blob([template], {type: "text/html"});
                    var blob_url = URL.createObjectURL(blob);
                    var blob_iframe = document.querySelector('#blob-src-test');

                    blob_iframe.src = blob_url;
                }, 200);
            }, function() {
                // An error has occurred here
            });
        }

        vm.moveToReport = function(direction){
            if(vm.selectedReport){

                vm.index = _.findIndex(vm.yearReports, { 'id': vm.selectedReport.id });

                //forward movement
                if(direction > 0){
                    if(vm.index < (vm.yearReports.length - 1)){
                        vm.index++;
                        vm.selectedReport = vm.yearReports[vm.index];
                        vm.changeSelectedReport();
                    }
                }else{//previous report
                    if(vm.index > 0){
                        vm.index--;
                        vm.selectedReport = vm.yearReports[vm.index];
                        vm.changeSelectedReport();
                    }
                }
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.results', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.results', {
                url    : '/data-results',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/results/views/results.html',
                        controller : 'ResultsController as vm'
                    }
                },
                authenticate: true
            })
            .state('app.public-results', {
                url    : '/public-results/:surveyHash',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/results/views/results.html',
                        controller : 'ResultsController as vm'
                    }
                },
                authenticate: false
            })
            .state('app.print-results', {
                url    : '/print-results/:surveyHash',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/results/views/print-results/print-results.html',
                        controller : 'PrintResultsController as vm'
                    }
                },
                authenticate: false,
                printClass: 'overflow-scroll'
            });

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.results')
        .controller('ShareLinkController', ShareLinkController);

    /** @ngInject */
    function ShareLinkController(currentLink)
    {
        var vm = this;

        // Data
        vm.link = currentLink;
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.results')
        .controller('PrintResultsController', PrintResultsController);

    /** @ngInject */
    function PrintResultsController($state, $mdDialog, $document, $translate, $timeout, $stateParams, $location, $window,
                                questionService, surveyDTO, geocitizenDTO, surveyService, msNavigationService)
    {
        var vm = this;

        // Data
        vm.surveyHash = $stateParams.surveyHash;
        vm.questions = [];

        // Delete the 'apps' item
        msNavigationService.deleteItem('survey');
        msNavigationService.deleteItem('questions');
        msNavigationService.deleteItem('results');
        geocitizenDTO.privateOptions.showOptions = false;

        vm.selectedProject = geocitizenDTO.selectedProject;

        vm.answerTypes = {  likert: $translate.instant('QUESTION.LIKERT_SCALE'),
                            single_choice: $translate.instant('QUESTION.SINGLE_CHOICE'),
                            multiple_choice: $translate.instant('QUESTION.MULTI_CHOICE'),
                            input: $translate.instant('QUESTION.TEXT'),
                            boolean: $translate.instant('QUESTION.YES_NO'),
                            number: $translate.instant('QUESTION.NUMBER'),
                            headline: $translate.instant('QUESTION.HEADLINE')
                         };

        vm.surveyStatus = { edit: $translate.instant('SURVEY.EDIT_MODE'),
                            started: $translate.instant('SURVEY.STARTED_MODE'),
                            ended: $translate.instant('SURVEY.ENDED_MODE')
                        };

        var chartAnswersLabel = $translate.instant('RESULTS.ANSWERS');

        // Methods

        loadSurveys();
        
        //////////
        function loadSurveys(){

            $timeout(function() {

                var html = angular.element( document.querySelector( 'html' ) );
                html.css('overflow','scroll !important');

                var body = angular.element( document.querySelector( 'body' ) );
                body.css('overflow','scroll !important');

            }, 2000);

            vm.languages = {};
            _.each(geocitizenDTO.languages, function(lang){
                vm.languages[lang.code] = lang.name;
            });

            if(geocitizenDTO.privateOptions.reloadPublicResults){
                geocitizenDTO.privateOptions.reloadPublicResults = false;
                $timeout(function() { 
                    $state.go($state.current.name, null, {reload: $state.current.name});
                }, 1000);
                
            }else{
                surveyService.getSurveyByHash(vm.surveyHash).then(function(result) {
                    vm.selectedProject = result.data.subgeo;
                    geocitizenDTO.selectedProject.id = vm.selectedProject.id;
                    geocitizenDTO.selectedProject.name = vm.selectedProject.name;
                    vm.region = result.data.subgeo;
                    showSurveyResults(result.data);
                });
            }            
        }

        vm.showSurveyResults = showSurveyResults;
        function showSurveyResults(survey){
            vm.selectedSurvey = survey;
            vm.selectedSurvey.survey_configurations = _.orderBy(vm.selectedSurvey.survey_configurations, ['question_order'], ['asc']);
            _.each(vm.selectedSurvey.survey_configurations, function(surveyConf){
                vm.questions.push(surveyConf.survey_question);
            });
            
            drawChart();   
        }

        function drawChart(){

            $timeout(function() {

                _.each(vm.questions, function(question){
                    var showChartFlag = false;
                    question.datapoints = [];
                    question.axisXNames = [];
                    question.datacolumns = [{"id": chartAnswersLabel,"type":"bar"}];
                    question.datax = {"id":"x"};
                    question.axisY =  function (d) {
                                    return (parseInt(d) == d) ? d : null;
                                };
                                
                    question.currentAnswers = _.filter(vm.selectedSurvey.survey_answers, { survey_question_id: question.id });
                    question.groupedAnswers = _.countBy(question.currentAnswers, 'answer_text');

                    question.totalParticipants = 0;
                    var participants = _.countBy(question.currentAnswers, 'user_id');
                    for (var key in participants) {
                        if (participants.hasOwnProperty(key)) {
                            question.totalParticipants++;
                        }
                    }

                    question.min = 5;
                    question.max = 1;
                    var total = 0;
                    var answersCount = question.currentAnswers.length == 0 ? 1 : question.currentAnswers.length;
                    
                    switch (question.answer_type) {
                        case "likert":
                            question.datapoints = [{"x":1, "answerValue": "1"},  
                                            {"x":2,  "answerValue": "2"},
                                            {"x":3,  "answerValue": "3"},
                                            {"x":4,  "answerValue": "4"},
                                            {"x":5,  "answerValue": "5"}];

                            _.each(question.datapoints, function(item){
                                item[chartAnswersLabel] = 0;
                            });

                            for (var key in question.groupedAnswers) {
                                if (question.groupedAnswers.hasOwnProperty(key)) {
                                    question.datapoints[key - 1][chartAnswersLabel] = question.groupedAnswers[key];
                                    total += (key * question.groupedAnswers[key]);
                                    question.min = question.min > key ? key : question.min;
                                    question.max = question.max < key ? key : question.max;
                                }
                            }
                            question.average = total / answersCount;
                            showChartFlag = true;
                            question.showAxisXNames = true;
                            break;
                        case "boolean": case "single_choice": case "multiple_choice": case "number":
                            for (var key in question.groupedAnswers) {
                                if (question.groupedAnswers.hasOwnProperty(key)) {
                                    var point = {"x": key, "answerValue": key};
                                    point[chartAnswersLabel] = question.groupedAnswers[key];
                                    question.datapoints.push(point);
                                    question.axisXNames.push(key);
                                }
                            }
                            question.changeAxisXNames = true;
                            question.showAxisXNames = false;
                            showChartFlag = true;
                            break;
                    }

                    question.showChart = showChartFlag;
                });

            }, 400);            
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsController', ReportsController);

    /** @ngInject */
    function ReportsController($mdDialog, $document, $sce, $templateRequest, $compile, $timeout, geocitizenDTO, api, reportsService)
    {
        var vm = this;

        // Data
        vm.selectedProject = geocitizenDTO.selectedProject;
        vm.topBgClass = geocitizenDTO.style.topBgClass;
        vm.api = api;
        vm.index = 0;

        loadReports();

        //////////
        function loadReports(selectedYearChange){

            vm.selectedProject = geocitizenDTO.selectedProject;
            
            reportsService.getReportsByRegion(geocitizenDTO.selectedProject.id).then(function(result) {
                vm.reports = result.data;

                vm.showIframe = false;
                vm.selectedReport = null;
                vm.selectedYear = null;
                vm.years = [];
                vm.yearReports = [];

                var allYears = [];

                vm.reports.forEach(function(report) {
                    allYears.push({ year: report.year });
                });

                allYears = _.uniqBy(allYears, 'year');
                vm.years = _.orderBy(allYears, ['year'], ['asc']);

                if(selectedYearChange){
                    //vm.changeSelectedYear();
                }
            });
        }

        // Methods

        vm.changeSelectedYear = function(){
            var reports = _.filter(vm.reports, { year: vm.selectedYear.year });
            vm.yearReports = _.orderBy(reports, ['created_at'], ['desc']);
            vm.showIframe = false;
            vm.selectedReport = null;
            //select the first report
            vm.selectedReport = vm.yearReports[0];
            vm.index = 0;
            vm.changeSelectedReport();
        }

        vm.iframeLoaded = function(){
            vm.loadingReport = false;
        };

        vm.changeSelectedReport = function(){

            vm.loadingReport = true;

            var parentDiv = document.getElementById('reports');
            var iframeContainer = document.getElementById('iframe-container');
            iframeContainer.style.height = (parentDiv.clientHeight - 200) + 'px';

            vm.showIframe = false;
            vm.selectedReport.safeUrl = $sce.trustAsResourceUrl(vm.selectedReport.url);

            $templateRequest(vm.selectedReport.safeUrl).then(function(template) {
                // template is the HTML template as a string

                vm.showIframe = true;
                
                $timeout(function(){
                    var blob = new Blob([template], {type: "text/html"});
                    var blob_url = URL.createObjectURL(blob);
                    var blob_iframe = document.querySelector('#blob-src-test');

                    blob_iframe.src = blob_url;
                }, 200);
            }, function() {
                // An error has occurred here
            });
        }

        vm.moveToReport = function(direction){
            if(vm.selectedReport){

                vm.index = _.findIndex(vm.yearReports, { 'id': vm.selectedReport.id });

                //forward movement
                if(direction > 0){
                    if(vm.index < (vm.yearReports.length - 1)){
                        vm.index++;
                        vm.selectedReport = vm.yearReports[vm.index];
                        vm.changeSelectedReport();
                    }
                }else{//previous report
                    if(vm.index > 0){
                        vm.index--;
                        vm.selectedReport = vm.yearReports[vm.index];
                        vm.changeSelectedReport();
                    }
                }
            }
        }

        vm.gotoReportDetail = function(report)
        {
            var data = report ? report : undefined;

            $mdDialog.show({
                controller         : 'ReportDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedReport : data
                },
                templateUrl        : 'app/main/reports/views/dialogs/report/report-dialog.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false
            }).then(function(result) {
                loadReports(true);
            }, function() {
                
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.results')
        .controller('ResultsController', ResultsController);

    /** @ngInject */
    function ResultsController($state, $mdDialog, $document, $translate, $timeout, $stateParams, $location, $window, $mdPanel,
                                questionService, surveyDTO, geocitizenDTO, surveyService, msNavigationService)
    {
        var vm = this;

        // Data
        vm.surveyHash = $stateParams.surveyHash;
        vm.showGPSResults = false;

        if(vm.surveyHash){
            // Delete the 'apps' item
            msNavigationService.deleteItem('survey');
            msNavigationService.deleteItem('questions');
            msNavigationService.deleteItem('results');
            geocitizenDTO.privateOptions.showOptions = false;
            vm.showGPSResults = false;
        }

        vm.selectedProject = geocitizenDTO.selectedProject;
        vm.topBgClass = geocitizenDTO.style.topBgClass;

        vm.answerTypes = {  likert: $translate.instant('QUESTION.LIKERT_SCALE'),
                            single_choice: $translate.instant('QUESTION.SINGLE_CHOICE'),
                            multiple_choice: $translate.instant('QUESTION.MULTI_CHOICE'),
                            input: $translate.instant('QUESTION.TEXT'),
                            boolean: $translate.instant('QUESTION.YES_NO'),
                            number: $translate.instant('QUESTION.NUMBER'),
                            headline: $translate.instant('QUESTION.HEADLINE')
                         };

        vm.surveyStatus = { edit: $translate.instant('SURVEY.EDIT_MODE'),
                            started: $translate.instant('SURVEY.STARTED_MODE'),
                            ended: $translate.instant('SURVEY.ENDED_MODE')
                        };

        var chartAnswersLabel = $translate.instant('RESULTS.ANSWERS');

        vm.showAllSurveys = true;
        vm.heatmapType = "village";
        vm.lastClickData = null;
        vm.showChart = false;

        //TABLE
        vm.dtInstance = {};
        
        vm.dtOptions = {
            paging: false, 
            searching: false,
            language    : {
                url : "/app/data/i18n/datatables/" + geocitizenDTO.currentLanguageCode + ".json"
            }
        };

        // Methods

        loadSurveys();
        
        //////////
        function loadSurveys(){

            vm.languages = {};
            _.each(geocitizenDTO.languages, function(lang){
                vm.languages[lang.code] = lang.name;
            });

            if(!vm.surveyHash){
                vm.region = _.first(_.filter(geocitizenDTO.userProjects, { id: geocitizenDTO.selectedProject.id }));
                loadMap();
                surveyService.getSurveysResultsByRegion(geocitizenDTO.selectedProject.id, geocitizenDTO.user.id).then(function(result) {
                    vm.surveys = result.data;                
                });
            }else{
                if(geocitizenDTO.privateOptions.reloadPublicResults){
                    geocitizenDTO.privateOptions.reloadPublicResults = false;
                    $timeout(function() { 
                        $state.go($state.current.name, null, {reload: $state.current.name});
                    }, 1000);
                    
                }else{
                    surveyService.getSurveyByHash(vm.surveyHash).then(function(result) {
                        vm.selectedProject = result.data.subgeo;
                        geocitizenDTO.selectedProject.id = vm.selectedProject.id;
                        geocitizenDTO.selectedProject.name = vm.selectedProject.name;
                        vm.region = result.data.subgeo;
                        showSurveyResults(result.data);
                        loadMap();                                    
                    });
                }
            }            
        }

        function loadMap(){
            $timeout(function() {                
                var location = vm.region.center ? JSON.parse(vm.region.center) : null;
                var zoom = 12;
                var lat = 0;
                var lng = 0;
                if(!location){
                    zoom = 2;
                }else{
                    lat = location.coordinates[1];
                    lng = location.coordinates[0];
                }
                mapMgr.createMap('mapCanvas');   
                mapMgr.showMap({lat: lat, lng: lng, zoom: zoom});
                mapMgr.addHeatMap();
            }, 1000);            
        }

        vm.showSurveyResults = showSurveyResults;
        function showSurveyResults(survey){
            vm.currentQuestionIndex = 0;
            vm.selectedSurvey = survey;
            vm.selectedSurvey.survey_configurations = _.orderBy(vm.selectedSurvey.survey_configurations, ['question_order'], ['asc']);
            vm.currentQuestion = vm.selectedSurvey.survey_configurations[vm.currentQuestionIndex].survey_question;
            vm.showAllSurveys = false;

            drawChart();   
        }

        function drawChart(){

            vm.showChart = false;
            var showChartFlag = false;            

            $timeout(function() {

                vm.chartHeight = angular.element(".gc-chart-container")[0].offsetHeight - 120;

                vm.datapoints = [];
                vm.axisXNames = [];
                vm.datacolumns = [{"id": chartAnswersLabel,"type":"bar"}];
                vm.datax = {"id":"x"};
                vm.axisY =  function (d) {
                                return (parseInt(d) == d) ? d : null;
                            };
                            
                vm.currentAnswers = _.filter(vm.selectedSurvey.survey_answers, { survey_question_id: vm.currentQuestion.id });
                vm.groupedAnswers = _.countBy(vm.currentAnswers, 'answer_text');

                vm.totalParticipants = 0;
                var participants = _.countBy(vm.currentAnswers, 'user_id');
                for (var key in participants) {
                    if (participants.hasOwnProperty(key)) {
                        vm.totalParticipants++;
                    }
                }

                vm.min = 5;
                vm.max = 1;
                var total = 0;
                var answersCount = vm.currentAnswers.length == 0 ? 1 : vm.currentAnswers.length;
                
                switch (vm.currentQuestion.answer_type) {
                    case "likert":
                        vm.datapoints = [{"x":1, "answerValue": "1"},  
                                        {"x":2,  "answerValue": "2"},
                                        {"x":3,  "answerValue": "3"},
                                        {"x":4,  "answerValue": "4"},
                                        {"x":5,  "answerValue": "5"}];

                        _.each(vm.datapoints, function(item){
                            item[chartAnswersLabel] = 0;
                        });

                        for (var key in vm.groupedAnswers) {
                            if (vm.groupedAnswers.hasOwnProperty(key)) {
                                vm.datapoints[key - 1][chartAnswersLabel] = vm.groupedAnswers[key];
                                total += (key * vm.groupedAnswers[key]);
                                vm.min = vm.min > key ? key : vm.min;
                                vm.max = vm.max < key ? key : vm.max;
                            }
                        }
                        vm.average = total / answersCount;
                        showChartFlag = true;
                        vm.showAxisXNames = true;
                        break;
                    case "boolean": case "single_choice": case "multiple_choice": case "number":
                        for (var key in vm.groupedAnswers) {
                            if (vm.groupedAnswers.hasOwnProperty(key)) {
                                var point = {"x": key, "answerValue": key};
                                point[chartAnswersLabel] = vm.groupedAnswers[key];
                                vm.datapoints.push(point);
                                vm.axisXNames.push(key);
                            }
                        }
                        vm.changeAxisXNames = true;
                        vm.showAxisXNames = false;
                        showChartFlag = true;
                        break;
                }

                vm.showChart = showChartFlag;

            }, 500);            
        }

        vm.showAllResults = function(){
            vm.selectedSurvey = null;
            vm.showAllSurveys = true;
        }

        vm.nextQuestion = function(){
            if(vm.selectedSurvey.survey_configurations.length > (vm.currentQuestionIndex + 1)){
                vm.currentQuestionIndex++;
                vm.currentQuestion = vm.selectedSurvey.survey_configurations[vm.currentQuestionIndex].survey_question;

                drawChart();
            }
        }

        vm.previousQuestion = function(){
            if((vm.currentQuestionIndex - 1) >= 0){
                vm.currentQuestionIndex--;
                vm.currentQuestion = vm.selectedSurvey.survey_configurations[vm.currentQuestionIndex].survey_question;

                drawChart();
            }
        }

        vm.showClick = function(data){
            if(data){
                //Put the data on memory.
                vm.lastClickData = data;

                var answerInfo = vm.datapoints[data.index];
                //var answers = _.filter(vm.currentQuestion.survey_answers, { answer_text: answerInfo.answerValue });
                var answers = _.filter(vm.selectedSurvey.survey_answers, { survey_question_id: vm.currentQuestion.id,
                                                                            answer_text: answerInfo.answerValue
                                                                         });

                var heatmapData = [];
                var tempJson = null;
                _.each(answers, function(item){
                    if(vm.heatmapType == "gps" && item.location){                    
                        heatmapData.push({ lat: item.location.coordinates[1], lng: item.location.coordinates[0], value: 1 });
                         
                    }else if(item.locality && item.locality.locality_geometry && item.locality.locality_geometry.center){   
                        var center = JSON.parse(item.locality.locality_geometry.center);                 
                        heatmapData.push({ lat: center.coordinates[1], lng: center.coordinates[0], value: 1 });                     
                    }                                  
                });

                mapMgr.heatmapLayer.setData({ max: 3, data: heatmapData });

                //show the result in the map view
                if(heatmapData.length > 0){
                    mapMgr.map.fitBounds(heatmapData);
                }  
            }                      
        }

        vm.shareSurveyUrl = function(shareType){
            surveyService.getSurveyIdHash(vm.selectedSurvey.id).then(function(result) {
                
                var urlToGo = '';
                switch (shareType) {
                    case 1:
                        urlToGo = '/#/public-results/';

                        var position = $mdPanel.newPanelPosition()
                                        .relativeTo('.share-link-btn')
                                        .addPanelPosition($mdPanel.xPosition.ALIGN_START, $mdPanel.yPosition.BELOW);

                        var config = {
                            attachTo: angular.element(document.body),
                            controller: 'ShareLinkController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/results/views/share-link/share-link.html',
                            panelClass: 'share-link',
                            position: position,
                            clickOutsideToClose: true,
                            escapeToClose: true,
                            focusOnOpen: false,
                            zIndex: 2,
                            locals: {
                                currentLink: $location.protocol()+'://'+$location.host()+ urlToGo +result.data.hash
                            }
                        };

                        $mdPanel.open(config);

                        break;
                    case 2:
                        urlToGo = '#/print-results/';
                        var url = $location.protocol()+'://'+$location.host()+ urlToGo +result.data.hash;
                        $window.open(url, '_blank');
                        break;
                }      
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.question')
        .controller('QuestionsLibraryController', QuestionsLibraryController);

    /** @ngInject */
    function QuestionsLibraryController($state, $mdDialog, $document, $translate, questionService, surveyDTO, geocitizenDTO)
    {
        var vm = this;

        // Data
        if($state.current.name == 'app.survey.copyquestions'){
            vm.selectedSurvey = surveyDTO.selectedSurvey;
        }        
        vm.selectedProject = geocitizenDTO.selectedProject;
        vm.topBgClass = geocitizenDTO.style.topBgClass;

        vm.answerTypes = {  likert: $translate.instant('QUESTION.LIKERT_SCALE'),
                            single_choice: $translate.instant('QUESTION.SINGLE_CHOICE'),
                            multiple_choice: $translate.instant('QUESTION.MULTI_CHOICE'),
                            input: $translate.instant('QUESTION.TEXT'),
                            boolean: $translate.instant('QUESTION.YES_NO'),
                            number: $translate.instant('QUESTION.NUMBER'),
                            headline: $translate.instant('QUESTION.HEADLINE')
                         };

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs  : [
                {
                    // Target the id column
                    targets: 0,
                    width  : '50px'
                }
            ],
            initComplete: function ()
            {
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 20,
            scrollY     : 'auto',
            responsive  : true,
            language    : {
                url : "/app/data/i18n/datatables/" + geocitizenDTO.currentLanguageCode + ".json"
            }
        };

        // Methods
        surveyDTO.reloadQuestions = loadQuestions;
        vm.gotoQuestionPreview = gotoQuestionPreview;
        vm.selectQuestion = selectQuestion;
        vm.importSelectedQuestions = importSelectedQuestions;

        loadQuestions();

        //////////
        function loadQuestions(){

            vm.languages = {};
            _.each(geocitizenDTO.languages, function(lang){
                vm.languages[lang.code] = lang.name;
            });

            questionService.getPublicQuestions(geocitizenDTO.currentLanguage).then(function(result) {
                vm.questions = result.data;                
            });
        }

        /**
         * Go to question detail
         *
         * @param id
         */
        function gotoQuestionPreview(question)
        {
            $mdDialog.show({
                controller         : 'QuestionPreviewDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedQuestion: question
                },
                templateUrl        : 'app/main/question/views/dialogs/question-preview/question-preview-dialog.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false
            });
        }

        function selectQuestion(question){

            vm.showImportBtn = _.some(vm.questions, { import: true });
        }

        function importSelectedQuestions(){

            if(!vm.selectedSurvey){
                $mdDialog.show({
                    controller         : 'QuestionImportDialogController',
                    controllerAs       : 'vm',
                    locals             : {
                        selectedQuestions: _.filter(vm.questions, { import: true })
                    },
                    templateUrl        : 'app/main/question/views/dialogs/question-import/question-import-dialog.html',
                    parent             : angular.element($document.body),
                    clickOutsideToClose: false
                });
            }else{
                importQuestionsToSurvey();
            }            
        }

        function importQuestionsToSurvey(){

            var ids = [];
            _.each(vm.questions, function(q){
                if(q.import){
                    ids.push(q.id);
                }
            });

            questionService.importSurveyQuestions(vm.selectedSurvey.id, ids).then(function(result) {
                $state.go('app.survey.questions');
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.process')
        .controller('ProcessController', ProcessController);

    /** @ngInject */
    function ProcessController($mdDialog, $document, $translate, geocitizenDTO)
    {
        var vm = this;

        // Data    
        vm.selectedProject = geocitizenDTO.selectedProject;
        vm.style = geocitizenDTO.style;
       
        // Methods
        

        /**
         * Go to product detail
         *
         * @param id
         */
        vm.gotoSubgeoDetail = function()
        {
            $mdDialog.show({
                controller         : 'ProcessDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/process/views/dialogs/process/process-dialog.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.participants')
        .controller('ParticipantsController', ParticipantsController);

    /** @ngInject */
    function ParticipantsController($state, $mdDialog, $document, $translate, participantsService, geocitizenDTO, participantsDTO)
    {
        var vm = this;

        // Data
        vm.selectedProject = geocitizenDTO.selectedProject;
        vm.topBgClass = geocitizenDTO.style.topBgClass;

        vm.genders = { 
                        female: $translate.instant('SHARED.FEMININE'),
                        male: $translate.instant('SHARED.MASCULINE'),
                        empty: ''
                     };

        vm.statuses = { 
                        requested: $translate.instant('PARTICIPANTS.STATUS_REQUESTED'),
                        accepted: $translate.instant('PARTICIPANTS.STATUS_ACCEPTED'),
                        denied: $translate.instant('PARTICIPANTS.STATUS_DENIED'),
                        blocked: $translate.instant('PARTICIPANTS.STATUS_BLOCKED')
                     };

        vm.requests = { 
                        1: $translate.instant('PARTICIPANTS.ADMIN'),
                        2: $translate.instant('PARTICIPANTS.MODERATOR'),
                        3: $translate.instant('PARTICIPANTS.GEOUSER'),
                        4: $translate.instant('PARTICIPANTS.FACILITATOR'),
                        6: $translate.instant('PARTICIPANTS.GEOEXPERT')
                     };

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function ()
            {
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 10,
            scrollY     : 'auto',
            responsive  : true,
            language    : {
                url : "/app/data/i18n/datatables/" + geocitizenDTO.currentLanguageCode + ".json"
            }
        };

        // Methods
        participantsDTO.reloadParticipants = loadParticipants;

        loadParticipants();

        //////////
        function loadParticipants(){
            vm.selectedProject = geocitizenDTO.selectedProject;
            
            participantsService.getParticipantsByRegion(geocitizenDTO.selectedProject.id, geocitizenDTO.user.id).then(function(result) {
                vm.participants = result.data;
            });
        }

        vm.changeStatus = function(participant, action){

            var title = '';
            var text = '';

            switch (action) {
                case 'give_access':
                    title = $translate.instant('PARTICIPANTS.GIVE_ACCESS');
                    text = $translate.instant('PARTICIPANTS.GIVE_ACCESS_TEXT');
                    break;
                case 'block':
                    title = $translate.instant('PARTICIPANTS.BLOCK_USER');
                    text = $translate.instant('PARTICIPANTS.BLOCK_USER_TEXT');
                    break;
                case 'deny':
                    title = $translate.instant('PARTICIPANTS.DENY_USER');
                    text = $translate.instant('PARTICIPANTS.DENY_USER_TEXT');
                    break;
            }

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title(title)
                .textContent(text+': '+participant.user.first_name+' '+participant.user.last_name)
                .ariaLabel('Change status')
                .ok($translate.instant('QUESTION.OK'))
                .cancel($translate.instant('QUESTION.CANCEL'));

            $mdDialog.show(confirm).then(function() {
                participantsService.changeParticipantStatus(geocitizenDTO.selectedProject.id, participant.user_id, action).then(function(result) {
                    loadParticipants();
                });
            }, function() {
                
            });
        }

        vm.assignRole = function(participant){

            $mdDialog.show({
                controller         : 'AssignRoleDialogController',
                controllerAs       : 'vm',
                locals             : {
                    participant: participant
                },
                templateUrl        : 'app/main/participants/views/dialogs/assign-role/assign-role-dialog.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.group')
        .controller('GroupController', GroupController);

    /** @ngInject */
    function GroupController($state, $mdDialog, $document, $translate, groupService, groupDTO, geocitizenDTO)
    {
        var vm = this;

        // Data
        vm.selectedProject = geocitizenDTO.selectedProject;
        vm.topBgClass = geocitizenDTO.style.topBgClass;

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function ()
            {
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 10,
            scrollY     : 'auto',
            responsive  : true,
            language    : {
                url : "/app/data/i18n/datatables/" + geocitizenDTO.currentLanguageCode + ".json"
            }
        };

        // Methods
        groupDTO.reloadGroups = loadGroups;
        vm.gotoGroupDetail = gotoGroupDetail;

        loadGroups();

        //////////
        function loadGroups(){
            vm.selectedProject = geocitizenDTO.selectedProject;
            
            groupService.getGroupsByRegion(geocitizenDTO.selectedProject.id, geocitizenDTO.user.id).then(function(result) {
                vm.groups = result.data;
            });
        }


        /**
         * Go to group detail
         *
         * @param id
         */
        function gotoGroupDetail(group)
        {
            var data = group ? group : undefined;

            $mdDialog.show({
                controller         : 'GroupDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedGroup: data
                },
                templateUrl        : 'app/main/group/views/dialogs/group/group-dialog.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false
            });
        }

        vm.gotoNotificationDetail = function(group)
        {
            $mdDialog.show({
                controller         : 'GroupNotificationDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedGroup: group
                },
                templateUrl        : 'app/main/group/views/dialogs/notification/group-notification-dialog.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false
            });
        }

        vm.deleteGroup = function(group){

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title($translate.instant('QUESTION.DELETE'))
                .textContent($translate.instant('GROUP.DELETE_GROUP'))
                .ariaLabel('Delete')
                .ok($translate.instant('QUESTION.OK'))
                .cancel($translate.instant('QUESTION.CANCEL'));

            $mdDialog.show(confirm).then(function() {
                groupService.deleteGroup(group.id).then(function(result) {
                    loadGroups();
                });
            }, function() {
                
            });               
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.flags')
        .controller('FlagsController', FlagsController);

    /** @ngInject */
    function FlagsController($state, $mdDialog, $document, $translate, flagsService, geocitizenDTO, flagsDTO)
    {
        var vm = this;

        // Data
        vm.selectedProject = geocitizenDTO.selectedProject;
        vm.currentLanguageCode = geocitizenDTO.currentLanguageCode;
        vm.topBgClass = geocitizenDTO.style.topBgClass;

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function ()
            {
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 10,
            scrollY     : 'auto',
            responsive  : true,
            language    : {
                url : "/app/data/i18n/datatables/" + geocitizenDTO.currentLanguageCode + ".json"
            }
        };

        flagsDTO.removeFlag = removeFlag;

        loadFlags();

        // Methods
        function loadFlags(){
            vm.selectedProject = geocitizenDTO.selectedProject;
            
            flagsService.getFlagsByRegion(geocitizenDTO.selectedProject.id).then(function(result) {
                vm.flags = result.data;
            });
        }
        
        vm.gotoFlagDescription = function(flag)
        {
            var data = flag ? flag : undefined;

            $mdDialog.show({
                controller         : 'ShowDescriptionDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedFlag: data
                },
                templateUrl        : 'app/main/flags/views/dialogs/show-description/show-description-dialog.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false
            });
        }

        vm.gotoEditItem = function(flag, edit)
        {
            var data = flag ? flag : undefined;

            $mdDialog.show({
                controller         : 'EditFlagDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedFlag   : data,
                    editMode       : edit
                },
                templateUrl        : 'app/main/flags/views/dialogs/edit-flag-entry/edit-flag-entry-dialog.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false
            });
        }

        vm.flagChange = function(flag, action){

            flagsService.deleteFlaggedElement(geocitizenDTO.selectedProject.id, flag.id, action).then(function(result) {
                removeFlag(flag.id);
            });
        }

        function removeFlag(id){
            _.remove(vm.flags, { id: id });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_reset-password', {
            url      : '/auth/reset-password',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_reset-password': {
                    templateUrl: 'app/main/auth/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            bodyClass: 'reset-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/reset-password');

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.reset-password')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.register', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_register-v2', {
            url      : '/auth/register-v2',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_register-v2': {
                    templateUrl: 'app/main/auth/register-v2/register-v2.html',
                    controller : 'RegisterV2Controller as vm'
                }
            },
            bodyClass: 'register-v2'
        });

        // Translate
        $translatePartialLoaderProvider.addPart('app/main/auth/register-v2');

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.register')
        .controller('RegisterV2Controller', RegisterV2Controller);

    /** @ngInject */
    function RegisterV2Controller($state, authService)
    {
        var vm = this;

        // Data
        vm.signup = {
                      "data": {
                        "attributes" : {
                          "first_name": null,
                          "last_name": null,
                          "email": null,
                          "password": null
                        },
                        "relationships": {},
                        "type": "users"
                        }
                    };

        // Methods
        vm.doSignup = function(){
            if(vm.signup.data.attributes.password == vm.signup.data.attributes.passwordConfirm){
                authService.doSignup(vm.signup).then(function(result) {
                    console.log('ctrl', result);
                    $state.go('app.login');
                });    
            }            
        }
        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.profile')
        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController(mdPanelRef, $mdPanel, $state, $window, geocitizenDTO, authService, $translate)
    {
        var vm = this;

        // Data
        vm.user = geocitizenDTO.user;
        vm.options = true;
        vm.passwords = {};
                
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us',
                'value'      : 1
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es',
                'value'      : 2
            },
            de: {
                'title'      : 'Deutsch',
                'translation': 'TOOLBAR.GERMAN',
                'code'       : 'de',
                'flag'       : 'de',
                'value'      : 3
            }
        };
        vm.selectedLanguage = vm.languages[geocitizenDTO.currentLanguageCode];

        vm.changeSelectedLanguage = function(){
            geocitizenDTO.changeLanguage(vm.selectedLanguage);
        }

        vm.closePanel = function()
        {
            mdPanelRef && mdPanelRef.close();
        }

        vm.updatePassword = function(){
            vm.errorMsg = null;

            if(vm.passwords.newPassword == vm.passwords.confirmPassword){
                if(vm.passwords.newPassword.length > 5){
                    authService.updatePassword({ currentPassword: vm.passwords.currentPassword, newPassword: vm.passwords.newPassword }).then(function(result){
                        vm.closePanel();
                    }, function(error){
                        console.log(error);
                        vm.errorMsg = $translate.instant('PROFILE.ERRORS.'+error.data.errorCode);
                    });
                }else{
                    vm.errorMsg = $translate.instant('PROFILE.ERRORS.PASSWORD_LENGTH');
                }                
            }else{
                vm.errorMsg = $translate.instant('PROFILE.ERRORS.CONFIRM_PASSWORD');
            }            
        }

        vm.logout = function()
        {
            geocitizenDTO.clearData();
            authService.doLogout().then(finishLogout, finishLogout);

            function finishLogout(result) {
                $window.localStorage.clear();
                vm.closePanel();
                $state.go('app.login');
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.login', {
            url      : '/auth/login',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.login': {
                    templateUrl: 'app/main/auth/login-v2/login-v2.html',
                    controller : 'LoginV2Controller as vm'
                }
            },
            bodyClass: 'login-v2'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/login-v2');

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.login')
        .controller('LoginV2Controller', LoginV2Controller);

    /** @ngInject */
    function LoginV2Controller(authService, geocitizenDTO, $window, $state, $translate)
    {
        var vm = this;
        // Data

        vm.login =  {
                      "email":   null,
                      "password": null
                    };

        // Methods

        //////////
        vm.doLogin = function(){
            authService.doLogin(vm.login).then(function(result) {
                //console.log('ctrl', result);
                $window.localStorage.setItem('user', JSON.stringify(result.data.user));
                $window.localStorage.setItem('profile', JSON.stringify(result.data.profile));
                $window.localStorage.setItem('auth_token', result.data.api_token);
                geocitizenDTO.reloadUserData();
                $state.go('app.survey');
            }, function(error){
                console.log(error);
                vm.showErrorMsg = true;
                vm.errorMsg = $translate.instant('LOGIN.ERRORS.'+error.data.errorCode);
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url      : '/auth/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password': {
                    templateUrl: 'app/main/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/forgot-password');

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController($translate, authService, geocitizenDTO)
    {
        var vm = this;
        // Data

        // Methods
        vm.recoverPassword = function(){
            vm.showMsg = false;

            authService.recoverPassword({email: vm.form.email, locale: geocitizenDTO.currentLanguageCode}).then(function(result) {
                vm.showMsg = true;
                vm.resultMsg = $translate.instant('FORGOTPASSWORD.EMAIL_SENT');
            }, function(error){
                console.log(error);
                vm.showMsg = true;
                vm.resultMsg = $translate.instant('FORGOTPASSWORD.ERRORS.'+error.data.errorCode);
            });
        }
        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'datatables',
                'angular-clipboard'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
            
            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);
                    
                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            var absUrl = window.location.href;
            //border bottom color
            vm.activeGreen = 'orange-active';
            if(_.includes(absUrl, 'geofarmer')){
                vm.activeGreen = 'green-active';
            }

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow')
        .service('workflowService', workflowService);

    /** @ngInject */
    function workflowService($http, api)
    {
        // Data
        

        // Methods
        this.saveWorkflow = function(workflowData){
            if(workflowData.id){//update
                return $http.patch(api.workflowUrl+'/'+workflowData.id, workflowData).then(function(result) {
                    return result;
                });
            }else{//create
                return $http.post(api.workflowUrl, workflowData).then(function(result) {
                    return result;
                });
            }            
        }

        this.deleteWorkflow = function(workflowId, regionId){
            return $http.post(api.surveyDashboard+'delete-workflow', { workflowId: workflowId, regionId: regionId }).then(function(result) {
                return result;
            });            
        }

        this.getWorkflowsByRegion = function(regionId, userId){
            return $http.get(api.surveyDashboard+'get-workflows-by-region', { params: { regionId: regionId, userId: userId } }).then(function(result) {
                return result;
            });
        }

        ///////// VARIABLES //////////
        this.saveVariable = function(variableData){
            if(variableData.id){//update
                return $http.patch(api.workflowVariableUrl+'/'+variableData.id, variableData).then(function(result) {
                    return result;
                });
            }else{//create
                return $http.post(api.workflowVariableUrl, variableData).then(function(result) {
                    return result;
                });
            }            
        }
        this.deleteVariable = function(regionId, variableId){
            return $http.post(api.surveyDashboard+'delete-variable', { variableId: variableId, regionId: regionId }).then(function(result) {
                return result;
            });            
        }
        this.getVariablesByWorkflow = function(regionId, workflowId){
            return $http.get(api.surveyDashboard+'get-variables-by-workflow', { params: { regionId: regionId, workflowId: workflowId } }).then(function(result) {
                return result;
            });
        }
        
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.workflow')
        .service('workflowDTO', workflowDTO);

    /** @ngInject */
    function workflowDTO()
    {
        //Data
        this.selectedWorkflow = null;

        //Methods
        this.reloadWorkflows = null;
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.workflow')
        .controller('WorkflowController', WorkflowController);

    /** @ngInject */
    function WorkflowController($state, $mdDialog, $document, $translate, workflowService, workflowDTO, geocitizenDTO)
    {
        var vm = this;

        // Data
        vm.selectedProject = geocitizenDTO.selectedProject;
        vm.topBgClass = geocitizenDTO.style.topBgClass;

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function ()
            {
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 10,
            scrollY     : 'auto',
            responsive  : true,
            language    : {
                url : "/app/data/i18n/datatables/" + geocitizenDTO.currentLanguageCode + ".json"
            }
        };

        // Methods
        workflowDTO.reloadWorkflows = loadWorkflows;
        vm.goToWorkflowDetail = goToWorkflowDetail;
        vm.goToWorkflowVariables = goToWorkflowVariables;

        loadWorkflows();

        //////////
        function loadWorkflows(){
            vm.selectedProject = geocitizenDTO.selectedProject;
            
            workflowService.getWorkflowsByRegion(geocitizenDTO.selectedProject.id, geocitizenDTO.user.id).then(function(result) {
                vm.workflows = result.data;
            });
        }


        /**
         * Go to product detail
         *
         * @param id
         */
        function goToWorkflowDetail(workflow)
        {
            var data = workflow ? workflow : undefined;

            $mdDialog.show({
                controller         : 'WorkflowDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedWorkflow: data
                },
                templateUrl        : 'app/main/workflow/views/dialogs/workflow/workflow-dialog.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false
            });
        }

        function goToWorkflowVariables(workflow){
            workflowDTO.selectedWorkflow = workflow;
            $state.go('app.workflow.variables');
        }

        vm.deleteWorkflow = function(workflow){

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title($translate.instant('SHARED.DELETE'))
                .textContent($translate.instant('WORKFLOW.DELETE_WORKFLOW'))
                .ariaLabel('Delete')
                .ok($translate.instant('QUESTION.OK'))
                .cancel($translate.instant('QUESTION.CANCEL'));

            $mdDialog.show(confirm).then(function() {
                workflowService.deleteWorkflow(workflow.id, geocitizenDTO.selectedProject.id).then(function(result) {
                    loadWorkflows();
                });
            }, function() {
                
            });               
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.survey_new')
        .service('surveyNewService', surveyNewService);

    /** @ngInject */
    function surveyNewService($http, api)
    {
        // Data
        

        // Methods
        this.saveSurvey = function(surveyData){
            if(surveyData.id){//update
                return $http.patch(api.surveyUrl+'/'+surveyData.id, surveyData).then(function(result) {
                    return result;
                });
            }else{//create
                return $http.post(api.surveyUrl, surveyData).then(function(result) {
                    return result;
                });
            }            
        }

        this.associateGroups = function(surveyId, groupIds){
            return $http.post(api.surveyDashboard+'associate-groups', { surveyId: surveyId, groupIds: groupIds }).then(function(result) {
                return result;
            });            
        }

        this.deleteSurvey = function(surveyId, userId){
            return $http.post(api.surveyDashboard+'delete-survey', { surveyId: surveyId, userId: userId }).then(function(result) {
                return result;
            });            
        }

        this.getSurveysByRegion = function(regionId, userId){
            return $http.get(api.surveyDashboard+'get-surveys-by-region-new', { params: { regionId: regionId, userId: userId } }).then(function(result) {
                return result;
            });
        }

        this.getSurveysResultsByRegion = function(regionId, userId){
            return $http.get(api.surveyDashboard+'get-surveys-results-by-region', { params: { regionId: regionId, userId: userId } }).then(function(result) {
                return result;
            });
        }

        this.getSurveyQuestions = function(surveyId){
            return $http.post(api.surveyDashboard+'survey-questions-new', { surveyId: surveyId }).then(function(result) {
                return result;
            });
        }

        /*this.saveQuestion = function(questionData){
            return $http.post(api.surveyDashboard+'create-question', {question: JSON.stringify(questionData)}).then(function(result) {
                return result;
            });       
        }*/

        this.deleteQuestion = function(questionId, userId){
            return $http.post(api.surveyDashboard+'delete-question', { questionId: questionId, userId: userId }).then(function(result) {
                return result;
            });            
        }

        this.deleteChoice = function(choiceId, userId){
            return $http.post(api.surveyDashboard+'deleteChoice', { choiceId: choiceId, userId: userId }).then(function(result) {
                return result;
            });            
        }

        this.saveQuestionConfig = function(qConfigData){
            if(qConfigData.id){//update
                return $http.patch(api.questionConfigUrl+'/'+qConfigData.id, qConfigData).then(function(result) {
                    return result;
                });
            }else{//create
                return $http.post(api.questionConfigUrl, qConfigData).then(function(result) {
                    return result;
                });
            }            
        }

        this.saveQuestion = function(qData){
            if(qData.id){//update
                return $http.patch(api.questionUrl+'/'+qData.id, qData).then(function(result) {
                    return result;
                });
            }else{//create
                return $http.post(api.questionUrl, qData).then(function(result) {
                    return result;
                });
            }            
        }

        this.saveGuards = function(guardData){
            return $http.post(api.surveyDashboard+'save-question-guards', { data: JSON.stringify(guardData) }).then(function(result) {
                return result;
            });         
        }

        this.saveChoices = function(choicesData){
            if(choicesData.id){//update
                return $http.patch(api.questionChoiceUrl+'/'+choicesData.id, choicesData).then(function(result) {
                    return result;
                });
            }else{//create
                return $http.post(api.questionChoiceUrl, choicesData).then(function(result) {
                    return result;
                });
            }            
        }

        this.deleteElement = function(deleteData){
            return $http.post(api.surveyDashboard+'delete-question-data', { data: JSON.stringify(deleteData) }).then(function(result) {
                return result;
            });         
        }

        this.getPublicSurveys = function(userId, language){
            return $http.get(api.surveyDashboard+'get-public-surveys', { params: { userId: userId, language: language } }).then(function(result) {
                return result;
            });
        }

        this.importSurvey = function(surveyId, regionId, userId){
            return $http.post(api.surveyDashboard+'import-survey', { surveyId: surveyId, regionId: regionId, userId: userId }).then(function(result) {
                return result;
            });
        }

        this.getSurveyIdHash = function(surveyId){
            return $http.post(api.surveyDashboard+'get-survey-hash', { surveyId: surveyId }).then(function(result) {
                return result;
            });
        }

        this.getSurveyByHash = function(hash){
            return $http.post(api.surveyDashboard+'get-survey-by-hash', { hash: hash }).then(function(result) {
                return result;
            });
        }

        this.getSurveyRounds = function(surveyId, regionId){
            return $http.post(api.surveyDashboard+'get-survey-rounds', { regionId: regionId, surveyId: surveyId }).then(function(result) {
                return result;
            });
        }

        this.getRoundFarmers = function(roundId, regionId){
            return $http.post(api.surveyDashboard+'get-round-farmers', { regionId: regionId, roundId: roundId }).then(function(result) {
                return result;
            });
        }

        this.assignFarmers = function(data, regionId){
            return $http.post(api.surveyDashboard+'assign-round-farmers', { data: JSON.stringify(data), regionId: regionId }).then(function(result) {
                return result;
            });
        }

        this.setDefaultSurvey = function(surveyId, regionId){
            return $http.post(api.surveyDashboard+'set-default-survey', { surveyId: surveyId, regionId: regionId }).then(function(result) {
                return result;
            });
        }

        this.deleteRound = function(roundId, regionId){
            return $http.post(api.surveyDashboard+'delete-round', { roundId: roundId, regionId: regionId }).then(function(result) {
                return result;
            });
        }

        this.saveRounds = function(rounds, regionId){
            return $http.post(api.surveyDashboard+'save-rounds', { rounds: JSON.stringify(rounds), regionId: regionId }).then(function(result) {
                return result;
            });
        }
        
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.survey_new')
        .service('surveyNewDTO', surveyNewDTO);

    /** @ngInject */
    function surveyNewDTO()
    {
        //Data
        this.selectedSurvey = null;

        //Methods
        this.reloadSurveys = null;
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.survey_new')
        .controller('SurveysNewController', SurveysNewController);

    /** @ngInject */
    function SurveysNewController($state, $mdDialog, $document, $translate, surveyNewService, surveyDTO, geocitizenDTO, api)
    {
        var vm = this;

        // Data
        vm.selectedProject = geocitizenDTO.selectedProject;
        vm.topBgClass = geocitizenDTO.style.topBgClass;
        vm.api = api;

        vm.surveyStatus = { edit: $translate.instant('SURVEY.EDIT_MODE'),
                            started: $translate.instant('SURVEY.STARTED_MODE'),
                            ended: $translate.instant('SURVEY.ENDED_MODE')
                        };

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function ()
            {
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 10,
            scrollY     : 'auto',
            responsive  : true,
            language    : {
                url : "/app/data/i18n/datatables/" + geocitizenDTO.currentLanguageCode + ".json"
            }
        };
        vm.isNewSurveyOpen = false;

        // Methods
        surveyDTO.reloadSurveys = loadSurveys;
        vm.gotoSurveyDetail = gotoSurveyDetail;
        vm.goToSurveyQuestions = goToSurveyQuestions;
        vm.gotoSurveyPreview = gotoSurveyPreview;
        vm.goToSurveyAssign = goToSurveyAssign;
        vm.gotoSurveyRounds = gotoSurveyRounds;

        loadSurveys();

        //////////
        function loadSurveys(){
            vm.selectedProject = geocitizenDTO.selectedProject;
            
            surveyNewService.getSurveysByRegion(geocitizenDTO.selectedProject.id, geocitizenDTO.user.id).then(function(result) {
                vm.surveys = result.data;

                vm.surveys.forEach(function(survey){
                    
                    survey.pendings = [];
                    survey.rounds.forEach(function(roundItem){
                        survey.pendings = survey.pendings.concat(roundItem.survey_pendings);
                    }); 

                    survey.pendings = _.uniqBy(survey.pendings, 'farmer_id');
                });
            });
        }


        /**
         * Go to product detail
         *
         * @param id
         */
        function gotoSurveyDetail(survey)
        {
            var data = survey ? survey : undefined;

            $mdDialog.show({
                controller         : 'SurveyDialogNewController',
                controllerAs       : 'vm',
                locals             : {
                    selectedSurvey: data
                },
                templateUrl        : 'app/main/survey-new/views/dialogs/survey/survey-dialog.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false
            });
        }

        function gotoSurveyRounds(survey)
        {
            var data = survey ? survey : undefined;

            $mdDialog.show({
                controller         : 'RoundsDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedSurvey: data
                },
                templateUrl        : 'app/main/survey-new/views/dialogs/rounds/rounds-dialog.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false
            });
        }

        function goToSurveyQuestions(survey){
            surveyDTO.selectedSurvey = survey;
            $state.go('app.survey-new.questions');
        }

        function goToSurveyAssign(survey){
            surveyDTO.selectedSurvey = survey;
            $state.go('app.survey-new.assign');
        }

        function gotoSurveyPreview(survey)
        {
            var data = survey;

            $mdDialog.show({
                controller         : 'SurveyPreviewDialogNewController',
                controllerAs       : 'vm',
                locals             : {
                    selectedSurvey: data
                },
                templateUrl        : 'app/main/survey-new/views/dialogs/survey-preview/survey-preview-dialog.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true
            });
        }

        vm.changeSurveyStatus = function(survey){

            var text = $translate.instant('SURVEY.START_CONFIRM');
            var newStatus = "started";
            if(survey.status == 'started'){
                newStatus = "ended";
                text = $translate.instant('SURVEY.STOP_CONFIRM');

            }else if(survey.status == 'ended'){
                newStatus = "started";
                text = $translate.instant('SURVEY.RESTART_CONFIRM');
            }

            var surveyData =  {
                                "status": newStatus,
                                "id": survey.id
                              };

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title($translate.instant('SURVEY.STATUS'))
                .textContent(text)
                .ariaLabel('Change status')
                .ok($translate.instant('QUESTION.OK'))
                .cancel($translate.instant('QUESTION.CANCEL'));

            $mdDialog.show(confirm).then(function() {
                surveyNewService.saveSurvey(surveyData).then(function(result) {
                    survey.status = newStatus; 
                });
            }, function() {
                
            });               
        }

        vm.deleteSurvey = function(survey){

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title($translate.instant('QUESTION.DELETE'))
                .textContent($translate.instant('SURVEY.DELETE_SURVEY'))
                .ariaLabel('Delete')
                .ok($translate.instant('QUESTION.OK'))
                .cancel($translate.instant('QUESTION.CANCEL'));

            $mdDialog.show(confirm).then(function() {
                surveyNewService.deleteSurvey(survey.id, geocitizenDTO.user.id).then(function(result) {
                    loadSurveys();
                });
            }, function() {
                
            });               
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.survey')
        .service('surveyService', surveyService);

    /** @ngInject */
    function surveyService($http, api)
    {
        // Data
        

        // Methods
        this.saveSurvey = function(surveyData){
            if(surveyData.id){//update
                return $http.patch(api.surveyUrl+'/'+surveyData.id, surveyData).then(function(result) {
                    return result;
                });
            }else{//create
                return $http.post(api.surveyUrl, surveyData).then(function(result) {
                    return result;
                });
            }            
        }

        this.associateGroups = function(surveyId, groupIds){
            return $http.post(api.surveyDashboard+'associate-groups', { surveyId: surveyId, groupIds: groupIds }).then(function(result) {
                return result;
            });            
        }

        this.deleteSurvey = function(surveyId, userId){
            return $http.post(api.surveyDashboard+'delete-survey', { surveyId: surveyId, userId: userId }).then(function(result) {
                return result;
            });            
        }

        this.getSurveysByRegion = function(regionId, userId){
            return $http.get(api.surveyDashboard+'get-surveys-by-region', { params: { regionId: regionId, userId: userId } }).then(function(result) {
                return result;
            });
        }

        this.getSurveysResultsByRegion = function(regionId, userId){
            return $http.get(api.surveyDashboard+'get-surveys-results-by-region', { params: { regionId: regionId, userId: userId } }).then(function(result) {
                return result;
            });
        }

        this.getSurveyQuestions = function(surveyId){
            return $http.post(api.surveyDashboard+'survey-questions', { surveyId: surveyId }).then(function(result) {
                return result;
            });
        }

        this.saveQuestion = function(questionData){
            return $http.post(api.surveyDashboard+'create-question', {question: JSON.stringify(questionData)}).then(function(result) {
                return result;
            });       
        }

        this.deleteQuestion = function(questionId, userId){
            return $http.post(api.surveyDashboard+'delete-question', { questionId: questionId, userId: userId }).then(function(result) {
                return result;
            });            
        }

        this.saveChoices = function(choicesData){
            if(choicesData.id){//update
                return $http.patch(api.questionChoiceUrl+'/'+choicesData.id, choicesData).then(function(result) {
                    return result;
                });
            }else{//create
                return $http.post(api.questionChoiceUrl, choicesData).then(function(result) {
                    return result;
                });
            }            
        }

        this.deleteChoice = function(choiceId, userId){
            return $http.post(api.surveyDashboard+'deleteChoice', { choiceId: choiceId, userId: userId }).then(function(result) {
                return result;
            });            
        }

        this.saveQuestionConfig = function(qConfigData){
            if(qConfigData.id){//update
                return $http.patch(api.questionConfigUrl+'/'+qConfigData.id, qConfigData).then(function(result) {
                    return result;
                });
            }else{//create
                return $http.post(api.questionConfigUrl, qConfigData).then(function(result) {
                    return result;
                });
            }            
        }

        this.getPublicSurveys = function(userId, language){
            return $http.get(api.surveyDashboard+'get-public-surveys', { params: { userId: userId, language: language } }).then(function(result) {
                return result;
            });
        }

        this.importSurvey = function(surveyId, regionId, userId){
            return $http.post(api.surveyDashboard+'import-survey', { surveyId: surveyId, regionId: regionId, userId: userId }).then(function(result) {
                return result;
            });
        }

        this.getSurveyIdHash = function(surveyId){
            return $http.post(api.surveyDashboard+'get-survey-hash', { surveyId: surveyId }).then(function(result) {
                return result;
            });
        }

        this.getSurveyByHash = function(hash){
            return $http.post(api.surveyDashboard+'get-survey-by-hash', { hash: hash }).then(function(result) {
                return result;
            });
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.survey')
        .service('surveyDTO', surveyDTO);

    /** @ngInject */
    function surveyDTO()
    {
        //Data
        this.selectedSurvey = null;

        //Methods
        this.reloadSurveys = null;
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.survey')
        .controller('SurveysController', SurveysController);

    /** @ngInject */
    function SurveysController($state, $mdDialog, $document, $translate, surveyService, surveyDTO, geocitizenDTO)
    {
        var vm = this;

        // Data
        vm.selectedProject = geocitizenDTO.selectedProject;
        vm.topBgClass = geocitizenDTO.style.topBgClass;

        vm.surveyStatus = { edit: $translate.instant('SURVEY.EDIT_MODE'),
                            started: $translate.instant('SURVEY.STARTED_MODE'),
                            ended: $translate.instant('SURVEY.ENDED_MODE')
                        };

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function ()
            {
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 10,
            scrollY     : 'auto',
            responsive  : true,
            language    : {
                url : "/app/data/i18n/datatables/" + geocitizenDTO.currentLanguageCode + ".json"
            }
        };
        vm.isNewSurveyOpen = false;

        // Methods
        surveyDTO.reloadSurveys = loadSurveys;
        vm.gotoSurveyDetail = gotoSurveyDetail;
        vm.goToSurveyQuestions = goToSurveyQuestions;
        vm.gotoSurveyPreview = gotoSurveyPreview;

        loadSurveys();

        //////////
        function loadSurveys(){
            vm.selectedProject = geocitizenDTO.selectedProject;
            
            surveyService.getSurveysByRegion(geocitizenDTO.selectedProject.id, geocitizenDTO.user.id).then(function(result) {
                vm.surveys = result.data;
            });
        }


        /**
         * Go to product detail
         *
         * @param id
         */
        function gotoSurveyDetail(survey)
        {
            var data = survey ? survey : undefined;

            $mdDialog.show({
                controller         : 'SurveyDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedSurvey: data
                },
                templateUrl        : 'app/main/survey/views/dialogs/survey/survey-dialog.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false
            });
        }

        function goToSurveyQuestions(survey){
            surveyDTO.selectedSurvey = survey;
            $state.go('app.survey.questions');
        }

        function gotoSurveyPreview(survey)
        {
            var data = survey;

            $mdDialog.show({
                controller         : 'SurveyPreviewDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedSurvey: data
                },
                templateUrl        : 'app/main/survey/views/dialogs/survey-preview/survey-preview-dialog.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true
            });
        }

        vm.changeSurveyStatus = function(survey){

            var text = $translate.instant('SURVEY.START_CONFIRM');
            var newStatus = "started";
            if(survey.status == 'started'){
                newStatus = "ended";
                text = $translate.instant('SURVEY.STOP_CONFIRM');

            }else if(survey.status == 'ended'){
                newStatus = "started";
                text = $translate.instant('SURVEY.RESTART_CONFIRM');
            }

            var surveyData =  {
                                "status": newStatus,
                                "id": survey.id
                              };

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title($translate.instant('SURVEY.STATUS'))
                .textContent(text)
                .ariaLabel('Change status')
                .ok($translate.instant('QUESTION.OK'))
                .cancel($translate.instant('QUESTION.CANCEL'));

            $mdDialog.show(confirm).then(function() {
                surveyService.saveSurvey(surveyData).then(function(result) {
                    survey.status = newStatus; 
                });
            }, function() {
                
            });               
        }

        vm.deleteSurvey = function(survey){

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title($translate.instant('QUESTION.DELETE'))
                .textContent($translate.instant('SURVEY.DELETE_SURVEY'))
                .ariaLabel('Delete')
                .ok($translate.instant('QUESTION.OK'))
                .cancel($translate.instant('QUESTION.CANCEL'));

            $mdDialog.show(confirm).then(function() {
                surveyService.deleteSurvey(survey.id, geocitizenDTO.user.id).then(function(result) {
                    loadSurveys();
                });
            }, function() {
                
            });               
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.reports')
        .service('reportsService', reportsService);

    /** @ngInject */
    function reportsService($http, api)
    {
        // Data
        

        // Methods
        this.saveReport = function(reportData){
            if(reportData.id){//update
                return $http.patch(api.reportUrl+'/'+reportData.id, reportData).then(function(result) {
                    return result;
                });
            }else{//create
                return $http.post(api.reportUrl, reportData).then(function(result) {
                    return result;
                });
            }            
        }

        this.getReportsByRegion = function(regionId){
            return $http.get(api.surveyDashboard+'get-reports-by-region', { params: { regionId: regionId } }).then(function(result) {
                return result;
            });
        }

        this.getPublicReportsByRegion = function(regionId){
            return $http.get(api.surveyDashboard+'get-public-reports-by-region', { params: { regionId: regionId } }).then(function(result) {
                return result;
            });
        }

        this.getProjectsWithPublicReports = function(regionId){
            return $http.get(api.surveyDashboard+'get-projects-with-public-reports', { params: { } }).then(function(result) {
                return result;
            });
        }
    }
})();

/* To handle all the maps functions */
function leafletMgr(){
    
    //To access the map from inside methods
    var mapObj = this;
    
    //Public properties
    this.heatmapLayer = null;
    this.map = null;
    
    //**************************************** Public Methods ****************************************************//
    /**
     * Instantiate the map
     */
    this.createMap = function(map_div) 
    {   
        this.map = L.map(map_div);        
    };

    /**
     * Show the map
     */
    this.showMap = function(extent) 
    {      
        // create the tile layer with correct attribution
        var osmUrl='http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
        var osmAttrib='Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors';
        var osm = new L.TileLayer(osmUrl, {attribution: osmAttrib});        
        //add layer
        this.map.addLayer(osm);

        this.map.setView(new L.LatLng(extent.lat, extent.lng), extent.zoom); 
    };

    /**
     * Add heatmap layer
     */
    this.addHeatMap = function() 
    {      
        var cfg = {
            // radius should be small ONLY if scaleRadius is true (or small radius is intended)
            // if scaleRadius is false it will be the constant radius used in pixels
            "radius": 50,
            "maxOpacity": .7, 
            // scales the radius based on map zoom
            //"scaleRadius": true, 
            // if set to false the heatmap uses the global maximum for colorization
            // if activated: uses the data maximum within the current map boundaries 
            //   (there will always be a red spot with useLocalExtremas true)
            //"useLocalExtrema": true,
            // which field name in your data represents the latitude - default "lat"
            latField: 'lat',
            // which field name in your data represents the longitude - default "lng"
            lngField: 'lng',
            // which field name in your data represents the data value - default "value"
            //valueField: 'count'
        };

        this.heatmapLayer = new HeatmapOverlay(cfg);
        //add layer
        this.map.addLayer(this.heatmapLayer);
    };
    
    /**
     * Adds a marker to the map in the given coordinate and symbol
     */
    this.addCustomMarker = function(lat, lng, symbol)
    {
        var icon = L.icon({
            iconUrl: "https://s3.amazonaws.com/geocitizen/markers/"+symbol+".png",
            iconSize:     [32, 32], // size of the icon
            iconAnchor:   [16, 31], // point of the icon which will correspond to marker's location
            popupAnchor:  [-3, -10] // point from which the popup should open relative to the iconAnchor
        });

        var marker = L.marker(new L.LatLng(lat, lng), {icon: icon}).addTo(this.map);
        //Add marker to the markerLayer
        this.markersLayer.addLayer(marker);

        return marker;
    };

    /**
     * Adds a marker to the map in the given coordinate and symbol
     */
    this.addMarker = function(lat, lng, userLayer)
    {
        var marker = L.marker(new L.LatLng(lat, lng)).addTo(this.map);
        //Add marker to the markerLayer
        if(userLayer){
            this.userMarkerLayer.addLayer(marker);
            this.userMarker = marker;   
        }else{
            this.markersLayer.addLayer(marker); 
        }

        return marker;      
    };

    /**
    * Clear all markers from the map
    */
    this.clearMarkers = function(userLayer){
        if(userLayer){
            this.userMarkerLayer.clearLayers();
        }else{
            this.markersLayer.clearLayers();
        }
    }
}

/*
* Leaflet Heatmap Overlay
*
* Copyright (c) 2008-2016, Patrick Wied (https://www.patrick-wied.at)
* Dual-licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
* and the Beerware (http://en.wikipedia.org/wiki/Beerware) license.
*/
;(function (name, context, factory) {
  // Supports UMD. AMD, CommonJS/Node.js and browser context
  if (typeof module !== "undefined" && module.exports) {
    module.exports = factory(
      require('heatmap.js'),
      require('leaflet')
    );
  } else if (typeof define === "function" && define.amd) {
    define(['heatmap.js', 'leaflet'], factory);
  } else {
    // browser globals
    if (typeof window.h337 === 'undefined') {
      throw new Error('heatmap.js must be loaded before the leaflet heatmap plugin');
    }
    if (typeof window.L === 'undefined') {
      throw new Error('Leaflet must be loaded before the leaflet heatmap plugin');
    }
    context[name] = factory(window.h337, window.L);
  }

})("HeatmapOverlay", this, function (h337, L) {
  'use strict';

  // Leaflet < 0.8 compatibility
  if (typeof L.Layer === 'undefined') {
    L.Layer = L.Class;
  }

  var HeatmapOverlay = L.Layer.extend({

    initialize: function (config) {
      this.cfg = config;
      this._el = L.DomUtil.create('div', 'leaflet-zoom-hide');
      this._data = [];
      this._max = 1;
      this._min = 0;
      this.cfg.container = this._el;
    },

    onAdd: function (map) {
      var size = map.getSize();

      this._map = map;

      this._width = size.x;
      this._height = size.y;

      this._el.style.width = size.x + 'px';
      this._el.style.height = size.y + 'px';
      this._el.style.position = 'absolute';

      this._origin = this._map.layerPointToLatLng(new L.Point(0, 0));

      map.getPanes().overlayPane.appendChild(this._el);

      if (!this._heatmap) {
        this._heatmap = h337.create(this.cfg);
      } 

      // this resets the origin and redraws whenever
      // the zoom changed or the map has been moved
      map.on('moveend', this._reset, this);
      this._draw();
    },

    addTo: function (map) {
      map.addLayer(this);
      return this;
    },

    onRemove: function (map) {
      // remove layer's DOM elements and listeners
      map.getPanes().overlayPane.removeChild(this._el);

      map.off('moveend', this._reset, this);
    },
    _draw: function() {
      if (!this._map) { return; }
      
      var mapPane = this._map.getPanes().mapPane;
      var point = mapPane._leaflet_pos;      

      // reposition the layer
      this._el.style[HeatmapOverlay.CSS_TRANSFORM] = 'translate(' +
        -Math.round(point.x) + 'px,' +
        -Math.round(point.y) + 'px)';

      this._update();
    },
    _update: function() {
      var bounds, zoom, scale;
      var generatedData = { max: this._max, min: this._min, data: [] };

      bounds = this._map.getBounds();
      zoom = this._map.getZoom();
      scale = Math.pow(2, zoom);

      if (this._data.length == 0) {
        if (this._heatmap) {
          this._heatmap.setData(generatedData);
        }
        return;
      }


      var latLngPoints = [];
      var radiusMultiplier = this.cfg.scaleRadius ? scale : 1;
      var localMax = 0;
      var localMin = 0;
      var valueField = this.cfg.valueField;
      var len = this._data.length;
    
      while (len--) {
        var entry = this._data[len];
        var value = entry[valueField];
        var latlng = entry.latlng;


        // we don't wanna render points that are not even on the map ;-)
        if (!bounds.contains(latlng)) {
          continue;
        }
        // local max is the maximum within current bounds
        localMax = Math.max(value, localMax);
        localMin = Math.min(value, localMin);

        var point = this._map.latLngToContainerPoint(latlng);
        var latlngPoint = { x: Math.round(point.x), y: Math.round(point.y) };
        latlngPoint[valueField] = value;

        var radius;

        if (entry.radius) {
          radius = entry.radius * radiusMultiplier;
        } else {
          radius = (this.cfg.radius || 2) * radiusMultiplier;
        }
        latlngPoint.radius = radius;
        latLngPoints.push(latlngPoint);
      }
      if (this.cfg.useLocalExtrema) {
        generatedData.max = localMax;
        generatedData.min = localMin;
      }

      generatedData.data = latLngPoints;

      this._heatmap.setData(generatedData);
    },
    setData: function(data) {
      this._max = data.max || this._max;
      this._min = data.min || this._min;
      var latField = this.cfg.latField || 'lat';
      var lngField = this.cfg.lngField || 'lng';
      var valueField = this.cfg.valueField || 'value';
    
      // transform data to latlngs
      var data = data.data;
      var len = data.length;
      var d = [];
    
      while (len--) {
        var entry = data[len];
        var latlng = new L.LatLng(entry[latField], entry[lngField]);
        var dataObj = { latlng: latlng };
        dataObj[valueField] = entry[valueField];
        if (entry.radius) {
          dataObj.radius = entry.radius;
        }
        d.push(dataObj);
      }
      this._data = d;
    
      this._draw();
    },
    // experimential... not ready.
    addData: function(pointOrArray) {
      if (pointOrArray.length > 0) {
        var len = pointOrArray.length;
        while(len--) {
          this.addData(pointOrArray[len]);
        }
      } else {
        var latField = this.cfg.latField || 'lat';
        var lngField = this.cfg.lngField || 'lng';
        var valueField = this.cfg.valueField || 'value';
        var entry = pointOrArray;
        var latlng = new L.LatLng(entry[latField], entry[lngField]);
        var dataObj = { latlng: latlng };
        
        dataObj[valueField] = entry[valueField];
        this._max = Math.max(this._max, dataObj[valueField]);
        this._min = Math.min(this._min, dataObj[valueField]);

        if (entry.radius) {
          dataObj.radius = entry.radius;
        }
        this._data.push(dataObj);
        this._draw();
      }
    },
    _reset: function () {
      this._origin = this._map.layerPointToLatLng(new L.Point(0, 0));
      
      var size = this._map.getSize();
      if (this._width !== size.x || this._height !== size.y) {
        this._width  = size.x;
        this._height = size.y;

        this._el.style.width = this._width + 'px';
        this._el.style.height = this._height + 'px';

        this._heatmap._renderer.setDimensions(this._width, this._height);
      }
      this._draw();
    } 
  });

  HeatmapOverlay.CSS_TRANSFORM = (function() {
    var div = document.createElement('div');
    var props = [
      'transform',
      'WebkitTransform',
      'MozTransform',
      'OTransform',
      'msTransform'
    ];

    for (var i = 0; i < props.length; i++) {
      var prop = props[i];
      if (div.style[prop] !== undefined) {
        return prop;
      }
    }
    return props[0];
  })();

  return HeatmapOverlay;
});
(function ()
{
    'use strict';

    angular
        .module('app.question')
        .service('questionService', questionService);

    /** @ngInject */
    function questionService($http, api)
    {
        // Data
        

        // Methods
        this.getPublicQuestions = function(language){
            return $http.get(api.surveyDashboard+'public-questions', { params: { language: language } }).then(function(result) {
                return result;
            });
        }

        this.importSurveyQuestions = function(surveyId, questionIds){
            return $http.post(api.surveyDashboard+'import-survey-questions', 
                                { surveyId: surveyId, questions: questionIds }).then(function(result) {
                return result;
            });
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.process')
        .service('processService', processService);

    /** @ngInject */
    function processService($http, api)
    {
        // Data
        
        // Methods
        this.saveSubgeo = function(subgeoData){
            if(subgeoData.id){//update
                return $http.patch(api.subgeoUrl+'/'+subgeoData.id, subgeoData).then(function(result) {
                    return result;
                });
            }else{//create
                return $http.post(api.subgeoUrl, subgeoData).then(function(result) {
                    return result;
                });
            }            
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.participants')
        .service('participantsService', participantsService);

    /** @ngInject */
    function participantsService($http, api)
    {
        // Data
        

        // Methods
        this.getParticipantsByRegion = function(regionId, userId){
            return $http.get(api.surveyDashboard+'get-participants-by-region', { params: { regionId: regionId, userId: userId } }).then(function(result) {
                return result;
            });
        }

        this.getRoles = function(subgeoId){
            return $http.get(api.surveyDashboard+'get-roles-by-user', { params: { subgeoId: subgeoId } }).then(function(result) {
                return result;
            });
        }

        this.changeParticipantStatus = function(subgeoId, participantId, action){
            return $http.post(api.surveyDashboard+'change-participant-status', { subgeoId: subgeoId, participantId: participantId, action: action }).then(function(result) {
                return result;
            });
        }

        this.assignParticipantRole = function(subgeoId, participantId, role){
            return $http.post(api.surveyDashboard+'assign-participant-role', { subgeoId: subgeoId, participantId: participantId, role: role }).then(function(result) {
                return result;
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.participants')
        .service('participantsDTO', participantsDTO);

    /** @ngInject */
    function participantsDTO()
    {
        //Data

        //Methods
        this.reloadParticipants = null;
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.group')
        .service('groupService', groupService);

    /** @ngInject */
    function groupService($http, api)
    {
        // Data
        

        // Methods
        this.saveGroup = function(groupData){
            if(groupData.id){//update
                return $http.patch(api.groupUrl+'/'+groupData.id, groupData).then(function(result) {
                    return result;
                });
            }else{//create
                return $http.post(api.groupUrl, groupData).then(function(result) {
                    return result;
                });
            }            
        }

        this.deleteGroup = function(groupId){
            return $http.post(api.surveyDashboard+'delete-group', { groupId: groupId }).then(function(result) {
                return result;
            });            
        }

        this.getGroupsByRegion = function(regionId, userId){
            return $http.get(api.surveyDashboard+'get-groups-by-region', { params: { regionId: regionId, userId: userId } }).then(function(result) {
                return result;
            });
        }

        this.saveGroupFilters = function(groupId, filters){
            return $http.post(api.surveyDashboard+'save-group-filters', { groupId: groupId, filters: filters }).then(function(result) {
                return result;
            });            
        }
        
        this.getUsersByRegion = function(regionId){
            return $http.get(api.surveyDashboard+'get-users-by-region', { params: { regionId: regionId } }).then(function(result) {
                return result;
            });
        }

        this.associateUsers = function(groupId, userIds){
            return $http.post(api.surveyDashboard+'associate-users', { groupId: groupId, userIds: userIds }).then(function(result) {
                return result;
            });            
        }

        this.sendNotification = function(groupId, message, schedule){
            return $http.post(api.surveyDashboard+'group-notification', { groupId: groupId, message: message, scheduleInfo: schedule }).then(function(result) {
                return result;
            });            
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.group')
        .service('groupDTO', groupDTO);

    /** @ngInject */
    function groupDTO()
    {
        //Data
        
        
        //Methods
        this.reloadGroups = null;
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.flags')
        .service('flagsService', flagsService);

    /** @ngInject */
    function flagsService($http, api)
    {
        // Data

        // Methods
        this.saveFlag = function(flagData){
            if(flagData.id){//update
                return $http.patch(api.flagUrl+'/'+flagData.id, flagData).then(function(result) {
                    return result;
                });
            }            
        }

        this.getFlagsByRegion = function(regionId){
            return $http.get(api.surveyDashboard+'get-flags-by-region', { params: { regionId: regionId } }).then(function(result) {
                return result;
            });
        }

        this.saveEditedElement = function(data, model){
            if(data.id){//update
                return $http.patch(api.baseUrlApi+'api/default/'+model+'/'+data.id, data).then(function(result) {
                    return result;
                });
            }            
        }

        this.deleteFlaggedElement = function(subgeoId, flagId, action){
            return $http.post(api.surveyDashboard+'delete-flagged-element', { subgeoId: subgeoId, flagId: flagId, action: action }).then(function(result) {
                return result;
            });    
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.flags')
        .service('flagsDTO', flagsDTO);

    /** @ngInject */
    function flagsDTO()
    {
        //Data
        this.removeFlag = null;

        //Methods
        
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'orange',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'amber',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'geofarmer': {
            primary   : {
                name: 'green',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'light-green',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, $location, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            var absUrl = $location.absUrl();

            //Set Label for the domain
            
            if(_.includes(absUrl, 'buergercockpit') || _.includes(absUrl, 'geociudadano') || _.includes(absUrl, 'geocitizen')){

                fuseTheming.setActiveTheme('default');

            }
            else if(_.includes(absUrl, 'geofarmer')){

                fuseTheming.setActiveTheme('geofarmer'); 

            }else{

                fuseTheming.setActiveTheme('default');          
            }
/*
            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }*/
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .service('notificationsDTO', notificationsDTO);

    /** @ngInject */
    function notificationsDTO($mdToast) {
        
        var last = {
            bottom: true,
            top: false,
            left: false,
            right: true
        };

        var toastPosition = angular.extend({}, last);

        this.getToastPosition = function () {
            sanitizePosition();

            return Object.keys(toastPosition)
                .filter(function (pos) { return toastPosition[pos]; })
                .join(' ');
        };

        function sanitizePosition() {
            var current = toastPosition;

            if (current.bottom && last.top) current.top = false;
            if (current.top && last.bottom) current.bottom = false;
            if (current.right && last.left) current.left = false;
            if (current.left && last.right) current.right = false;

            last = angular.extend({}, current);
        }

        this.showSimpleToast = function (text) {
            var pinTo = this.getToastPosition();

            $mdToast.show(
                $mdToast.simple()
                    .textContent(text)
                    .position(pinTo)
                    .hideDelay(3000)
            );
        };

        this.showActionToast = function () {
            var pinTo = this.getToastPosition();
            var toast = $mdToast.simple()
                .textContent('Marked as read')
                .action('UNDO')
                .highlightAction(true)
                .highlightClass('md-accent')// Accent is used by default, this just demonstrates the usage.
                .position(pinTo);

            $mdToast.show(toast).then(function (response) {
                
            });
        };
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('geocitizenDTO', geocitizenDTO);

    /** @ngInject */
    function geocitizenDTO($window)
    {
        this.token = { value: $window.localStorage.getItem('auth_token') };
        this.selectedProject = { id: null, name: null };
        this.userProjects = [];
        this.languages = [{ name: "English", code: 'en' }, { name: "Deutsch", code: 'de' }, { name: "Español", code: 'es' }];
        this.currentLanguage = 'en';
        this.currentLanguageCode = 'en';
        this.privateOptions = { showOptions: true, reloadPublicResults: true };
        this.changeLanguage = null;
        this.defaultRoute = null;
        this.style = { topBgClass : "general-blue", bgClass: "orange-bg", textColorPrimary: "orange-text" };

        //Get user information from localstorage
        try {
            this.user = JSON.parse($window.localStorage.getItem('user'));
        }
        catch(err) {
            this.user = {};
        }
        //get profile information from localstorage
        try {
            this.profile = JSON.parse($window.localStorage.getItem('profile'));
        }
        catch(err) {
            this.profile = {};
        }
        
        //Methods
        this.reloadUserData = function(){
            this.token = { value: $window.localStorage.getItem('auth_token') };
            this.user = JSON.parse($window.localStorage.getItem('user'));
            this.profile = JSON.parse($window.localStorage.getItem('profile'));
        }

        this.getHeaders = function(jsonType, multipart){
            var headers = { headers: {} };

            if(jsonType){
                headers.headers['Content-Type'] = 'application/json';
            }else if (multipart) {
                headers.headers['Content-Type'] = 'multipart/form-data';
            }

            return headers;
        }

        this.clearData = function(){
            this.profile = {};
            this.user = {};
            this.userProjects = [];
            this.token = { value: null };
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('domainService', domainService);

    /** @ngInject */
    function domainService($http, api, geocitizenDTO)
    {        
        this.getDomains = function(domain){
            var config = geocitizenDTO.getHeaders(true);
            // return the same promise that $http.get returns
            return $http.post(api.surveyDashboard + 'get-modules-by-domain', { domain: domain }, config).then(function(result) {
                return result;
            });
        } 
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('authService', authService);

    /** @ngInject */
    function authService($http, api, geocitizenDTO)
    {
        //Check if the session is valid
        this.checkSession = function(){
            // return the same promise that $http.get returns
            return $http.post(api.authUrl+'check-session', {}).then(function(result) {
                return result;
            });
        }

        //login 
        this.doLogin = function(data){
            var config = geocitizenDTO.getHeaders(true);
            // return the same promise that $http.get returns
            return $http.post(api.authUrl+'login', data, config).then(function(result) {
                return result;
            });
        } 

        this.doSignup = function(data){
            // return the same promise that $http.get returns
            /*return $http.post(api.authUrl+'register', {"email":"camiloess@gmail.com",
                                            "password":"123456",
                                            "first_name":"abc",
                                            "last_name":"def",
                                            "locale":"en"}).then(function(result) {
                return result;
            });*/
        } 

        this.updatePassword = function(data){
            var config = geocitizenDTO.getHeaders(true);
            // return the same promise that $http.get returns
            return $http.post(api.authUrl+'change-password', data, config).then(function(result) {
                return result;
            });
        } 

        this.recoverPassword = function(data){
            var config = geocitizenDTO.getHeaders(true);
            // return the same promise that $http.get returns
            return $http.post(api.authUrl+'forgot-password', data, config).then(function(result) {
                return result;
            });
        }

        //Logout 
        this.doLogout = function(){
            // return the same promise that $http.get returns
            return $http.post(api.authUrl+'logout', {}).then(function(result) {
                return result;
            });
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('authInterceptor', authInterceptor);

    /** @ngInject */
    function authInterceptor($q, $injector, $location, geocitizenDTO) {
      return {
        request: function (config) {
          if(geocitizenDTO.token.value && !config.url.includes("s3.amazonaws.com")){
            config.headers['Authorization'] = "Bearer "+geocitizenDTO.token.value;
          }         
          config.headers['App-Url'] = $location.host();
          
          return config;
        },
        responseError: function (rejection) {
          switch (rejection.status) {
              case 401: case 403:
                  $injector.get('$state').go('app.login'); 
                  break;
          }

          return $q.reject(rejection);
        }
      }
    }
}());
angular.module("app.config", [])
.constant("configValues", {"https":"false","domain":"geocitizen.org","clientPrefix":"app","apiPrefix":"api","uploadsPrefix":"uploads","staticPrefix":"static","defaultLanguage":"de","defaultRegion":"1","apiDevelopment":"http://localhost:8000/"});

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('objectToArray', objectToArray);

    /** @ngInject */
    function objectToArray()
    {
        return function(obj) {
            return _.toArray(obj);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('iframeOnload', iframeOnload);

    /** @ngInject */
    function iframeOnload($timeout)
    {
        return {
            restrict: "A",
            scope: {
                callback: "&iframeOnload"
            },
            link: function (scope, element, attrs) {
                element.on("load", function (event) {
                    element.context.style.height = '0px';
                    $timeout(function(){
                        element.context.style.height = event.target.contentDocument.documentElement.scrollHeight+'px';
                        scope.callback({ event: event });
                    }, 300);                    
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'E',
            compile : function (element, attr)
            {
                var code;
                //No attribute? code is the content
                if ( !attr.code )
                {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr)
                {

                    if ( attr.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, $mdPanel, msNavigationService, api, 
                               geocitizenDTO, surveyDTO, authService, configValues, $window, $location, fuseTheming)
    {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        //Set the selected project
        vm.selectedProject = geocitizenDTO.selectedProject;
        vm.user = geocitizenDTO.user;
        vm.domain = configValues.domain.split('.')[0];
        vm.privateOptions = geocitizenDTO.privateOptions;
        vm.loadingSubgeos = true;
        vm.toolbarBackgroundClass = 'general-blue';

        vm.bodyEl = angular.element('body');
        
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us',
                'value'      : 1
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es',
                'value'      : 2
            },
            de: {
                'title'      : 'Deutsch',
                'translation': 'TOOLBAR.GERMAN',
                'code'       : 'de',
                'flag'       : 'de',
                'value'      : 3
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.changeSelectedProject = changeSelectedProject;

        geocitizenDTO.changeLanguage = changeLanguage;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            //get absolute url
            var absUrl = $location.absUrl();

            //Set Label for the domain
            vm.domainLabel = 'Geocitizen';
            if(_.includes(absUrl, 'buergercockpit')){

                vm.domainLabel = 'Bürgercockpit';

            }else if(_.includes(absUrl, 'geociudadano')){

                vm.domainLabel = 'Geociudadano';
            }
            else if(_.includes(absUrl, 'geofarmer')){
                vm.domainLabel = 'Geofarmer';
                vm.toolbarBackgroundClass = 'green-bg';
                geocitizenDTO.style.topBgClass = 'green-bg';
                geocitizenDTO.style.bgClass = 'green-bg';
                geocitizenDTO.style.textColorPrimary = 'green-text';
            }
            
            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[geocitizenDTO.currentLanguageCode];//$translate.preferredLanguage()];
            geocitizenDTO.currentLanguage = vm.selectedLanguage.value;
            geocitizenDTO.currentLanguageCode = vm.selectedLanguage.code;

            //apply language
            //$translate.use(geocitizenDTO.currentLanguageCode);

            // Get the regions list
            if(geocitizenDTO.user && geocitizenDTO.user.id){
                api.regions.get({ userId: geocitizenDTO.user.id },
                    // Success
                    function (response)
                    {
                        vm.regions = response.data;
                        geocitizenDTO.userProjects = vm.regions;
                        vm.loadingSubgeos = false;
                    },
                    // Error
                    function (response)
                    {
                        vm.loadingSubgeos = false;
                        console.error(response);
                    }
                );
            }            
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {
            geocitizenDTO.clearData();
            authService.doLogout().then(finishLogout, finishLogout);

            function finishLogout(result) {
                $window.localStorage.clear();
                $state.go('app.login');
            }
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;
            
            // Change the language
            $translate.use(lang.code);

            $window.localStorage.setItem('selectedLanguage', lang.code);
            geocitizenDTO.currentLanguage = lang.value;
            geocitizenDTO.currentLanguageCode = lang.code;

            //reload current state
            $state.go($state.current.name, null, {reload: $state.current.name});
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }

        /**
         * Change selected project
         */
        function changeSelectedProject(){
            geocitizenDTO.selectedProject = vm.selectedProject;
            vm.userRole = $translate.instant('TOOLBAR.ROLE_'+vm.selectedProject.role.id);

            $state.go(geocitizenDTO.defaultRoute);
            if(surveyDTO.reloadSurveys) surveyDTO.reloadSurveys();
        }

        vm.showProfileMenu = function(ev) {
            var position = $mdPanel.newPanelPosition()
            .relativeTo('.profile-menu-btn')
            .addPanelPosition($mdPanel.xPosition.ALIGN_START, $mdPanel.yPosition.BELOW);

            var config = {
                attachTo: angular.element(document.body),
                controller: 'ProfileController',
                controllerAs: 'vm',
                templateUrl: 'app/main/auth/profile/profile.html',
                panelClass: 'profile-panel',
                position: position,
                openFrom: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 2
            };

            $mdPanel.open(config);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick panel
            'app.quick-panel',

            // Surveys
            'app.survey',
            'app.survey_new',

            //questions
            'app.question',

            //RESULTS
            'app.results',

            //Auth
            'app.auth.login',
            'app.auth.forgot-password',
            'app.auth.reset-password',
            'app.auth.register',
            'app.auth.profile',

            //Config
            'app.config',

            //Groups
            'app.group',

            //Process
            'app.process',

            //Participants
            'app.participants',

            //Flags
            'app.flags',

            //workflow
            "app.workflow",

            //Reports
            "app.reports",

            //Charts
            'gridshore.c3js.chart',

            'ADM-dateTimePicker',

            'ngFileUpload',

            'ngSanitize'
        ]);
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, authService, $window, $state, $stateParams, $location, msNavigationService, domainService, geocitizenDTO, fuseTheming)
    {
        // Data
        var vm = this;

        vm.publicResults = false;

        //get absolute url
        var absUrl = $location.absUrl();

        //Set Label for the domain
        if(_.includes(absUrl, 'public-results') || _.includes(absUrl, 'print-results') || _.includes(absUrl, 'public-reports')){
            vm.publicResults = true;
        }

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                //Check session token
                if($window.localStorage.getItem('auth_token') && !vm.publicResults){
                    authService.checkSession().then(function(result) {
                        if(result.data && result.data.success){
                            
                            showModules();
                        }else{
                            $state.go('app.login');
                            $rootScope.$broadcast('msSplashScreen::remove');
                        }                                                
                        
                    }, function(error) {
                        $state.go('app.login');                       
                        $rootScope.$broadcast('msSplashScreen::remove');
                    });
                }else{
                    $rootScope.$broadcast('msSplashScreen::remove');
                }                
            }
        });

        

        function showModules(){

            var modulesArray = {
                flags : {
                    title    : 'Flags',
                    icon     : 'icon-flag-variant',
                    state    : 'app.flags',
                    translate: 'FLAGS.FLAGS_NAV',
                    weight   : 1
                },
                groups : {
                    title    : 'Groups',
                    icon     : 'icon-people',
                    state    : 'app.group',
                    translate: 'GROUP.GROUP_NAV',
                    weight   : 1
                },
                participants : {
                    title    : 'Participants',
                    icon     : 'icon-account',
                    state    : 'app.participants',
                    translate: 'PARTICIPANTS.PARTICIPANTS_NAV',
                    weight   : 1
                },
                process : {
                    title    : 'Process',
                    icon     : 'icon-sync',
                    state    : 'app.process',
                    translate: 'PROCESS.PROCESS',
                    weight   : 1
                },
                questions : {
                    title    : 'Question-library',
                    icon     : 'icon-message-text',
                    state    : 'app.question',
                    translate: 'QUESTION.QUESTION_LIBRARY',
                    weight   : 1
                },
                results : {
                    title    : 'Data-view',
                    icon     : 'icon-chart-pie',
                    state    : 'app.results',
                    translate: 'TOOLBAR.DATA_VIEW',
                    weight   : 1
                },
                surveys : {
                    title    : 'Survey-forms',
                    icon     : 'icon-clipboard-outline',
                    state    : 'app.survey',
                    /*stateParams: {
                        'param1': 'page'
                    },*/
                    translate: 'SURVEY.SURVEY_NAV',
                    weight   : 1
                },
                surveys_new : {
                    title    : 'Survey-forms',
                    icon     : 'icon-clipboard-outline',
                    state    : 'app.survey-new',
                    /*stateParams: {
                        'param1': 'page'
                    },*/
                    translate: 'SURVEY.SURVEY_NAV',
                    weight   : 1
                },
                workflow : {
                    title    : 'Data-calculator',
                    icon     : 'icon-calculator',
                    state    : 'app.workflow',
                    /*stateParams: {
                        'param1': 'page'
                    },*/
                    translate: 'WORKFLOW.WORKFLOW_NAV',
                    weight   : 1
                },
                reports : {
                    title    : 'Reports',
                    icon     : 'icon-poll',
                    state    : 'app.reports',
                    /*stateParams: {
                        'param1': 'page'
                    },*/
                    translate: 'REPORTS.REPORTS_NAV',
                    weight   : 1
                }
            };

            domainService.getDomains($location.host()).then(function(result) {
                var modules = result.data;

                modules.forEach(function(module){
                    if(modulesArray[module.name]){
                        // Navigation
                        msNavigationService.saveItem(module.name, modulesArray[module.name]);

                        if(!geocitizenDTO.defaultRoute){
                            geocitizenDTO.defaultRoute = modulesArray[module.name].state;
                        }
                    }
                });

                if(_.includes(absUrl, 'login')){
                    $state.go(geocitizenDTO.defaultRoute);
                }
                
                $rootScope.$broadcast('msSplashScreen::remove');
            });
/*
            // Navigation
            msNavigationService.saveItem('flags', {
                title    : 'Flags',
                icon     : 'icon-flag-variant',
                state    : 'app.flags',
                translate: 'FLAGS.FLAGS_NAV',
                weight   : 1
            });

            msNavigationService.saveItem('groups', {
                title    : 'Groups',
                icon     : 'icon-people',
                state    : 'app.group',
                translate: 'GROUP.GROUP_NAV',
                weight   : 1
            });

            msNavigationService.saveItem('participants', {
                title    : 'Participants',
                icon     : 'icon-account',
                state    : 'app.participants',
                translate: 'PARTICIPANTS.PARTICIPANTS_NAV',
                weight   : 1
            });

            // Navigation
            msNavigationService.saveItem('process', {
                title    : 'Process',
                icon     : 'icon-sync',
                state    : 'app.process',
                translate: 'PROCESS.PROCESS',
                weight   : 1
            });

            // Navigation
            msNavigationService.saveItem('questions', {
                title    : 'Question-library',
                icon     : 'icon-message-text',
                state    : 'app.question',
                translate: 'QUESTION.QUESTION_LIBRARY',
                weight   : 1
            });
            
            // Navigation
            msNavigationService.saveItem('results', {
                title    : 'Data-view',
                icon     : 'icon-chart-pie',
                state    : 'app.results',
                translate: 'TOOLBAR.DATA_VIEW',
                weight   : 1
            });

            // Navigation
            msNavigationService.saveItem('surveys', {
                title    : 'Survey-forms',
                icon     : 'icon-clipboard-outline',
                state    : 'app.survey',
                /*stateParams: {
                    'param1': 'page'
                },/
                translate: 'SURVEY.SURVEY_NAV',
                weight   : 1
            });

            // Navigation
            msNavigationService.saveItem('surveys_new', {
                title    : 'Survey-forms',
                icon     : 'icon-clipboard-outline',
                state    : 'app.survey-new',
                /*stateParams: {
                    'param1': 'page'
                },/
                translate: 'SURVEY.SURVEY_NAV',
                weight   : 1
            });*/

        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, geocitizenDTO)
    {
        var vm = this;
        vm.privateOptions = geocitizenDTO.privateOptions;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig, geocitizenDTO, $translate)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);
        
        var lang = 'en';
        switch (window.localStorage.getItem('selectedLanguage')) {
            case "es": case "de":
                lang = window.localStorage.getItem('selectedLanguage');
                break;
        }

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'app/data/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage(lang);
        $translateProvider.useSanitizeValueStrategy('escape');

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, $window, $location)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams)
        {
            $rootScope.loadingProgress = true;

            //check if the route needs authentication
            if ( toState.authenticate ) {
                // Check for the token
                if ( !$window.localStorage.getItem('auth_token') ) {
                    $state.go('app.login');
                }
            } 
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        //get absolute url
        var absUrl = $location.absUrl();

        //Set Label for the domain
        $rootScope.domainLabel = 'Geocitizen';
        if(_.includes(absUrl, 'buergercockpit')){
            $rootScope.domainLabel = 'Bürgercockpit';

        }else if(_.includes(absUrl, 'geociudadano')){
            $rootScope.domainLabel = 'Geociudadano';

        }else if(_.includes(absUrl, 'geofarmer')){
            $rootScope.domainLabel = 'Geofarmer';
        }

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(false);

        $urlRouterProvider.otherwise('/auth/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = /*$cookies.get('layoutStyle') ||*/ 'horizontalNavigation';


        var currentUrl = window.location.href;

        if(_.includes(currentUrl, 'print-results')){
            layoutStyle = 'contentOnly';
        }
        else if(_.includes(currentUrl, 'public-reports')){
            layoutStyle = 'contentWithToolbar';
        }

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming, authService, $state, configValues, geocitizenDTO, $translate, $location)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //check if default language is available
        //get url
        var absUrl = $location.absUrl();

        var langCode = 'en';
        //check if default language is available
        if(_.includes(absUrl, 'buerger')){
            langCode = 'de';
        }else if(_.includes(absUrl, 'geociudadano')){
            langCode = 'es';
        }

        geocitizenDTO.currentLanguage = langCode;
        geocitizenDTO.currentLanguageCode = langCode;

        // Change the language
        $translate.use(langCode);
        
        /*if(configValues.defaultLanguage){
            var langCode = configValues.defaultLanguage.split('_')[0];
            // Change the language
            $translate.use(langCode);
        }*/
    }
})();

var mapMgr = new leafletMgr();//Leaflet manager
(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($httpProvider)
    {
        // Put your custom configurations here
        //$httpProvider.defaults.withCredentials = true;
        $httpProvider.interceptors.push('authInterceptor');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource, $location, configValues)
    {
        var api = { baseUrl: '', baseUrlApi: '' };

        //get absolute url
        var absUrl = $location.absUrl();
        var domain = 'geocitizen.org';
        var modelsFolder = "default/";

        //Set https / http
        if(_.includes(absUrl, 'test')){
            api.baseUrlApi = 'http://test.';
        }else{
            api.baseUrlApi = 'https://api.';
        }

        //Add the api prefix
        api.baseUrlApi += domain + '/';

        //if apiDevelopment is present we use that one for baseUrl
        if (_.includes(absUrl, 'localhost')) {
            api.baseUrlApi = configValues.apiDevelopment;

            //modelsFolder = "defaultapp/Geofarmer/";
        }
        
        //to know if the platform will use groups for the users
        api.useGroups = true;

        if (_.includes(absUrl, 'geofarmer') || _.includes(absUrl, 'localhost')) {
            modelsFolder = "defaultapp/Geofarmer/";
            api.useGroups = false;
        }

        // Base Url
        api.fileManagementUrl = api.baseUrlApi+'api/fileManagement';
        api.authUrl = api.baseUrlApi+'api/';
        api.surveyUrl = api.baseUrlApi+'api/'+modelsFolder+'Survey';
        api.questionUrl = api.baseUrlApi+'api/'+modelsFolder+'SurveyQuestion';
        api.questionChoiceUrl = api.baseUrlApi+'api/'+modelsFolder+'SurveyChoice';
        api.questionConfigUrl = api.baseUrlApi+'api/'+modelsFolder+'SurveyConfiguration';
        api.questionGuardUrl = api.baseUrlApi+'api/'+modelsFolder+'SurveyConfigurationGuard';
        api.groupUrl = api.baseUrlApi+'api/'+modelsFolder+'Group';
        api.surveyDashboard = api.baseUrlApi+'api/surveyDashboard/';
        api.subgeoUrl = api.baseUrlApi+'api/'+modelsFolder+'Subgeo';
        api.flagUrl = api.baseUrlApi+'api/'+modelsFolder+'FlaggedEntry';
        api.workflowUrl = api.baseUrlApi+'api/'+modelsFolder+'Workflow';
        api.workflowVariableUrl = api.baseUrlApi+'api/'+modelsFolder+'WorkflowVariable';
        api.reportUrl = api.baseUrlApi+'api/'+modelsFolder+'Report';

        //resources
        api.regions = $resource( api.baseUrlApi+'api/surveyDashboard/regions' );
        api.languages = $resource( api.baseUrlApi+'api/'+modelsFolder+'Language' );
        api.surveys = $resource( api.baseUrlApi+api.surveyAction );

        return api;
    }

})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div id=\"content-container\" flex \nlayout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex \nng-if=\"vm.publicResults\" style=\"top: -10px\"></md-content><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" \nms-scroll ui-view=\"content\" flex ng-if=\"!vm.publicResults\"></md-content></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" ms-scroll \nng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/main/flags/views/flags.html","<div id=\"groups\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-if=\"vm.selectedProject.id\"><div class=\"top-bg\" \nng-class=\"vm.topBgClass\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clipboard-outline\"></md-icon><span \ntranslate=\"GROUP.GROUPS_IN\">Groups in</span>&nbsp; <span class=\"capitalize\">{{vm.selectedProject.name}}</span></div>\n</div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SURVEY.SEARCH\" flex></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"FLAGS.USER\">User</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"FLAGS.FLAG_ITEM\">\nFlag Item</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"FLAGS.REASON\">Reason</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"FLAGS.DESCRIPTION\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"FLAGS.SEEN_MOD\">Seen by Mod.</span></div></th><th \nclass=\"secondary-text\" style=\"max-width: 300px\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SHARED.ACTIONS\">Actions</span></div></th></tr></thead><tbody><tr ng-repeat=\"flag in vm.flags\"><td>\n{{flag.user.first_name}} {{flag.user.last_name}}</td><td><button class=\"gray-md-icon-btn\" aria-label=\"show flag\" \nng-click=\"vm.gotoEditItem(flag, false)\"><md-icon md-font-icon=\"icon-eye\"></md-icon></button>\n ({{flag.flag.id}}) {{flag.uploadable_type.split(\'\\\\\').pop()}}</td><td>{{flag.flag[vm.currentLanguageCode]}}</td><td>\n<button class=\"gray-md-icon-btn\" aria-label=\"show flag\" ng-click=\"vm.gotoFlagDescription(flag)\"><md-icon \nmd-font-icon=\"icon-eye\"></md-icon></button> <span translate=\"FLAGS.SHOW\"></span></td><td><md-icon \nng-if=\"!flag.seen_by_mod\" md-font-icon=\"icon-checkbox-blank-circle-outline\"></md-icon><md-icon \nng-if=\"flag.seen_by_mod\" md-font-icon=\"icon-checkbox-marked-circle\"></md-icon></td><td style=\"max-width: 300px\">\n<md-menu><button class=\"gray-md-icon-btn\" aria-label=\"Open menu\" ng-click=\"$mdOpenMenu()\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></button><md-menu-content width=\"4\"><md-menu-item><md-button \nng-click=\"vm.gotoEditItem(flag, true)\" aria-label=\"Assign role\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\">\n</md-icon><span translate=\"FLAGS.EDIT\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.flagChange(flag, \'delete\')\" aria-label=\"delete flag\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\">\n</md-icon><span translate=\"FLAGS.DELETE\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.flagChange(flag, \'ignore\')\" aria-label=\"ignore flag\"><md-icon md-font-icon=\"icon-block-helper\" \nclass=\"s16\"></md-icon><span translate=\"FLAGS.IGNORE_FLAG\"></span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr></tbody></table></div></div></div></div><div ng-if=\"!vm.selectedProject.id\" class=\"padding-30\">\n<md-whiteframe class=\"md-whiteframe-3dp padding-50 red-100-bg\" layout layout-align=\"center center\"><span \ntranslate=\"SURVEY.SELECT_PROJECT\">Please select one project.</span></md-whiteframe></div>");
$templateCache.put("app/main/auth/login-v2/login-v2.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex hide show-gt-sm><div class=\"logo\">\n<span><img src=\"/assets/images/logos/geocitizen.png\"></span></div><div class=\"title\" translate=\"LOGIN.INTRO_TITLE\">\nWelcome to the Geocitizen!</div><div class=\"description\" translate=\"LOGIN.INTRO_DESCRIPTION\">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div><div id=\"login-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div \nid=\"login-v2-form\"><div class=\"logo\" hide-gt-sm><span><img src=\"/assets/images/logos/geocitizen.png\"></span></div><div \nclass=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div><div class=\"description\" \ntranslate=\"LOGIN.DESCRIPTION\">Sed mollis velit facilisis facilisis viverra</div><form name=\"loginForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.login.email\" \nplaceholder=\"Email\" translate translate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.login.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.PASSWORD\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">Remember Me</span>\n</md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><div layout=\"column\" ng-if=\"vm.showErrorMsg\"><span><span \nclass=\"text error-msg\">{{ vm.errorMsg }}</span></span></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \nng-click=\"vm.doLogin()\" translate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form><div\n layout=\"column\"><span><span class=\"text\" translate=\"LOGIN.DONT_HAVE_ACCOUNT\">No account?</span> <a \nhref=\"mailto:contact@geocitizen.org?Subject=Geocitizen Account\" target=\"_top\" class=\"link\">contact@geocitizen.org</a>\n</span></div></div></div></div>");
$templateCache.put("app/main/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo\"><span><img src=\"/assets/images/logos/geocitizen.png\"></span></div><div class=\"title\" \ntranslate=\"FORGOTPASSWORD.TITLE\">Recover your password</div><form name=\"forgotPasswordForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"Email address\" translate translate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">\nEmail field is required</span></div><div ng-message=\"pattern\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container><div layout=\"column\" ng-if=\"vm.showMsg\">\n<span><span class=\"text error-msg\">{{ vm.resultMsg }}</span></span></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" translate=\"FORGOTPASSWORD.SEND_RESET_LINK\" \ntranslate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\" ng-click=\"vm.recoverPassword()\">SEND RESET LINK</md-button>\n</form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.login\" \ntranslate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/auth/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\">\n<span><img src=\"/assets/images/logos/geocitizen.png\"></span></div><div class=\"title\" translate=\"RESETPASSWORD.TITLE\">\nReset your password</div><form name=\"resetPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float>\n<input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"resetPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"RESETPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"RESETPASSWORD.PASSWORD\" \nrequired><div ng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.PASSWORD_CONFIRM\" required><div \nng-messages=\"resetPasswordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"UPDATE MY PASSWORD\" ng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" \ntranslate=\"RESETPASSWORD.UPDATE_PASSWORD\" translate-attr-aria-label=\"RESETPASSWORD.UPDATE_PASSWORD\">RESET MY PASSWORD\n</md-button></form></div></div></div>");
$templateCache.put("app/main/auth/register-v2/register-v2.html","<div id=\"register-v2\" layout=\"row\" layout-align=\"start\"><div id=\"register-v2-intro\" flex hide show-gt-sm><div \nclass=\"logo\"><span><img src=\"/assets/images/logos/geocitizen.png\"></span></div><div class=\"title\" \ntranslate=\"REGISTER.INTRO_TITLE\">Welcome to the Geocitizen!</div><div class=\"description\" \ntranslate=\"REGISTER.INTRO_DESCRIPTION\">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div><div id=\"register-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex \nms-scroll><div id=\"register-v2-form\"><div class=\"logo md-accent-bg\" hide-gt-sm><span><img \nsrc=\"/assets/images/logos/geocitizen.png\"></span></div><div class=\"title\" translate=\"REGISTER.TITLE\">Create an account\n</div><form name=\"registerForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input name=\"firstname\" \nng-model=\"vm.signup.data.attributes.first_name\" placeholder=\"Firstname\" translate \ntranslate-attr-placeholder=\"REGISTER.NAME\" required><div ng-messages=\"registerForm.firstname.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"REGISTER.ERRORS.USERNAME_REQUIRED\">Firstname field is required</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><input name=\"lastname\" \nng-model=\"vm.signup.data.attributes.last_name\" placeholder=\"Lastname\" translate \ntranslate-attr-placeholder=\"REGISTER.LASTNAME\" required><div ng-messages=\"registerForm.lastname.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.LASTNAME_REQUIRED\">Lastname field is required</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" \nng-model=\"vm.signup.data.attributes.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"REGISTER.EMAIL\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.signup.data.attributes.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"REGISTER.PASSWORD\" required><div ng-messages=\"registerForm.password.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"passwordConfirm\" ng-model=\"vm.signup.data.attributes.passwordConfirm\" placeholder=\"Password (Confirm)\" translate \ntranslate-attr-placeholder=\"REGISTER.PASSWORD_CONFIRM\" required><div ng-messages=\"registerForm.passwordConfirm.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">\nPassword (Confirm) field is required</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" ng-click=\"vm.doSignup()\" \ntranslate=\"REGISTER.CREATE_ACCOUNT\" translate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button>\n</form><div class=\"login\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" \ntranslate=\"REGISTER.ALREADY_HAVE\">Already have an account?</span> <a class=\"link\" ui-sref=\"app.login\" \ntranslate=\"REGISTER.LOGIN\">Log in</a></div></div></div></div>");
$templateCache.put("app/main/group/views/group.html","<div id=\"groups\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-if=\"vm.selectedProject.id\"><div class=\"top-bg\" \nng-class=\"vm.topBgClass\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clipboard-outline\"></md-icon><span \ntranslate=\"GROUP.GROUPS_IN\">Groups in</span>&nbsp; <span class=\"capitalize\">{{vm.selectedProject.name}}</span></div>\n</div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SURVEY.SEARCH\" flex></div></div><div id=\"group-buttons\">\n<md-button id=\"new-group-btn\" class=\"md-fab md-primary\" aria-label=\"New survey\" ng-click=\"vm.gotoGroupDetail()\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"GROUP.TITLE\">Title</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"GROUP.DESCRIPTION\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"GROUP.USERS\">Users</span></div>\n</th><th class=\"secondary-text\" style=\"max-width: 300px\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"GROUP.ACTIONS\">Actions</span></div></th></tr></thead><tbody><tr ng-repeat=\"group in vm.groups\"><td>\n{{group.name}}</td><td>{{group.description}}</td><td>{{group.users.length}}</td><td style=\"max-width: 300px\"><md-menu>\n<button class=\"gray-md-icon-btn\" aria-label=\"Open menu\" ng-click=\"$mdOpenMenu()\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon></button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"vm.gotoGroupDetail(group)\" \naria-label=\"Group details\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><span translate=\"SURVEY.EDIT\">\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.gotoNotificationDetail(group)\" \naria-label=\"Notification details\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon><span \ntranslate=\"GROUP.SEND_NOTIFICATION\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.deleteGroup(group)\" aria-label=\"delete group\"><md-icon md-font-icon=\"icon-file-document-box\" class=\"s16\">\n</md-icon><span translate=\"GROUP.DELETE\"></span></md-button></md-menu-item></md-menu-content></md-menu></td></tr>\n</tbody></table></div></div></div></div><div ng-if=\"!vm.selectedProject.id\" class=\"padding-30\"><md-whiteframe \nclass=\"md-whiteframe-3dp padding-50 red-100-bg\" layout layout-align=\"center center\"><span \ntranslate=\"SURVEY.SELECT_PROJECT\">Please select one project.</span></md-whiteframe></div>");
$templateCache.put("app/main/auth/profile/profile.html","<div class=\"profile\" aria-label=\"Profile\"><div class=\"triangle\" data-reactid=\".0.1.0.0.0.0.2.1.3.0\"><span></span></div>\n<div class=\"top-bar\"><span ng-if=\"vm.options\">{{vm.user.first_name}} {{vm.user.last_name}}</span> <span \nng-if=\"!vm.options\" translate=\"PROFILE.CONFIGURATION\">Configuration</span></div><div ng-if=\"vm.options\" \nclass=\"margin-top-10\" layout=\"column\"><md-button class=\"gray-light2-btn button-text-left md-raised\" \naria-label=\"Profile\" ng-click=\"\"><md-icon md-svg-src=\"assets/images/profile/profile-white.svg\"></md-icon><span \ntranslate=\"PROFILE.YOUR_PROFILE\">Your Profile</span></md-button><md-button \nclass=\"gray-light2-btn button-text-left md-raised\" aria-label=\"Profile\" ng-click=\"vm.options = !vm.options\"><md-icon \nmd-svg-src=\"assets/images/profile/config-white.svg\"></md-icon><span translate=\"PROFILE.CONFIGURATION\">Configuration\n</span></md-button><div class=\"margin-top-10\" layout=\"row\" layout-align=\"space-around center\"><md-button flex=\"90\" \nclass=\"md-primary md-raised\" aria-label=\"Logout\" ng-click=\"vm.logout()\"><span translate=\"TOOLBAR.LOGOUT\">Logout</span>\n</md-button></div></div><div ng-if=\"!vm.options && !vm.password\" class=\"margin-top-10\" layout=\"column\"><div \nlayout=\"row\" class=\"padding-15\"><div flex class=\"white-text padding-top-5\"><strong><span \ntranslate=\"PROFILE.INTERFACE_LANGUAGE\">Language</span></strong></div><div flex layout=\"column\"><md-select flex \nclass=\"white-select-bg\" ng-model=\"vm.selectedLanguage\" ng-change=\"vm.changeSelectedLanguage()\" aria-label=\"Project\">\n<md-option ng-repeat=\"language in vm.languages\" ng-value=\"language\">{{language.title}}</md-option></md-select></div>\n</div><div layout=\"row\" class=\"padding-15\"><div flex class=\"white-text padding-top-10\"><strong><span \ntranslate=\"PROFILE.PASSWORD\">Password</span></strong></div><div flex layout=\"column\"><md-button flex \nclass=\"md-primary no-margin md-raised\" aria-label=\"password\" translate=\"PROFILE.CHANGE\" ng-click=\"vm.password = true\">\n</md-button></div></div><div layout=\"row\" class=\"padding-15\"><div flex class=\"white-text padding-top-10\"></div><div \nflex layout=\"column\"><md-button flex class=\"gray-light-btn no-margin md-raised\" aria-label=\"password\" \ntranslate=\"PROFILE.CLOSE\" ng-click=\"vm.closePanel()\"></md-button></div></div></div><div \nng-if=\"!vm.options && vm.password\" class=\"margin-top-10\" layout=\"column\"><form name=\"newPasswordForm\"><div \nlayout=\"row\" class=\"padding-15\"><div flex class=\"white-text padding-top-5\"><strong><span \ntranslate=\"PROFILE.CURRENT_PASSWORD\">Current password</span></strong></div><div flex layout=\"column\">\n<md-input-container class=\"white-small-input\"><input ng-model=\"vm.passwords.currentPassword\" type=\"password\" required>\n</md-input-container></div></div><div layout=\"row\" class=\"padding-15\"><div flex class=\"white-text padding-top-5\">\n<strong><span translate=\"PROFILE.NEW_PASSWORD\">New password</span></strong></div><div flex layout=\"column\">\n<md-input-container class=\"white-small-input\"><input ng-model=\"vm.passwords.newPassword\" type=\"password\" required>\n</md-input-container></div></div><div layout=\"row\" class=\"padding-15\"><div flex class=\"white-text padding-top-5\">\n<strong><span translate=\"PROFILE.CONFIRM_PASSWORD\">Confirm password</span></strong></div><div flex layout=\"column\">\n<md-input-container class=\"white-small-input\"><input ng-model=\"vm.passwords.confirmPassword\" type=\"password\" required>\n</md-input-container></div></div><div ng-if=\"vm.errorMsg\" layout=\"row\" class=\"msg-error\">{{ vm.errorMsg }}</div><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"padding-15\"><div flex=\"45\" layout=\"column\"><md-button flex \nclass=\"gray-light-btn no-margin md-raised\" aria-label=\"password\" translate=\"PROFILE.CLOSE\" ng-click=\"vm.closePanel()\">\n</md-button></div><div flex=\"45\" layout=\"column\"><md-button flex class=\"md-primary no-margin md-raised\" \naria-label=\"password\" translate=\"PROFILE.SAVE\" ng-click=\"vm.updatePassword()\" ng-disabled=\"newPasswordForm.$invalid\">\n</md-button></div></div></form></div></div>");
$templateCache.put("app/main/participants/views/participants.html","<div id=\"groups\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-if=\"vm.selectedProject.id\"><div class=\"top-bg\" \nng-class=\"vm.topBgClass\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clipboard-outline\"></md-icon><span \ntranslate=\"PARTICIPANTS.PARTICIPANTS_IN\">Groups in</span>&nbsp; <span class=\"capitalize\">{{vm.selectedProject.name}}\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"SURVEY.SEARCH\" flex></div>\n</div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead>\n<tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SHARED.FIRST_NAME\">Name\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SHARED.LAST_NAME\">Surname</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"SHARED.BIRTHYEAR\">Birth</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SHARED.GENDER\">Gender</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SHARED.EMAIL\">Mail</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SHARED.REQUEST\">Request\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SHARED.STATUS\">Status</span></div></th><th class=\"secondary-text\" style=\"max-width: 300px\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SHARED.ACTIONS\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"participant in vm.participants\"><td>{{participant.user.first_name}}</td><td>\n{{participant.user.last_name}}</td><td>{{participant.user.profile.birth_year}}</td><td><span \nng-if=\"participant.user.profile.gender\">{{vm.genders[participant.user.profile.gender]}}</span> <span \nng-if=\"!participant.user.profile.gender\">{{vm.genders[\'empty\']}}</span></td><td>{{participant.user.email}}</td><td \nclass=\"orange-text\">{{vm.requests[participant.role_id]}}</td><td>{{vm.statuses[participant.status]}}</td><td \nstyle=\"max-width: 300px\"><md-menu><button class=\"gray-md-icon-btn\" aria-label=\"Open menu\" ng-click=\"$mdOpenMenu()\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></button><md-menu-content width=\"4\"><md-menu-item \nng-if=\"participant.status == \'accepted\'\"><md-button ng-click=\"vm.assignRole(participant)\" aria-label=\"Assign role\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><span translate=\"PARTICIPANTS.ASSIGN_ROLE\"></span>\n</md-button></md-menu-item><md-menu-item ng-if=\"participant.status == \'requested\'\"><md-button \nng-click=\"vm.changeStatus(participant, \'deny\')\" aria-label=\"Deny user\"><md-icon md-font-icon=\"icon-block-helper\" \nclass=\"s16\"></md-icon><span translate=\"PARTICIPANTS.DENY_USER\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"participant.status == \'accepted\'\"><md-button ng-click=\"vm.changeStatus(participant, \'block\')\" \naria-label=\"Block user\"><md-icon md-font-icon=\"icon-block-helper\" class=\"s16\"></md-icon><span \ntranslate=\"PARTICIPANTS.BLOCK_USER\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"(vm.selectedProject.private && participant.status == \'requested\') || \n                                                            participant.status == \'denied\' || participant.status == \'blocked\'\">\n<md-button ng-click=\"vm.changeStatus(participant, \'give_access\')\" aria-label=\"Give access\"><md-icon \nmd-font-icon=\"icon-account-plus\" class=\"s16\"></md-icon><span translate=\"PARTICIPANTS.GIVE_ACCESS\"></span></md-button>\n</md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></div></div></div></div><div \nng-if=\"!vm.selectedProject.id\" class=\"padding-30\"><md-whiteframe class=\"md-whiteframe-3dp padding-50 red-100-bg\" \nlayout layout-align=\"center center\"><span translate=\"SURVEY.SELECT_PROJECT\">Please select one project.</span>\n</md-whiteframe></div>");
$templateCache.put("app/main/process/views/process.html","<div id=\"process\" ng-if=\"vm.selectedProject.id\" class=\"page-layout simple fullwidth gray-light3-bg\"><div \nclass=\"top-bg\" ng-class=\"vm.style.topBgClass\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"icon\" translate translate-attr-aria-label=\"EC.GO_TO_PRODUCTS\">\n<md-icon md-font-icon=\"icon-sync\"></md-icon></md-button><span translate=\"PROCESS.PROCESS\"></span></div></div></div><div\n class=\"content\"><div layout=\"row\" class=\"white-border padding-20\"><div flex=\"nogrow\" class=\"left-div lock-icon\">\n<md-icon ng-if=\"vm.selectedProject.private\" md-font-icon=\"icon-key\"></md-icon><md-icon \nng-if=\"!vm.selectedProject.private\" md-font-icon=\"icon-lock-unlocked-outline\"></md-icon></div><div flex \nclass=\"padding-top-5\"><div ng-if=\"vm.selectedProject.private\"><span translate=\"PROCESS.PROJECT_IS\"></span> <strong>\n<span translate=\"PROCESS.PRIVATE\" class=\"uppercase\" ng-class=\"vm.style.textColorPrimary\"></span></strong> <span \ntranslate=\"PROCESS.REQUEST_ACCESS\"></span></div><div ng-if=\"!vm.selectedProject.private\"><span \ntranslate=\"PROCESS.PROJECT_GRANTS\"></span> <strong><span translate=\"PROCESS.PUBLIC\" class=\"uppercase\" \nng-class=\"vm.style.textColorPrimary\"></span></strong> <span translate=\"PROCESS.ANY_ACCESS\"></span></div></div><div \nflex=\"nogrow\"><md-button aria-label=\"menu\" class=\"md-fab md-primary\" ng-click=\"vm.gotoSubgeoDetail()\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></div></div><div layout=\"column\" class=\"white-border padding-20\"><div \nlayout=\"row\"><div flex=\"nogrow\" class=\"left-div\"></div><div flex><span translate=\"PROCESS.SOLUTION_FINDING\"></span>\n</div></div><div layout=\"row\" class=\"padding-top-15 smaller-text\"><div flex=\"nogrow\" class=\"left-div\"><div \nclass=\"white-text padding-5 rounded-corners counter\" ng-class=\"vm.style.bgClass\">{{ vm.selectedProject.proposal_days }}\n</div></div><div flex class=\"padding-top-5\"><span translate=\"PROCESS.DAYS_RATING\"></span></div></div><div layout=\"row\" \nclass=\"padding-top-15 smaller-text\"><div flex=\"nogrow\" class=\"left-div\"><div \nclass=\"white-text padding-5 rounded-corners counter\" ng-class=\"vm.style.bgClass\">\n{{ vm.selectedProject.proposal_participants }}</div></div><div flex class=\"padding-top-5\"><span \ntranslate=\"PROCESS.PARTICIPANTS_REQUIRED\"></span></div></div><div layout=\"row\" class=\"padding-top-15 smaller-text\"><div\n flex class=\"padding-top-5\"><span ng-if=\"vm.selectedProject.allow_anonymous == true\" \ntranslate=\"PROCESS.PROJECT_ALLOW_ANONYMOUS\"></span> <span ng-if=\"vm.selectedProject.allow_anonymous == false\" \ntranslate=\"PROCESS.PROJECT_DONT_ALLOW_ANONYMOUS\"></span></div></div></div></div></div><div \nng-if=\"!vm.selectedProject.id\" class=\"padding-30\"><md-whiteframe class=\"md-whiteframe-3dp padding-50 red-100-bg\" \nlayout layout-align=\"center center\"><span translate=\"SURVEY.SELECT_PROJECT\">Please select one project.</span>\n</md-whiteframe></div>");
$templateCache.put("app/main/question/views/questions.html","<div id=\"questions-library\" ng-if=\"vm.selectedProject.id\" class=\"page-layout carded fullwidth\" layout=\"row\"><div \nclass=\"top-bg\" ng-class=\"vm.topBgClass\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button class=\"goto-products-button md-icon-button\" \naria-label=\"icon\" translate translate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-message-text\">\n</md-icon></md-button><span ng-if=\"!vm.selectedSurvey\" translate=\"QUESTION.QUESTION_LIBRARY\"></span> <span \nng-if=\"vm.selectedSurvey\" translate=\"QUESTION.ADD_QUESTION_FOR\"></span> <span ng-if=\"vm.selectedSurvey\" \nclass=\"capitalize\">: {{vm.selectedSurvey.title}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"SURVEY.SEARCH\" flex></div><div id=\"question-buttons\"><md-button class=\"md-fab md-primary\" \naria-label=\"Add\" ng-click=\"vm.importSelectedQuestions()\" ng-if=\"vm.showImportBtn\"><md-icon \nmd-font-icon=\"icon-content-copy\"></md-icon></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"QUESTION.QUESTION\">Question</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"QUESTION.TYPE\">Type</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"QUESTION.PROJECTS_USING\">Projects using</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SURVEY.ACTIONS\">Action</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"question in vm.questions | orderBy: question.question_order\"><td><md-checkbox \nng-model=\"question.import\" aria-label=\"Import checkbox\" ng-change=\"vm.selectQuestion(question)\" ng-true-value=\"true\" \nng-false-value=\"false\"></md-checkbox></td><td>{{question.question}}</td><td>{{vm.answerTypes[question.answer_type]}}\n</td><td>{{question.projectsUsing}}</td><td><md-button class=\"md-icon-button\" \nng-click=\"vm.gotoQuestionPreview(question)\" aria-label=\"Question preview\"><md-icon md-font-icon=\"icon-eye\" class=\"s16\">\n</md-icon></md-button></td></tr></tbody></table></div></div></div></div><div ng-if=\"!vm.selectedProject.id\" \nclass=\"padding-30\"><md-whiteframe class=\"md-whiteframe-3dp padding-50 red-100-bg\" layout layout-align=\"center center\">\n<span translate=\"SURVEY.SELECT_PROJECT\">Please select one project.</span></md-whiteframe></div>");
$templateCache.put("app/main/reports/views/reports.html","<div id=\"reports\" ng-if=\"vm.selectedProject.id\" class=\"page-layout simple fullwidth\"><div class=\"top-bg\" \nng-class=\"vm.topBgClass\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"icon\" translate translate-attr-aria-label=\"EC.GO_TO_PRODUCTS\">\n<md-icon md-font-icon=\"icon-poll\"></md-icon></md-button><span translate=\"REPORTS.REPORTS_FOR\"></span>&nbsp; <span \nclass=\"capitalize\">{{vm.selectedProject.name}}</span></div></div></div><div class=\"content\"><div layout=\"row\" \nclass=\"options\"><div flex=\"nogrow\" style=\"padding-right: 10px\"><span translate=\"SHARED.YEAR\"></span></div><div \nflex=\"nogrow\" style=\"width: 100px\"><md-select class=\"white-select-bg\" ng-model=\"vm.selectedYear\" \nng-change=\"vm.changeSelectedYear()\" aria-label=\"Years\"><md-option ng-repeat=\"year in vm.years\" ng-value=\"year\">\n{{year.year}}</md-option></md-select></div><div flex=\"nogrow\" style=\"padding: 0 10px 0 25px\"><span \ntranslate=\"REPORTS.REPORT\"></span></div><div flex=\"nogrow\" style=\"width: 200px\"><md-select class=\"white-select-bg\" \nng-model=\"vm.selectedReport\" ng-change=\"vm.changeSelectedReport()\" aria-label=\"Years\"><md-option \nng-repeat=\"report in vm.yearReports\" ng-value=\"report\">{{report.title}}</md-option></md-select></div><div \nflex=\"nogrow\" style=\"padding: 0 10px 0 25px\" ng-if=\"vm.loadingReport\"><md-progress-circular class=\"md-info\" \nmd-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div><div flex></div><div flex=\"nogrow\" \nstyle=\"width: 200px\" layout=\"row\" ng-if=\"vm.yearReports.length > 1\"><div flex=\"nogrow\" style=\"width: 50px\"><md-button \nclass=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.moveToReport(-1)\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon></md-button></div><div flex class=\"report-index\">{{ vm.index + 1 }} <span translate=\"SHARED.OF\"></span>\n {{ vm.yearReports.length }}</div><div flex=\"nogrow\" style=\"width: 50px\"><md-button class=\"md-icon-button\" \naria-label=\"More\" ng-click=\"vm.moveToReport(1)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><div flex=\"nogrow\"><md-button aria-label=\"menu\" class=\"md-fab md-mini md-primary\" \nng-click=\"vm.gotoReportDetail()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"REPORTS.NEW_REPORT\"></span></md-tooltip></md-button></div></div><div id=\"iframe-container\"><iframe \nsandbox=\"allow-scripts allow-same-origin\" id=\"blob-src-test\" ng-if=\"vm.showIframe\" frameborder=\"0\" width=\"100%\" \nscrolling=\"no\" iframe-onload=\"vm.iframeLoaded(event)\"></iframe></div></div></div><div ng-if=\"!vm.selectedProject.id\" \nclass=\"padding-30\"><md-whiteframe class=\"md-whiteframe-3dp padding-50 red-100-bg\" layout layout-align=\"center center\">\n<span translate=\"SURVEY.SELECT_PROJECT\">Please select one project.</span></md-whiteframe></div>");
$templateCache.put("app/main/results/views/results.html","<div id=\"results-library\" ng-if=\"vm.selectedProject.id\" class=\"page-layout carded fullwidth\" layout=\"row\"><div \nclass=\"top-bg\" ng-class=\"vm.topBgClass\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" \nlayout=\"row\" layout-align=\"space-between center\"><div flex=\"50\" flex-xs=\"100\" class=\"white-fg\" layout=\"row\" \nlayout-align=\"start start\"><div flex=\"50\" class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"icon\" translate translate-attr-aria-label=\"EC.GO_TO_PRODUCTS\">\n<md-icon md-font-icon=\"icon-chart-pie\"></md-icon></md-button><span translate=\"RESULTS.SURVEY_RESULTS\"></span></div><div\n flex=\"50\" layout=\"row\" layout-align=\"end center\" ng-if=\"!vm.showAllSurveys\"><md-button \nclass=\"md-raised md-mini md-primary\" ng-click=\"vm.showAllResults()\" aria-label=\"icon\" ng-if=\"!vm.surveyHash\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon><span translate=\"RESULTS.GO_BACK\"></span></md-button></div></div><div \nflex=\"50\" class=\"h1 white-fg padding-left-15\" layout=\"row\" ng-if=\"vm.showAllSurveys\"><span \ntranslate=\"RESULTS.SELECT_SURVEY_FROM\"></span> &nbsp;<span class=\"capitalize\">{{vm.selectedProject.name}}</span>&nbsp; \n<span translate=\"RESULTS.TO_SHOW_RESULTS\"></span></div><div flex=\"50\" class=\"white-fg\" layout=\"row\" \nng-if=\"!vm.showAllSurveys && !vm.surveyHash\"><div flex layout=\"row\" layout-align=\"start center\" class=\"padding-top-10\">\n<div flex class=\"h1 white-fg padding-left-15\"><span translate=\"RESULTS.SURVEY\"></span>: &nbsp;<span class=\"capitalize\">\n{{vm.selectedSurvey.title}}</span></div><div flex layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-raised md-mini gray-light-btn\" aria-label=\"share\" ng-click=\"vm.shareSurveyUrl(2)\">Print</md-button><md-button\n class=\"md-raised md-mini md-primary share-link-btn\" aria-label=\"share\" ng-click=\"vm.shareSurveyUrl(1)\"><span \ntranslate=\"RESULTS.SHARE_SURVEY\"></span><md-icon md-font-icon=\"icon-link\"></md-icon></md-button></div></div></div>\n</div><div class=\"content\" layout=\"column\" flex style=\"position: relative\"><div layout=\"row\" \nng-if=\"!vm.showAllSurveys\" style=\"padding: 8px 15px\"><div flex=\"50\" flex-xs=\"100\" layout=\"row\" class=\"margin-top-10\">\n<div class=\"h2\"><span translate=\"RESULTS.AGGREGATE_RESULTS\"></span>:</div><div flex class=\"h2 padding-left-15\">\n<md-radio-group ng-model=\"vm.heatmapType\" layout=\"row\" ng-change=\"vm.showClick(vm.lastClickData)\"><md-radio-button \nvalue=\"village\"><span translate=\"RESULTS.LOCATIONS\"></span></md-radio-button><md-radio-button value=\"gps\" \ndisabled=\"vm.showGPSResults\"><span translate=\"RESULTS.GPS_POINTS\"></span></md-radio-button></md-radio-group></div>\n</div><div flex=\"50\" flex-xs=\"100\" class=\"margin-top-10\" layout=\"row\" layout-align=\"space-between center\"><div flex \nlayout=\"row\" layout-align=\"end center\"><md-icon md-font-icon=\"icon-chevron-left\" class=\"wizard-step-icon\" \nng-click=\"vm.previousQuestion()\"></md-icon></div><div flex=\"50\" class=\"current-question\"><span \ntranslate=\"QUESTION.QUESTION\"></span> <span>\n{{vm.currentQuestionIndex + 1}}/{{vm.selectedSurvey.survey_configurations.length}}</span></div><div flex layout=\"row\" \nlayout-align=\"start center\" class=\"\"><md-icon md-font-icon=\"icon-chevron-right\" class=\"wizard-step-icon\" \nng-click=\"vm.nextQuestion()\"></md-icon></div></div></div><div flex layout=\"row\" layout-xs=\"column\" \nlayout-align=\"center stretch\"><div flex=\"50\" flex-xs=\"100\" id=\"mapCanvas\" layout-align=\"center stretch\"><div \nid=\"heatmap-legend\" ng-if=\"!vm.showAllSurveys\"><span class=\"md-subhead\"><span translate=\"RESULTS.HEATMAP_GPS_LEGEND\" \nng-if=\"vm.heatmapType == \'gps\'\"></span> <span translate=\"RESULTS.HEATMAP_VILLAGE_LEGEND\" \nng-if=\"vm.heatmapType == \'village\'\"></span></span></div></div><div flex=\"50\" flex-xs=\"100\" layout=\"column\" \nclass=\"padding-30\" ng-if=\"vm.showAllSurveys\"><div class=\"padding-15\" style=\"overflow-y: auto\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title results-header capitalize\" \ntranslate=\"RESULTS.TITLE\">Title</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title results-header capitalize\" translate=\"RESULTS.STATUS\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title results-header capitalize\" \ntranslate=\"RESULTS.RESULTS\">Results</span></div></th></tr></thead><tbody><tr ng-repeat=\"survey in vm.surveys\" \nstyle=\"height: 70px\"><td>{{survey.title}}</td><td><md-icon ng-if=\"survey.status == \'edit\'\" md-font-icon=\"icon-pencil\">\n</md-icon><md-icon ng-if=\"survey.status == \'started\'\" md-font-icon=\"icon-play\"></md-icon><md-icon \nng-if=\"survey.status == \'ended\'\" md-font-icon=\"icon-stop\"></md-icon>{{vm.surveyStatus[survey.status]}}</td><td>\n<md-button id=\"new-group-btn\" class=\"md-fab md-mini md-primary\" aria-label=\"Results\" \nng-click=\"vm.showSurveyResults(survey)\"><md-icon md-font-icon=\"icon-chart-pie\"></md-icon></md-button></td></tr></tbody>\n</table></div></div><div flex=\"50\" flex-xs=\"100\" layout=\"column\" ng-if=\"!vm.showAllSurveys\" style=\"overflow-y: auto\">\n<div layout=\"column\" class=\"question-bg padding-15 h3\"><div class=\"question\"><span>{{vm.currentQuestion.question}}\n</span><br></div><div layout=\"row\"><div flex><span translate=\"QUESTION.TYPE\"></span>: <strong>\n{{vm.answerTypes[vm.currentQuestion.answer_type]}}</strong> &nbsp;|&nbsp;<span translate=\"RESULTS.PARTICIPANTS\"></span>\n&nbsp; <strong><span>{{ vm.totalParticipants }}</span></strong> <span ng-repeat=\"(key, value) in vm.groupedAnswers\" \nng-if=\"vm.showChart && vm.currentQuestion.answer_type != \'likert\'\">&nbsp;|&nbsp;<span>{{ key }}</span>&nbsp; <strong>\n<span>{{ value }}</span></strong> </span><span ng-if=\"vm.currentQuestion.answer_type == \'likert\'\">&nbsp;|&nbsp;<span \ntranslate=\"QUESTION.MIN\"></span>&nbsp; <strong><span>{{ vm.min }}</span></strong> &nbsp;|&nbsp;<span \ntranslate=\"QUESTION.AVERAGE\"></span>&nbsp; <strong><span>{{ vm.average }}</span></strong> &nbsp;|&nbsp;<span \ntranslate=\"QUESTION.MAX\"></span>&nbsp; <strong><span>{{ vm.max }}</span></strong></span></div></div><div \nng-if=\"vm.showChart\"><span translate=\"RESULTS.CHART_HELP\"></span></div></div><div flex ng-if=\"!vm.showChart\" \nclass=\"padding-30 gc-chart-container\"></div><div flex ng-if=\"vm.showChart\" layout=\"column\" style=\"padding: 5px 30px\">\n<c3chart bindto-id=\"chart\" chart-data=\"vm.datapoints\" chart-columns=\"vm.datacolumns\" chart-x=\"vm.datax\"><chart-size \nchart-height=\"{{vm.chartHeight}}\"><chart-colors color-pattern=\"#F4723A\"><chart-legend show-legend=\"false\"><chart-axis>\n<chart-axis-x axis-type=\"category\" show=\"true\" ng-if=\"vm.showAxisXNames\"></chart-axis-x><chart-axis-x \naxis-type=\"category\" show=\"false\" ng-if=\"!vm.showAxisXNames\"></chart-axis-x><chart-axis-y><chart-axis-y-tick \ntick-format-function=\"vm.axisY\"></chart-axis-y></chart-axis><chart-events on-click-data=\"vm.showClick(data)\"></c3chart>\n<div ng-if=\"vm.currentQuestion.answer_type == \'likert\'\" layout=\"row\" style=\"padding: 0 30px\"><div \nclass=\"padding-left-60\"><md-icon md-font-icon=\"icon-thumb-down\" class=\"s32\"></md-icon></div><div flex \nstyle=\"overflow: hidden\" class=\"padding-top-10\"><div style=\"border-top: 1px dashed gray\"></div></div><div \nclass=\"padding-right-60\" style=\"position: relative\"><md-icon md-font-icon=\"icon-thumb-up\" class=\"s32\" \nstyle=\"position: absolute; top: -10px\"></md-icon></div></div><div ng-if=\"vm.showChart\" layout=\"row\" \nlayout-align=\"end center\" class=\"h3 padding-right-60\" style=\"font-style: italic\"><span translate=\"RESULTS.CLICK_BAR\">\n</span></div></div><div flex ng-if=\"!vm.showChart && vm.currentQuestion.answer_type == \'input\'\" class=\"padding-30\">\n<md-whiteframe class=\"md-whiteframe-1dp margin-5 padding-15\" layout layout-align=\"start center\" \nng-repeat=\"answer in vm.currentAnswers\"><span>{{answer.answer_text}}</span></md-whiteframe></div></div></div></div>\n</div></div><div ng-if=\"!vm.selectedProject.id\" class=\"padding-30\"><md-whiteframe \nclass=\"md-whiteframe-3dp padding-50 red-100-bg\" layout layout-align=\"center center\"><span \ntranslate=\"SURVEY.SELECT_PROJECT\">Please select one project.</span></md-whiteframe></div>");
$templateCache.put("app/main/survey/views/survey.html","<div id=\"surveys\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-if=\"vm.selectedProject.id\"><div class=\"top-bg\" \nng-class=\"vm.topBgClass\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clipboard-outline\"></md-icon><span \ntranslate=\"SURVEY.SURVEYS_FOR\">Surveys for</span>&nbsp; <span class=\"capitalize\">{{vm.selectedProject.name}}</span>\n</div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SURVEY.SEARCH\" flex></div></div><div id=\"survey-buttons\">\n<md-fab-speed-dial md-open=\"vm.isNewSurveyOpen\" md-direction=\"left\" class=\"md-scale\"><md-fab-trigger><md-button \naria-label=\"menu\" class=\"md-fab md-primary\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button aria-label=\"Create\" class=\"md-fab md-raised md-mini gray-light-btn\" \nng-click=\"vm.gotoSurveyDetail()\"><md-icon md-font-icon=\"icon-pencil\" aria-label=\"Create\"></md-icon></md-button>\n<md-button aria-label=\"Copy\" class=\"md-fab md-raised md-mini gray-light-btn\" ui-sref=\"app.survey.others\"><md-icon \nmd-font-icon=\"icon-content-copy\" aria-label=\"Copy\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div>\n<div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SURVEY.TITLE\">Title</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SURVEY.STATUS\">Status\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SURVEY.GROUPS\">Groups</span></div></th><th class=\"secondary-text\" style=\"max-width: 350px\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SURVEY.ACTIONS\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"survey in vm.surveys\"><td>{{survey.title}}</td><td>{{vm.surveyStatus[survey.status]}}</td><td>\n<span ng-repeat=\"group in survey.groups\" class=\"group-name margin-left-5\">{{group.name}}</span></td><td \nstyle=\"max-width: 350px\"><md-menu><button class=\"gray-md-icon-btn\" aria-label=\"Open menu\" ng-click=\"$mdOpenMenu()\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></button><md-menu-content width=\"4\"><md-menu-item \nng-if=\"survey.status == \'edit\' || survey.status == \'started\'\"><md-button ng-click=\"vm.gotoSurveyDetail(survey)\" \naria-label=\"Survey details\" translate translate-attr-aria-label=\"SURVEY.DETAILS\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s16\"></md-icon><span translate=\"SURVEY.EDIT\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"survey.status == \'edit\'\"><md-button ng-click=\"vm.goToSurveyQuestions(survey)\" aria-label=\"Survey questions\" \ntranslate translate-attr-aria-label=\"SURVEY.QUESTIONS\"><md-icon md-font-icon=\"icon-file-document-box\" class=\"s16\">\n</md-icon><span translate=\"SURVEY.QUESTIONS\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.gotoSurveyPreview(survey)\" aria-label=\"Survey preview\" translate \ntranslate-attr-aria-label=\"SURVEY.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" class=\"s16\"></md-icon><span \ntranslate=\"SURVEY.PREVIEW\"></span></md-button></md-menu-item><md-menu-item ng-if=\"survey.status != \'started\'\">\n<md-button ng-click=\"vm.deleteSurvey(survey)\" aria-label=\"Delete Survey\" translate \ntranslate-attr-aria-label=\"QUESTION.DELETE\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon><span \ntranslate=\"QUESTION.DELETE\"></span></md-button></md-menu-item><md-menu-item ng-if=\"survey.status == \'started\'\">\n<md-button ng-click=\"vm.changeSurveyStatus(survey)\" aria-label=\"Stop Survey\" translate \ntranslate-attr-aria-label=\"SURVEY.STOP_SURVEY\"><md-icon md-font-icon=\"icon-stop\" class=\"s16\"></md-icon><span \ntranslate=\"SURVEY.STOP_SURVEY\"></span></md-button></md-menu-item><md-menu-item ng-if=\"survey.status == \'ended\'\">\n<md-button ng-click=\"vm.changeSurveyStatus(survey)\" aria-label=\"Stop Survey\" translate \ntranslate-attr-aria-label=\"SURVEY.START_SURVEY\"><md-icon md-font-icon=\"icon-play-circle-outline\" class=\"s16\"></md-icon>\n<span translate=\"SURVEY.START_SURVEY\"></span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nclass=\"md-raised\" aria-label=\"Start survey\" ng-click=\"vm.changeSurveyStatus(survey)\" \nng-if=\"survey.survey_configurations.length > 0 && survey.status == \'edit\' && survey.groups.length > 0\"><span \ntranslate=\"SURVEY.START_SURVEY\">Start Survey</span><md-icon md-font-icon=\"icon-play-circle-outline\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div></div><div ng-if=\"!vm.selectedProject.id\" class=\"padding-30\">\n<md-whiteframe class=\"md-whiteframe-3dp padding-50 red-100-bg\" layout layout-align=\"center center\"><span \ntranslate=\"SURVEY.SELECT_PROJECT\">Please select one project.</span></md-whiteframe></div>");
$templateCache.put("app/main/survey-new/views/survey.html","<div id=\"surveys\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-if=\"vm.selectedProject.id\"><div class=\"top-bg\" \nng-class=\"vm.topBgClass\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clipboard-outline\"></md-icon><span \ntranslate=\"SURVEY.SURVEYS_FOR\">Surveys for</span>&nbsp; <span class=\"capitalize\">{{vm.selectedProject.name}}</span>\n</div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SURVEY.SEARCH\" flex></div></div><div id=\"survey-buttons\">\n<md-fab-speed-dial md-open=\"vm.isNewSurveyOpen\" md-direction=\"left\" class=\"md-scale\"><md-fab-trigger><md-button \naria-label=\"menu\" class=\"md-fab md-primary\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button aria-label=\"Create\" class=\"md-fab md-raised md-mini gray-light-btn\" \nng-click=\"vm.gotoSurveyDetail()\"><md-icon md-font-icon=\"icon-pencil\" aria-label=\"Create\"></md-icon></md-button>\n<md-button aria-label=\"Copy\" class=\"md-fab md-raised md-mini gray-light-btn\" ui-sref=\"app.survey-new.others\"><md-icon \nmd-font-icon=\"icon-content-copy\" aria-label=\"Copy\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div>\n<div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SURVEY.TITLE\">Title</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SURVEY.STATUS\">Status\n</span></div></th><th class=\"secondary-text\" ng-if=\"vm.api.useGroups\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"SURVEY.GROUPS\">Groups</span></div></th><th class=\"secondary-text\" \nng-if=\"!vm.api.useGroups\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SURVEY.ASSIGNED\">Assigned\n</span></div></th><th class=\"secondary-text\" style=\"max-width: 350px\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"SURVEY.ACTIONS\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"survey in vm.surveys\"><td>{{survey.title}}</td><td>{{vm.surveyStatus[survey.status]}}</td><td \nng-if=\"vm.api.useGroups\"><span ng-repeat=\"group in survey.groups\" class=\"group-name margin-left-5\">{{group.name}}\n</span></td><td ng-if=\"!vm.api.useGroups\">{{ survey.pendings.length }}</td><td style=\"max-width: 350px\"><md-menu>\n<button class=\"gray-md-icon-btn\" aria-label=\"Open menu\" ng-click=\"$mdOpenMenu()\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon></button><md-menu-content width=\"4\"><md-menu-item ng-if=\"survey.status == \'edit\'\"><md-button \nng-click=\"vm.gotoSurveyDetail(survey)\" aria-label=\"Survey details\" translate \ntranslate-attr-aria-label=\"SURVEY.DETAILS\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><span \ntranslate=\"SURVEY.EDIT\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.gotoSurveyRounds(survey)\" aria-label=\"Survey rounds\" translate translate-attr-aria-label=\"SURVEY.ROUNDS\">\n<md-icon md-font-icon=\"icon-calendar-check-multiple\" class=\"s16\"></md-icon><span translate=\"SURVEY.ROUNDS\"></span>\n</md-button></md-menu-item><md-menu-item ng-if=\"survey.status == \'edit\'\"><md-button \nng-click=\"vm.goToSurveyQuestions(survey)\" aria-label=\"Survey questions\" translate \ntranslate-attr-aria-label=\"SURVEY.QUESTIONS\"><md-icon md-font-icon=\"icon-file-document-box\" class=\"s16\"></md-icon><span\n translate=\"SURVEY.QUESTIONS\"></span></md-button></md-menu-item><md-menu-item ng-if=\"!vm.api.useGroups\"><md-button \nng-click=\"vm.goToSurveyAssign(survey)\" aria-label=\"Survey assign\" translate translate-attr-aria-label=\"SURVEY.Assign\">\n<md-icon md-font-icon=\"icon-people\" class=\"s16\"></md-icon><span translate=\"SURVEY.ASSIGN\"></span></md-button>\n</md-menu-item><md-menu-item ng-if=\"survey.status != \'started\'\"><md-button ng-click=\"vm.deleteSurvey(survey)\" \naria-label=\"Delete Survey\" translate translate-attr-aria-label=\"QUESTION.DELETE\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s16\"></md-icon><span translate=\"QUESTION.DELETE\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"survey.status == \'started\'\"><md-button ng-click=\"vm.changeSurveyStatus(survey)\" aria-label=\"Stop Survey\" \ntranslate translate-attr-aria-label=\"SURVEY.STOP_SURVEY\"><md-icon md-font-icon=\"icon-stop\" class=\"s16\"></md-icon><span \ntranslate=\"SURVEY.STOP_SURVEY\"></span></md-button></md-menu-item><md-menu-item ng-if=\"survey.status == \'ended\'\">\n<md-button ng-click=\"vm.changeSurveyStatus(survey)\" aria-label=\"Stop Survey\" translate \ntranslate-attr-aria-label=\"SURVEY.START_SURVEY\"><md-icon md-font-icon=\"icon-play-circle-outline\" class=\"s16\"></md-icon>\n<span translate=\"SURVEY.START_SURVEY\"></span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nclass=\"md-raised\" aria-label=\"Start survey\" ng-click=\"vm.changeSurveyStatus(survey)\" \nng-if=\"survey.survey_configurations.length > 0 && survey.status == \'edit\' && survey.groups.length > 0\"><span \ntranslate=\"SURVEY.START_SURVEY\">Start Survey</span><md-icon md-font-icon=\"icon-play-circle-outline\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div></div><div ng-if=\"!vm.selectedProject.id\" class=\"padding-30\">\n<md-whiteframe class=\"md-whiteframe-3dp padding-50 red-100-bg\" layout layout-align=\"center center\"><span \ntranslate=\"SURVEY.SELECT_PROJECT\">Please select one project.</span></md-whiteframe></div>");
$templateCache.put("app/main/workflow/views/workflow.html","<div id=\"surveys\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-if=\"vm.selectedProject.id\"><div class=\"top-bg\" \nng-class=\"vm.topBgClass\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-calculator\"></md-icon><span \ntranslate=\"WORKFLOW.WORKFLOWS_FOR\">Workflows for</span>&nbsp; <span class=\"capitalize\">{{vm.selectedProject.name}}\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"SURVEY.SEARCH\" flex></div>\n</div><div id=\"survey-buttons\"><md-button id=\"new-group-btn\" class=\"md-fab md-primary\" aria-label=\"New workflow\" \nng-click=\"vm.goToWorkflowDetail()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"WORKFLOW.WORKFLOW\">Workflow\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SHARED.ACTIONS\">Actions</span></div></th></tr></thead><tbody><tr ng-repeat=\"workflow in vm.workflows\"><td>\n{{workflow.name}}</td><td style=\"max-width: 350px\"><md-menu><button class=\"gray-md-icon-btn\" aria-label=\"Open menu\" \nng-click=\"$mdOpenMenu()\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></button><md-menu-content width=\"4\">\n<md-menu-item><md-button ng-click=\"vm.goToWorkflowDetail(workflow)\" aria-label=\"Workflow details\" translate \ntranslate-attr-aria-label=\"SHARED.EDIT\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><span \ntranslate=\"SHARED.EDIT\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.goToWorkflowReport(workflow)\" aria-label=\"Report\" translate \ntranslate-attr-aria-label=\"WORKFLOW.VIEW_REPORT\"><md-icon md-font-icon=\"icon-file-document-box\" class=\"s16\"></md-icon>\n<span translate=\"WORKFLOW.VIEW_REPORT\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.goToWorkflowVariables(workflow)\" aria-label=\"Variables\" translate \ntranslate-attr-aria-label=\"WORKFLOW.VARIABLES\"><md-icon md-font-icon=\"icon-eye\" class=\"s16\"></md-icon><span \ntranslate=\"WORKFLOW.VARIABLES\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.deleteWorkflow(workflow)\" aria-label=\"Delete Survey\" translate \ntranslate-attr-aria-label=\"QUESTION.DELETE\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon><span \ntranslate=\"QUESTION.DELETE\"></span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table>\n</div></div></div></div><div ng-if=\"!vm.selectedProject.id\" class=\"padding-30\"><md-whiteframe \nclass=\"md-whiteframe-3dp padding-50 red-100-bg\" layout layout-align=\"center center\"><span \ntranslate=\"SURVEY.SELECT_PROJECT\">Please select one project.</span></md-whiteframe></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"><img \nsrc=\"/assets/images/logos/geocitizen.png\"></span><span class=\"logo-text\">Geocitizen</span></div><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\">\n</ms-navigation>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.privateOptions.showOptions\"><ms-navigation-horizontal>\n</ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> \n<span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>\n<md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span>\n</md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div \nclass=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\">\n<h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list>\n<md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader>\n<md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 \ntranslate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" \naria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" \nng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"column\" style=\"border-bottom: 1px solid #BDBDBD\"><div class=\"top-row\" layout=\"row\" \nlayout-align=\"space-between center\" ng-class=\"vm.toolbarBackgroundClass\"><div flex layout=\"row\" \nlayout-align=\"start center\"><div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\">\n</md-icon></md-button></div><div flex layout=\"row\" layout-align=\"space-around center\"><div flex flex-md=\"40\" \nflex-sm=\"30\" flex-xs=\"10\" layout=\"row\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"logo-image\"><img src=\"/assets/images/logos/geocitizen_white.png\"></span></div><md-input-container hide-xs>\n<strong><span class=\"uppercase\">{{ vm.domainLabel }}</span></strong> <span hide-sm class=\"uppercase padding-left-15\" \ntranslate=\"TOOLBAR.DASHBOARD\"></span></md-input-container></div><div flex layout=\"row\" layout-align=\"end center\"></div>\n</div></div></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"column\" style=\"border-bottom: 1px solid #BDBDBD\"><div class=\"top-row\" layout=\"row\" \nlayout-align=\"space-between center\" ng-class=\"vm.toolbarBackgroundClass\"><div flex layout=\"row\" \nlayout-align=\"start center\"><div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\">\n</md-icon></md-button></div><div flex layout=\"row\" layout-align=\"space-around center\"><div flex flex-md=\"40\" \nflex-sm=\"30\" flex-xs=\"10\" layout=\"row\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"logo-image\"><img src=\"/assets/images/logos/geocitizen_white.png\"></span></div><md-input-container hide-xs>\n<strong><span class=\"uppercase\">{{ vm.domainLabel }}</span></strong> <span hide-sm class=\"uppercase padding-left-15\" \ntranslate=\"TOOLBAR.DASHBOARD\"></span></md-input-container></div><div flex layout=\"row\" layout-align=\"end center\"><div \nflex layout=\"row\" layout-align=\"start center\"><span translate=\"TOOLBAR.PROJECTS\"></span>:<div class=\"select-project\" \nng-if=\"vm.privateOptions.showOptions\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"vm.loadingSubgeos\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular><md-select class=\"white-select-bg\" \nng-model=\"vm.selectedProject\" ng-change=\"vm.changeSelectedProject()\" aria-label=\"Project\" ng-if=\"!vm.loadingSubgeos\">\n<md-option ng-repeat=\"region in vm.regions\" ng-value=\"region\">{{region.name}}</md-option></md-select></div><div \nng-if=\"!vm.privateOptions.showOptions\">&nbsp;{{ vm.selectedProject.name }}</div></div><div flex ng-if=\"vm.userRole\" \nhide-sm hide-xs class=\"text-right padding-right-15\"><span translate=\"TOOLBAR.YOUR_ROLE\"></span>: <strong><span>\n{{vm.userRole}}</span></strong></div></div></div></div><div layout=\"row\" layout-align=\"start center\"><div \nng-if=\"vm.privateOptions.showOptions\" class=\"profile-menu-btn\" ng-click=\"vm.showProfileMenu()\"><img \nng-if=\"!vm.user.avatar_url\" class=\"avatar mr-16\" ng-src=\"assets/images/avatars/user.jpg\" alt=\"Avatar\"> <img \nng-if=\"vm.user.avatar_url\" class=\"avatar mr-16\" ng-src=\"{{vm.user.avatar_url}}\" alt=\"Avatar\"></div></div></div><div \nclass=\"bottom-row\" ng-if=\"vm.privateOptions.showOptions\"><div id=\"horizontal-navigation\" ui-view=\"navigation\"></div>\n</div><div hide-sm hide-xs id=\"project-access-icon\" ng-if=\"vm.privateOptions.showOptions\"><md-icon \nng-if=\"vm.selectedProject.private\" md-font-icon=\"icon-key\"><md-tooltip md-autohide=\"true\"><span \ntranslate=\"TOOLBAR.PRIVATE\"></span></md-tooltip></md-icon><md-icon ng-if=\"!vm.selectedProject.private\" \nmd-font-icon=\"icon-lock-unlocked-outline\"><md-tooltip md-autohide=\"true\"><span translate=\"TOOLBAR.PUBLIC\"></span>\n</md-tooltip></md-icon></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div layout=\"row\"><div flex class=\"padding-left-15\">\n<md-input-container><span translate=\"TOOLBAR.PROJECT\"></span></md-input-container></div><div flex \nclass=\"padding-left-15\"><md-input-container><md-select ng-model=\"vm.selectedProject.id\" \nng-change=\"vm.changeSelectedProject()\"><md-option ng-repeat=\"region in vm.regions\" ng-value=\"region.id\">{{region.name}}\n</md-option></md-select></md-input-container></div></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\">\n</md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"username\" hide show-gt-sm>{{vm.user.username}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" \nmd-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">G</span> <span class=\"logo-text\">Geocitizen</span>\n</div><div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button><div\n class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" \nmd-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" \nmd-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s25 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"vm.activeGreen\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s25 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/reports/views/public-reports/public-reports.html","<div id=\"reports\" class=\"page-layout simple fullwidth\"><div class=\"top-bg\" ng-class=\"vm.topBgClass\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"goto-products-button md-icon-button\" aria-label=\"icon\" \ntranslate translate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-poll\"></md-icon></md-button><span \ntranslate=\"REPORTS.PUBLIC_REPORTS\"></span></div></div></div><div class=\"content\"><div layout=\"row\" class=\"options\"><div\n flex=\"nogrow\" style=\"padding-right: 10px; width: 100px\"><span translate=\"SHARED.PROJECT\"></span></div><div \nflex=\"nogrow\" style=\"width: 500px\"><md-select class=\"white-select-bg\" ng-model=\"vm.selectedProject\" \nng-change=\"vm.loadReports()\" aria-label=\"Projects\"><md-option ng-repeat=\"project in vm.projects\" ng-value=\"project\">\n{{project.name}}</md-option></md-select></div><div flex=\"nogrow\" style=\"padding: 0 10px 0 25px\" \nng-if=\"vm.loadingReportsList\"><md-progress-circular class=\"md-info\" md-mode=\"indeterminate\" md-diameter=\"30\">\n</md-progress-circular></div><div flex></div></div><div layout=\"row\" class=\"options\"><div flex=\"nogrow\" \nstyle=\"padding-right: 10px; width: 100px\"><span translate=\"SHARED.YEAR\"></span></div><div flex=\"nogrow\" \nstyle=\"width: 120px\"><md-select class=\"white-select-bg\" ng-model=\"vm.selectedYear\" ng-change=\"vm.changeSelectedYear()\" \naria-label=\"Years\"><md-option ng-repeat=\"year in vm.years\" ng-value=\"year\">{{year.year}}</md-option></md-select></div>\n<div flex=\"nogrow\" style=\"padding: 0 10px 0 25px\"><span translate=\"REPORTS.REPORT\"></span></div><div flex=\"nogrow\" \nstyle=\"width: 295px\"><md-select class=\"white-select-bg\" ng-model=\"vm.selectedReport\" \nng-change=\"vm.changeSelectedReport()\" aria-label=\"Years\"><md-option ng-repeat=\"report in vm.yearReports\" \nng-value=\"report\">{{report.title}}</md-option></md-select></div><div flex=\"nogrow\" style=\"padding: 0 10px 0 25px\" \nng-if=\"vm.loadingReport\"><md-progress-circular class=\"md-info\" md-mode=\"indeterminate\" md-diameter=\"30\">\n</md-progress-circular></div><div flex></div><div flex=\"nogrow\" style=\"width: 200px\" layout=\"row\" \nng-if=\"vm.yearReports.length > 1\"><div flex=\"nogrow\" style=\"width: 50px\"><md-button class=\"md-icon-button\" \naria-label=\"More\" ng-click=\"vm.moveToReport(-1)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button></div>\n<div flex class=\"report-index\">{{ vm.index + 1 }} <span translate=\"SHARED.OF\"></span> {{ vm.yearReports.length }}</div>\n<div flex=\"nogrow\" style=\"width: 50px\"><md-button class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"vm.moveToReport(1)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div></div><div \nid=\"iframe-container\"><iframe sandbox=\"allow-scripts allow-same-origin\" id=\"blob-src-test\" ng-if=\"vm.showIframe\" \nframeborder=\"0\" width=\"100%\" scrolling=\"no\" iframe-onload=\"vm.iframeLoaded(event)\"></iframe></div></div></div>");
$templateCache.put("app/main/results/views/print-results/print-results.html","<div style=\"width: 600px; background: #FFFFFF\" id=\"print-content\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\" style=\"border-bottom: 1px solid grey\"><md-button class=\"md-icon-button\" aria-label=\"icon\" \ntranslate translate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-chart-pie\"></md-icon></md-button>\n<span translate=\"RESULTS.SURVEY_RESULTS_OF\"></span>:&nbsp;{{vm.selectedSurvey.title}}</div><div layout=\"column\" \nclass=\"padding-30\"><div ng-repeat=\"question in vm.questions\"><div class=\"question-bg padding-30 h3\"><div \nclass=\"question\"><span>{{question.question}}</span><br></div><div><span translate=\"QUESTION.TYPE\"></span>: <strong>\n{{vm.answerTypes[question.answer_type]}}</strong> &nbsp;|&nbsp;<span translate=\"RESULTS.PARTICIPANTS\"></span>&nbsp; \n<strong><span>{{ question.totalParticipants }}</span></strong> <span \nng-repeat=\"(key, value) in question.groupedAnswers\" ng-if=\"question.showChart && question.answer_type != \'likert\'\">\n&nbsp;|&nbsp;<span>{{ key }}</span>&nbsp; <strong><span>{{ value }}</span></strong> </span><span \nng-if=\"question.answer_type == \'likert\'\">&nbsp;|&nbsp;<span translate=\"QUESTION.MIN\"></span>&nbsp; <strong><span>\n{{ question.min }}</span></strong> &nbsp;|&nbsp;<span translate=\"QUESTION.AVERAGE\"></span>&nbsp; <strong><span>\n{{ question.average }}</span></strong> &nbsp;|&nbsp;<span translate=\"QUESTION.MAX\"></span>&nbsp; <strong><span>\n{{ question.max }}</span></strong></span></div></div><div ng-if=\"question.showChart\" style=\"padding: 5px 30px\"><div \nclass=\"chart-height\"><c3chart bindto-id=\"chart-{{question.id}}\" chart-data=\"question.datapoints\" \nchart-columns=\"question.datacolumns\" chart-x=\"question.datax\"><chart-size chart-height=\"250\" chart-width=\"500\">\n<chart-colors color-pattern=\"#F4723A\"><chart-legend show-legend=\"false\"><chart-axis><chart-axis-x axis-type=\"category\" \nshow=\"true\" ng-if=\"question.showAxisXNames\"></chart-axis-x><chart-axis-x axis-type=\"category\" show=\"false\" \nng-if=\"!question.showAxisXNames\"></chart-axis-x><chart-axis-y><chart-axis-y-tick tick-format-function=\"question.axisY\">\n</chart-axis-y></chart-axis></c3chart></div><div ng-if=\"question.answer_type == \'likert\'\" layout=\"row\" \nstyle=\"padding: 0 30px\"><div class=\"padding-left-60\"><md-icon md-font-icon=\"icon-thumb-down\" class=\"s32\"></md-icon>\n</div><div flex class=\"padding-top-10\"><div style=\"border-top: 1px dashed gray\"></div></div><div \nclass=\"padding-right-60\" style=\"position: relative\"><md-icon md-font-icon=\"icon-thumb-up\" class=\"s32\" \nstyle=\"position: absolute; top: -10px\"></md-icon></div></div></div><div flex \nng-if=\"!question.showChart && question.answer_type == \'input\'\" class=\"padding-30\"><md-whiteframe \nclass=\"md-whiteframe-1dp margin-5 padding-15\" layout layout-align=\"start center\" \nng-repeat=\"answer in question.currentAnswers\"><span>{{answer.answer_text}}</span></md-whiteframe></div></div></div>\n</div>");
$templateCache.put("app/main/results/views/share-link/share-link.html","<div class=\"share-link\" aria-label=\"share-link\"><div class=\"triangle\" data-reactid=\".0.1.0.0.0.0.2.1.3.0\"><span></span>\n</div><div class=\"content\" layout=\"column\"><div class=\"title\"><span translate=\"RESULTS.ANYONE_LINK\"></span></div><div \nclass=\"link\"><a href=\"{{vm.link}}\" target=\"_blank\">{{vm.link}}</a></div><div class=\"copy-icon\"><md-icon \nmd-font-icon=\"icon-content-copy\" clipboard text=\"vm.link\"></md-icon></div><div><span translate=\"RESULTS.COPY_PASTE\">\n</span></div></div></div>");
$templateCache.put("app/main/survey/views/other-surveys/other-surveys.html","<div id=\"other-surveys\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-if=\"vm.selectedProject.id\"><div \nclass=\"top-bg\" ng-class=\"vm.topBgClass\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clipboard-outline\"></md-icon><span \ntranslate=\"SURVEY.OTHER_SURVEYS_TITLE\">Copy from existing surveys (make duplicate)</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SURVEY.SEARCH\" flex></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SURVEY.SURVEY_FORM\">Survey-Form\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"TOOLBAR.PROJECT\">Project</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"SURVEY.QUESTIONS\">Questions</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SURVEY.LANGUAGE\">Language</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SURVEY.ACTIONS\">Actions</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"survey in vm.surveys\"><td>{{survey.title}}</td><td>{{survey.subgeo.name}}\n</td><td>{{survey.survey_configurations.length}}</td><td>{{vm.languages[survey.language]}}</td><td><md-menu><md-button \nclass=\"md-fab md-mini md-primary\" aria-label=\"Open menu\" ng-click=\"$mdOpenMenu()\"><md-icon \nmd-font-icon=\"icon-content-copy\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button \nng-click=\"vm.gotoSurveyPreview(survey)\" aria-label=\"Survey preview\" translate \ntranslate-attr-aria-label=\"SURVEY.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" class=\"s16\"></md-icon><span \ntranslate=\"SURVEY.PREVIEW\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.importSurvey(survey)\" aria-label=\"Import survey\" translate \ntranslate-attr-aria-label=\"SURVEY.IMPORT_SURVEY\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s16\"></md-icon><span \ntranslate=\"SURVEY.IMPORT_SURVEY\"></span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody>\n</table></div></div></div></div>");
$templateCache.put("app/main/survey/views/questions/questions.html","<div id=\"questions\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg\" ng-class=\"vm.topBgClass\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"goto-products-button md-icon-button\" aria-label=\"Go to Surveys\" \nng-click=\"vm.goToSurveys()\" translate translate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><span translate=\"QUESTION.QUESTIONS_SURVEY\">Questions for survey\n</span> <span>: {{vm.selectedSurvey.title}} (<span class=\"capitalize\">{{vm.selectedProject.name}}</span>)</span></div>\n</div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SURVEY.SEARCH\" flex></div></div><div \nid=\"survey-questions-btn\"><md-fab-speed-dial md-open=\"vm.isNewQuestionOpen\" md-direction=\"left\" class=\"md-scale\">\n<md-fab-trigger><md-button aria-label=\"menu\" class=\"md-fab md-primary\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button aria-label=\"Create\" \nclass=\"md-fab md-raised md-mini gray-light-btn\" ng-click=\"vm.gotoQuestionDetail()\"><md-icon md-font-icon=\"icon-pencil\" \naria-label=\"Create\"></md-icon></md-button><md-button aria-label=\"Copy\" class=\"md-fab md-raised md-mini gray-light-btn\" \nui-sref=\"app.survey.copyquestions\"><md-icon md-font-icon=\"icon-content-copy\" aria-label=\"Copy\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"QUESTION.QUESTION\">Question</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"QUESTION.MANDATORY\">Mandatory</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"QUESTION.TYPE\">Type</span></div>\n</th><th class=\"secondary-text\" ng-if=\"!vm.readOnly\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SURVEY.ACTIONS\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"question in vm.questions | orderBy: question.question_order\"><td>{{question.question_order}}</td><td>\n{{question.survey_question.question}}</td><td><span translate=\"QUESTION.YES\" ng-if=\"question.mandatory == 1\"></span> \n<span translate=\"QUESTION.NO\" ng-if=\"question.mandatory == 0\"></span></td><td>\n{{vm.answerTypes[question.survey_question.answer_type]}}</td><td ng-if=\"!vm.readOnly\"><md-menu><button \nclass=\"gray-md-icon-btn\" aria-label=\"Open menu\" ng-click=\"$mdOpenMenu()\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"vm.gotoQuestionDetail(question)\" \naria-label=\"Question details\" translate translate-attr-aria-label=\"QUESTION.DETAILS\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><span translate=\"SURVEY.EDIT\"></span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.deleteQuestion(question)\" aria-label=\"Delete question\" translate \ntranslate-attr-aria-label=\"QUESTION.DELETE\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon><span \ntranslate=\"QUESTION.DELETE\"></span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table>\n</div></div></div></div>");
$templateCache.put("app/main/survey-new/views/assign/assign-surveys.html","<div id=\"assign-surveys\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-if=\"vm.selectedProject.id\"><div \nclass=\"top-bg\" ng-class=\"vm.topBgClass\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button class=\"goto-products-button md-icon-button\" \naria-label=\"Go back\" ng-click=\"vm.goBack()\" translate translate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><span translate=\"SURVEY.PARTICIPANTS_SURVEY\">\nParticipants in survey</span> <span>: {{vm.selectedSurvey.title}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"select-rounds h2\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"pr-10\"><span translate=\"SURVEY.ROUNDS\"></span>:</span><md-select class=\"white-select-bg\" \nng-model=\"vm.selectedRound\" ng-change=\"vm.changeSelectedRound()\" aria-label=\"Round\" ng-if=\"!vm.loadingRounds\">\n<md-option ng-repeat=\"round in vm.rounds\" ng-value=\"round\">{{round.round}}</md-option></md-select></div><div \nclass=\"pl-10\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SURVEY.SEARCH\" flex></div></div></div><div \nid=\"save-buttons\"><md-button id=\"save-btn\" class=\"md-fab md-primary\" aria-label=\"New survey\" \nng-click=\"vm.savePendings()\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th>\n<md-checkbox ng-model=\"vm.checkboxAll\" aria-label=\"pending\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-change=\"vm.toggleAll()\" style=\"margin-bottom: 0\"></md-checkbox></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SHARED.FIRST_NAME\"></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SHARED.LAST_NAME\"></span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SHARED.BIRTHYEAR\">\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SHARED.GENDER\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"SHARED.HOMETOWN\"></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SHARED.ADDRESS\"></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SURVEY.COMPLETED\"></span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"farmer in vm.farmers\"><td><md-checkbox ng-model=\"farmer.pending_round\" \naria-label=\"pending\" ng-change=\"vm.countSelected()\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-if=\"!farmer.pending.finished\" style=\"margin-bottom: 0\"></md-checkbox></td><td>{{farmer.firstname}}</td><td>\n{{farmer.lastname}}</td><td>{{farmer.birthyear}}</td><td>{{farmer.gender}}</td><td>{{farmer.locality.name}}</td><td>\n{{farmer.address}}</td><td><md-icon ng-if=\"farmer.pending.finished\" md-font-icon=\"icon-checkbox-marked-circle\">\n</md-icon></td></tr></tbody></table></div></div><div id=\"pending-selected\"><h3><strong><span \ntranslate=\"SURVEY.SELECTED\"></span><span>: </span>{{ vm.selectedFarmersCount }} <span translate=\"SURVEY.OF\"></span>\n {{ vm.farmers.length }}</strong></h3></div></div></div>");
$templateCache.put("app/main/survey-new/views/other-surveys/other-surveys.html","<div id=\"other-surveys\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-if=\"vm.selectedProject.id\"><div \nclass=\"top-bg\" ng-class=\"vm.topBgClass\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clipboard-outline\"></md-icon><span \ntranslate=\"SURVEY.OTHER_SURVEYS_TITLE\">Copy from existing surveys (make duplicate)</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SURVEY.SEARCH\" flex></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SURVEY.SURVEY_FORM\">Survey-Form\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"TOOLBAR.PROJECT\">Project</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"SURVEY.QUESTIONS\">Questions</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SURVEY.LANGUAGE\">Language</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SURVEY.ACTIONS\">Actions</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"survey in vm.surveys\"><td>{{survey.title}}</td><td>{{survey.subgeo.name}}\n</td><td>{{survey.survey_configurations.length}}</td><td>{{vm.languages[survey.language]}}</td><td><md-menu><md-button \nclass=\"md-fab md-mini md-primary\" aria-label=\"Open menu\" ng-click=\"$mdOpenMenu()\"><md-icon \nmd-font-icon=\"icon-content-copy\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button \nng-click=\"vm.gotoSurveyPreview(survey)\" aria-label=\"Survey preview\" translate \ntranslate-attr-aria-label=\"SURVEY.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" class=\"s16\"></md-icon><span \ntranslate=\"SURVEY.PREVIEW\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.importSurvey(survey)\" aria-label=\"Import survey\" translate \ntranslate-attr-aria-label=\"SURVEY.IMPORT_SURVEY\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s16\"></md-icon><span \ntranslate=\"SURVEY.IMPORT_SURVEY\"></span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody>\n</table></div></div></div></div>");
$templateCache.put("app/main/survey-new/views/questions/questions.html","<div id=\"questions\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg\" ng-class=\"vm.topBgClass\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"goto-products-button md-icon-button\" aria-label=\"Go to Surveys\" \nng-click=\"vm.goToSurveys()\" translate translate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><span translate=\"QUESTION.QUESTIONS_SURVEY\">Questions for survey\n</span> <span>: {{vm.selectedSurvey.title}} (<span class=\"capitalize\">{{vm.selectedProject.name}}</span>)</span></div>\n</div></div><div id=\"questions-btn\"><md-fab-speed-dial md-open=\"vm.isNewQuestionOpen\" md-direction=\"left\" \nclass=\"md-scale\"><md-fab-trigger><md-button aria-label=\"menu\" class=\"md-fab md-primary\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button aria-label=\"Create\" \nclass=\"md-fab md-raised md-mini gray-light-btn\" ng-click=\"vm.addQuestion(\'...\')\"><md-icon md-font-icon=\"icon-plus\" \naria-label=\"Create\"></md-icon></md-button><md-button aria-label=\"Graph\" \nclass=\"md-fab md-raised md-mini gray-light-btn\" ng-click=\"vm.orderGraph()\"><md-icon \nmd-font-icon=\"icon-format-object-square\" aria-label=\"Graph\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial>\n</div><div id=\"save-btn\"><md-button aria-label=\"Save\" class=\"md-fab md-primary\" ng-disabled=\"vm.hasErrors\" \nng-click=\"vm.saveQuestions()\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage\" layout=\"column\" flex><div id=\"divPaperWrapper\" \nstyle=\"overflow-y: scroll\"><div id=\"paper-parent-restriction\" style=\"width: 100%; height: 100%\"></div></div><div \nclass=\"data-table\" ng-if=\"vm.selectedItem\"><div layout=\"row\" layout-align=\"space-between center\"><h2 \nng-if=\"vm.selectedItem.attributes.elementType == \'question\'\" translate=\"QUESTION.QUESTION\">Question</h2><h2 \nng-if=\"vm.selectedItem.attributes.type == \'link\'\" translate=\"QUESTION.CONNECTOR\">Connector</h2><md-button \naria-label=\"Delete\" class=\"md-icon-button md-warn\" ng-click=\"vm.deleteItem()\"><md-icon md-font-icon=\"icon-delete\" \naria-label=\"Delete\"></md-icon></md-button></div><div ng-if=\"vm.selectedItem.attributes.elementType == \'question\'\"><div \nclass=\"pb-10\"><h2 ng-if=\"vm.selectedItem.attributes.errors.length > 0\" translate=\"QUESTION.ERRORS.ERRORS\">Errors</h2>\n<ul><li style=\"color:var(--error-color)\" ng-repeat=\"error in vm.selectedItem.attributes.errors\">{{error}}</li></ul>\n</div><md-input-container class=\"md-block\"><label translate=\"QUESTION.QUESTION\"></label><textarea \nng-model=\"vm.selectedItem.attributes.survey_config.survey_question.question\" ng-change=\"vm.updateQuestion()\" \nng-model-options=\"{ debounce: 200 }\" maxlength=\"255\" required>\n                            </textarea>\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"QUESTION.ANSWER_TYPE\"></label><md-select \nname=\"answerType\" ng-model=\"vm.selectedItem.attributes.survey_config.survey_question.answer_type\" \nng-change=\"vm.answerTypeChange()\" required><md-option ng-repeat=\"option in vm.answerTypes\" ng-value=\"option.value\">\n{{option.name}}</md-option></md-select></md-input-container></div><div \nng-if=\"vm.selectedItem.attributes.type == \'link\' || vm.canBeLastQuestion\"><div class=\"pb-10\"><h2 \nng-if=\"vm.selectedItem.attributes.guard.errors.length>0\" translate=\"QUESTION.ERRORS.ERRORS\">Errors</h2><ul><li \nstyle=\"color:var(--error-color)\" ng-repeat=\"error in vm.selectedItem.attributes.guard.errors\">{{error}}</li></ul></div>\n<md-input-container class=\"md-block\"><label translate=\"QUESTION.SELECTOR\"></label><md-select name=\"selector\" \nng-model=\"vm.selectedItem.attributes.guard.selector\" ng-change=\"vm.checkValidity()\" \nng-model-options=\"{ debounce: 200 }\"><md-option ng-repeat=\"option in vm.currentlyPossibleSelectors\" \nng-value=\"option.value\">{{option.name}}</md-option></md-select></md-input-container><div \nng-if=\"vm.selectedItem.attributes.guard.selector ==\'value_equals\' ||\n                            vm.selectedItem.attributes.guard.selector ==\'text_length_greater\' ||\n                            vm.selectedItem.attributes.guard.selector ==\'text_length_smaller\' ||\n                            vm.selectedItem.attributes.guard.selector ==\'value_greater\' ||\n                            vm.selectedItem.attributes.guard.selector ==\'value_greater_equal\' ||\n                            vm.selectedItem.attributes.guard.selector ==\'value_smaller\' ||\n                            vm.selectedItem.attributes.guard.selector ==\'value_smaller_equal\' ||\n                            vm.selectedItem.attributes.guard.selector == \'value_between\'\" \nclass=\"pt-10\"><md-input-container class=\"md-block\"><label translate=\"QUESTION.VAL_1\"></label><input type=\"number\" \nng-model=\"vm.selectedItem.attributes.guard.val_1\" ng-change=\"vm.checkValidity()\" ng-model-options=\"{ debounce: 500 }\">\n</md-input-container></div><div style=\"color:var(--info-color)\" \nng-if=\"vm.parentConfigNode \n                            && vm.parentConfigNode.attributes.survey_config.survey_question.answer_type ==\'boolean\' && vm.selectedItem.attributes.guard.selector ==\'value_equals\'\">\n0 = false, 1 = true</div><div style=\"color:var(--info-color)\" \nng-if=\"vm.parentConfigNode \n                            && vm.parentConfigNode.attributes.survey_config.survey_question.answer_type ==\'multiple_choice\'\" \ntranslate=\"QUESTION.INFO.FOR_MULTI_CHOICE\">\nFor mutliple choice, only the amount of selected choices is taken into account, not which specific choice was selected ot not.\n</div><div ng-if=\"vm.selectedItem.attributes.guard.selector == \'value_between\'\"><md-input-container class=\"md-block\">\n<label translate=\"QUESTION.VAL_2\"></label><input type=\"number\" ng-model=\"vm.selectedItem.attributes.guard.val_2\" \nng-change=\"vm.checkValidity()\" ng-model-options=\"{ debounce: 500 }\"></md-input-container></div><div \nng-if=\"vm.parentConfigNode \n                            && (vm.parentConfigNode.attributes.survey_config.survey_question.answer_type == \'multiple_choice\'\n                                || vm.parentConfigNode.attributes.survey_config.survey_question.answer_type == \'single_choice\')\">\n<h2 translate=\"QUESTION.ANSWER_CHOICES\">Choices:</h2><div layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"choice in vm.selectedItem.attributes.guard.choices\" class=\"choices\"><md-input-container class=\"small-input\">\n<input name=\"title\" ng-model=\"choice.choice\" type=\"text\"></md-input-container><md-button aria-label=\"Delete\" \nclass=\"md-icon-button md-warn\" ng-click=\"vm.deleteChoice(choice)\"><md-icon md-font-icon=\"icon-delete\" \naria-label=\"Delete\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"space-between center\" class=\"choices\">\n<md-input-container class=\"small-input\"><input name=\"title\" ng-model=\"vm.newChoice\" type=\"text\"></md-input-container>\n<md-button aria-label=\"Add\" class=\"md-icon-button md-primary\" ng-click=\"vm.addChoice()\"><md-icon \nmd-font-icon=\"icon-plus\" aria-label=\"Add\"></md-icon></md-button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/workflow/views/variables/workflow-variables.html","<div id=\"workflow-variables\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-if=\"vm.selectedProject.id\"><div \nclass=\"top-bg\" ng-class=\"vm.topBgClass\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button class=\"goto-products-button md-icon-button\" \naria-label=\"Go to Workflows\" ng-click=\"vm.goToWorkflows()\" translate translate-attr-aria-label=\"EC.GO_TO_PRODUCTS\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><span translate=\"WORKFLOW.VARIABLES\">:</span>:&nbsp; \n<span class=\"capitalize\">{{vm.selectedWorkflow.name}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"SURVEY.SEARCH\" flex></div></div><div id=\"survey-buttons\"><md-fab-speed-dial \nmd-open=\"vm.isWorkflowBtnOpen\" md-direction=\"left\" class=\"md-scale\"><md-fab-trigger><md-button aria-label=\"menu\" \nclass=\"md-fab md-primary\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></md-fab-trigger><md-fab-actions>\n<md-button aria-label=\"Import\" class=\"md-fab md-raised md-mini gray-light-btn\" ng-click=\"vm.goToVariableImport()\">\n<md-icon md-font-icon=\"icon-calendar-plus\" aria-label=\"Copy\"></md-icon></md-button><md-button aria-label=\"Create\" \nclass=\"md-fab md-raised md-mini gray-light-btn\" ng-click=\"vm.goToVariableDetail()\"><md-icon md-font-icon=\"icon-plus\" \naria-label=\"Create\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"QUESTION.QUESTION\">Question\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORKFLOW.VARIABLE\">Variable</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"WORKFLOW.SUBSET\">Subset</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"WORKFLOW.DATA_DESCRIPTION\">DataDescription</span></div></th>\n<th class=\"secondary-text\" style=\"width: 200px\"><div><div layout=\"row\" layout-align=\"end center\"><div class=\"pr-10\">\n<span class=\"column-title\" translate=\"WORKFLOW.VIEW_HIDE\">View/Hide</span></div><div style=\"width: 170px\"><div \nstyle=\"text-align: center\"><span class=\"column-title\" translate=\"WORKFLOW.ON_REPORT\">On report</span></div><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"pt-15\"><div><span class=\"column-title\" \ntranslate=\"WORKFLOW.ALL\"></span></div><div><span class=\"column-title\" translate=\"WORKFLOW.TEXT\"></span></div><div><span\n class=\"column-title\" translate=\"WORKFLOW.CHART\"></span></div><div><span class=\"column-title\" translate=\"WORKFLOW.MAP\">\n</span></div></div></div></div></div></th></tr></thead><tbody><tr ng-repeat=\"variable in vm.variables\"><td>\n{{variable.question}}</td><td><div layout=\"row\" layout-align=\"space-between center\"><div>{{ variable.name }}<br>\n({{ variable.data_type }})</div><md-button aria-label=\"edit\" class=\"md-icon-button\" \nng-click=\"vm.goToVariableDetail(variable)\"><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button>\n</div></td><td><div ng-show=\"vm.mqInitialized\"><span id=\"definition-{{variable.id}}\">{{ variable.definitionToShow }}\n</span></div></td><td></td><td><div layout=\"row\" layout-align=\"end center\"><div class=\"pr-10\"><md-button \naria-label=\"view\" class=\"md-icon-button\" ng-if=\"variable.view\" ng-click=\"vm.viewHideVariable(false, variable)\"><md-icon\n md-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button aria-label=\"hide\" class=\"md-icon-button\" \nng-if=\"!variable.view\" ng-click=\"vm.viewHideVariable(true, variable)\"><md-icon md-font-icon=\"icon-eye-off\" \naria-label=\"hide\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"end center\" class=\"pt-15\"><md-checkbox \nng-model=\"variable.reportAll\" aria-label=\"report checkbox\" ng-change=\"vm.onReportVariableChange(variable)\" \nng-true-value=\"true\" ng-false-value=\"false\"></md-checkbox><md-checkbox ng-model=\"variable.reportText\" \naria-label=\"report text checkbox\" ng-change=\"vm.onReportVariableChange(variable)\" ng-true-value=\"true\" \nng-false-value=\"false\" ng-disabled=\"variable.reportAll\"></md-checkbox><md-checkbox ng-model=\"variable.reportChart\" \naria-label=\"report chart checkbox\" ng-change=\"vm.onReportVariableChange(variable)\" ng-true-value=\"true\" \nng-false-value=\"false\" ng-disabled=\"variable.reportAll\"></md-checkbox><md-checkbox ng-model=\"variable.reportMap\" \naria-label=\"report map checkbox\" ng-change=\"vm.onReportVariableChange(variable)\" ng-true-value=\"true\" \nng-false-value=\"false\" ng-disabled=\"variable.reportAll\"></md-checkbox></div></div></td></tr></tbody></table></div>\n</div></div></div><div ng-if=\"!vm.selectedProject.id\" class=\"padding-30\"><md-whiteframe \nclass=\"md-whiteframe-3dp padding-50 red-100-bg\" layout layout-align=\"center center\"><span \ntranslate=\"SURVEY.SELECT_PROJECT\">Please select one project.</span></md-whiteframe></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/flags/views/dialogs/edit-flag-entry/edit-flag-entry-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" md-theme=\"{{vm.theme}}\"><form name=\"EditFlagForm\">\n<md-toolbar class=\"gray2-bg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"FLAGS.PREVIEW_FLAG_ITEM\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" tranlate translate-aria-label=\"SURVEY.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\"><md-input-container \nclass=\"md-block\" ng-if=\"vm.title\"><label translate=\"FLAGS.TITLE\">Title</label><input name=\"title\" \nng-model=\"vm.element.title\" type=\"text\" ng-disabled=\"!vm.editMode\" required><div \nng-messages=\"EditFlagForm.title.$error\"><div ng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">\nRequired field</span></div></div></md-input-container><md-input-container class=\"md-block\" ng-if=\"vm.description\">\n<label translate=\"SURVEY.DESCRIPTION\">Description</label><textarea name=\"description\" \nng-model=\"vm.element.description\" rows=\"2\" ng-disabled=\"!vm.editMode\" required></textarea><div \nng-messages=\"EditFlagForm.description.$error\"><div ng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">\nRequired field</span></div></div></md-input-container><md-input-container class=\"md-block\" ng-if=\"vm.text\"><label \ntranslate=\"FLAGS.TEXT\">Text</label><textarea name=\"description\" ng-model=\"vm.element.text\" rows=\"2\" \nng-disabled=\"!vm.editMode\" required></textarea><div ng-messages=\"EditFlagForm.description.$error\"><div \nng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">Required field</span></div></div></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\"><div flex=\"100\" layout=\"row\" layout-align=\"end center\">\n<md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.loading\" md-diameter=\"40\" class=\"md-primary\">\n</md-progress-circular><md-button class=\"send-button gray2-btn md-raised\" aria-label=\"Close\" translate=\"SURVEY.CLOSE\" \nng-click=\"vm.closeDialog()\">Close</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Send\" \ntranslate=\"SURVEY.SAVE\" ng-if=\"vm.editMode\" ng-click=\"vm.saveElement()\" ng-disabled=\"EditFlagForm.$invalid\">Save\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/group/views/dialogs/group/group-dialog.html","<md-dialog class=\"group-dialog\" aria-label=\"New Message\" md-theme=\"{{vm.theme}}\"><form name=\"groupDetailsForm\">\n<md-toolbar class=\"gray2-bg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"GROUP.GROUP_DETAILS\">Group details</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"SURVEY.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\">\n<md-input-container class=\"md-block\"><label translate=\"SURVEY.TITLE\">Title</label><input name=\"title\" \nng-model=\"vm.groupDetails.name\" type=\"text\" required><div ng-messages=\"groupDetailsForm.title.$error\"><div \nng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">Required field</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"SURVEY.DESCRIPTION\">Description</label><textarea \nname=\"description\" ng-model=\"vm.groupDetails.description\" rows=\"2\" required></textarea><div \nng-messages=\"groupDetailsForm.description.$error\"><div ng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">\nRequired field</span></div></div></md-input-container><label><span translate=\"GROUP.HOW_TO_ADD_USERS\"></span></label>\n<div layout=\"row\" class=\"padding-top-10\" ng-if=\"!vm.showAllSurveys\"><md-radio-group ng-model=\"vm.addUsersType\" \nlayout=\"row\" ng-change=\"vm.filterTypeChange()\"><md-radio-button value=\"auto\" aria-label=\"Radio button\"><span \ntranslate=\"GROUP.FILTER_AUTO\"></span></md-radio-button><md-radio-button value=\"manual\" aria-label=\"Radio button\"><span \ntranslate=\"GROUP.FILTER_MANUAL\"></span></md-radio-button></md-radio-group></div><div ng-if=\"vm.addUsersType == \'auto\'\">\n<div layout=\"row\" class=\"filter-borders margin-top-15 text-center\"><div flex=\"20\" class=\"padding-top-10\"><label \ntranslate=\"GROUP.FILTER\"></label></div><div flex=\"25\" class=\"padding-top-10 border-left\"><label \ntranslate=\"GROUP.FIRST_VALUE\">Value</label></div><div flex=\"20\" class=\"padding-top-10 border-left\"><label \ntranslate=\"GROUP.COMPARATOR\"></label></div><div flex=\"25\" class=\"padding-top-10 border-left\"><label \ntranslate=\"GROUP.SECOND_VALUE\">Value</label></div><div flex=\"10\" class=\"padding-top-10 border-left\"></div></div><div \nlayout=\"row\" class=\"filter-borders\" ng-repeat=\"userFilter in vm.createdFilters track by userFilter.id\"><div flex=\"20\" \nclass=\"select-filter\"><md-select name=\"filter\" ng-model=\"userFilter.selectedFilter\" aria-label=\"select\" required>\n<md-option ng-repeat=\"filter in userFilter.filters\" ng-value=\"filter\">{{filter.label}}</md-option></md-select><div \nng-messages=\"surveyDetailsForm.answerType.$error\"><div ng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">\nRequired field</span></div></div></div><div flex=\"25\" class=\"padding-top-10 border-left\"><div \nng-if=\"userFilter.selectedComparator.values > 1\"><md-datepicker ng-model=\"userFilter.selectedFilter.firstValue\" \nng-if=\"userFilter.selectedFilter.type == \'date\'\" aria-label=\"date\" required></md-datepicker><div \nng-if=\"userFilter.selectedFilter.type == \'select\'\" class=\"select-filter-dynamic\"><md-select name=\"comparator\" \nng-model=\"userFilter.selectedFilter.firstValue\" aria-label=\"select\" required><md-option \nng-repeat=\"option in userFilter.selectedFilter.typeValues\" ng-value=\"option.value\">{{option.label}}</md-option>\n</md-select></div></div></div><div flex=\"20\" class=\"select-filter border-left\"><md-select name=\"comparator\" \nng-model=\"userFilter.selectedComparator\" ng-if=\"userFilter.selectedFilter\" aria-label=\"select\" required><md-option \nng-repeat=\"comparator in userFilter.comparators\" ng-value=\"comparator\" \nng-if=\"vm.showComparator(userFilter.selectedFilter, comparator.id)\">{{comparator.label}}</md-option></md-select><div \nng-messages=\"surveyDetailsForm.answerType.$error\"><div ng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">\nRequired field</span></div></div></div><div flex=\"25\" class=\"border-left padding-top-10\"><md-datepicker \nng-model=\"userFilter.selectedFilter.secondValue\" aria-label=\"date\" ng-if=\"userFilter.selectedFilter.type == \'date\'\" \nrequired></md-datepicker><div ng-if=\"userFilter.selectedFilter.type == \'select\'\" class=\"select-filter-dynamic\">\n<md-select name=\"comparator\" ng-model=\"userFilter.selectedFilter.secondValue\" aria-label=\"select\" required><md-option \nng-repeat=\"option in userFilter.selectedFilter.typeValues\" ng-value=\"option.value\">{{option.label}}</md-option>\n</md-select></div></div><div flex=\"10\" layout=\"row\" layout-align=\"center center\" class=\"padding-top-10 border-left\">\n<md-button class=\"md-fab md-mini md-primary\" aria-label=\"Add filter\" ng-click=\"vm.addFilter()\" \nng-if=\"userFilter.id == vm.currentFilterId\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-warn\" aria-label=\"Add filter\" ng-click=\"vm.removeFilter(userFilter)\" \nng-if=\"userFilter.id != vm.currentFilterId\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div>\n</div><div ng-if=\"vm.addUsersType == \'manual\'\" class=\"padding-top-20\"><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"GROUP.FIRST_NAME\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"GROUP.LAST_NAME\">Surname</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"GROUP.BIRTH_YEAR\">Birth(year)</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"GROUP.GENDER\">Gender</span></div></th></tr></thead><tbody><tr \nng-repeat=\"user in vm.usersByRegion\" style=\"height: 70px\"><td><md-checkbox ng-model=\"user.inGroup\" \naria-label=\"Import checkbox\" ng-true-value=\"true\" ng-false-value=\"false\"></md-checkbox></td><td>{{user.first_name}}\n</td><td>{{user.last_name}}</td><td>{{user.profile.birth_year}}</td><td>{{user.profile.gender}}</td></tr></tbody>\n</table></div></md-dialog-content><md-dialog-actions layout=\"row\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"send-button gray2-btn md-raised\" aria-label=\"Close\" \ntranslate=\"SURVEY.CLOSE\" ng-click=\"vm.closeDialog()\">Close</md-button><md-button class=\"md-raised md-primary\" \naria-label=\"Save\" translate=\"SURVEY.SAVE\" ng-click=\"vm.saveGroup()\" ng-disabled=\"groupDetailsForm.$invalid\">Save\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/flags/views/dialogs/show-description/show-description-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" md-theme=\"{{vm.theme}}\"><form name=\"surveyQuestionsForm\">\n<md-toolbar class=\"gray2-bg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"FLAGS.FLAG_DESCRIPTION\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" tranlate translate-aria-label=\"SURVEY.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\"><div layout=\"row\"><strong><span \ntranslate=\"SURVEY.DESCRIPTION\"></span></strong> <span>: {{vm.survey.description}}</span></div><div layout=\"row\"><span>\n{{vm.flag.comment}}</span></div></md-dialog-content><md-dialog-actions layout=\"row\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"end center\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.loading\" md-diameter=\"40\" \nclass=\"md-primary\"></md-progress-circular><md-button class=\"send-button gray2-btn md-raised\" aria-label=\"Close\" \ntranslate=\"SURVEY.CLOSE\" ng-click=\"vm.closeDialog()\">Close</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/group/views/dialogs/notification/group-notification-dialog.html","<md-dialog class=\"group-dialog\" aria-label=\"New Message\" md-theme=\"{{vm.theme}}\"><form name=\"notificationForm\">\n<md-toolbar class=\"gray2-bg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"GROUP.SEND_NOTIFICATION\">Group details</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"SURVEY.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\"><p>\n<span translate=\"GROUP.MOBILE_NOTIFICATION\"></span>&nbsp;{{vm.group.name}}</p><br><md-input-container class=\"md-block\">\n<label translate=\"SURVEY.DESCRIPTION\">Description</label><textarea name=\"description\" ng-model=\"vm.notificationMsg\" \nrows=\"2\" required></textarea><div ng-messages=\"notificationForm.description.$error\"><div ng-message=\"required\"><span \ntranslate=\"SURVEY.REQUIRED_FIELD\">Required field</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"GROUP.SCHEDULE\">Schedule</label><md-select name=\"schedule\" \nng-model=\"vm.schedule.type\" ng-change=\"vm.changeSchedule()\" required><md-option \nng-repeat=\"option in vm.scheduleOptions\" ng-value=\"option.type\">{{option.description}}</md-option></md-select><div \nng-messages=\"notificationForm.schedule.$error\"><div ng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">\nRequired field</span></div></div></md-input-container><div flex ng-if=\"vm.schedule.type == 2\"><adm-dtp name=\"datetime\" \nng-model=\"vm.schedule.datetime\" full-data=\"vm.schedule.date_details\" options=\"{multiple: false, minuteStep: 1}\">\n</adm-dtp><div ng-messages=\"notificationForm.datetime.$error\"><div ng-message=\"required\"><span \ntranslate=\"SURVEY.REQUIRED_FIELD\">Required field</span></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><div flex=\"100\" layout=\"row\" layout-align=\"end center\"><md-button class=\"send-button gray2-btn md-raised\" \naria-label=\"Close\" translate=\"SURVEY.CLOSE\" ng-click=\"vm.closeDialog()\">Close</md-button><md-button \nclass=\"md-primary md-raised\" aria-label=\"Save\" translate=\"SHARED.SEND\" ng-click=\"vm.sendNotification()\" \nng-disabled=\"notificationForm.$invalid || (vm.schedule.type == 2 && vm.schedule.datetime == null)\">Send</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/participants/views/dialogs/assign-role/assign-role-dialog.html","<md-dialog class=\"assign-role-dialog\" aria-label=\"Role\" md-theme=\"{{vm.theme}}\"><form name=\"assignRoleForm\"><md-toolbar\n class=\"gray2-bg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"PARTICIPANTS.ASSIGN_ROLE\">Assign role</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" tranlate translate-aria-label=\"SURVEY.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\"><h3><span \ntranslate=\"PARTICIPANTS.ASSIGN_ROLE_TEXT\"></span>\n: {{ vm.participant.user.first_name +\' \'+ vm.participant.user.first_name }}</h3><md-input-container class=\"md-block\">\n<label translate=\"PARTICIPANTS.ROLES\"></label><md-select name=\"role\" ng-model=\"vm.selectedRoleId\" required>\n<md-optgroup><md-option ng-repeat=\"role in vm.roles | orderBy: \'name\'\" ng-value=\"role.id\">{{role.name}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"assignRoleForm.role.$error\"><div ng-message=\"required\"><span \ntranslate=\"SURVEY.REQUIRED_FIELD\">Required field</span></div></div></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\"><div flex=\"100\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"send-button gray2-btn md-raised\" aria-label=\"Close\" translate=\"SURVEY.CLOSE\" ng-click=\"vm.closeDialog()\">Close\n</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Save\" translate=\"SURVEY.SAVE\" \nng-click=\"vm.assignRole()\" ng-disabled=\"assignRoleForm.$invalid\">Save</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/process/views/dialogs/process/process-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"Access details\" md-theme=\"{{vm.theme}}\"><form name=\"processDataForm\">\n<md-toolbar class=\"gray2-bg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"PROCESS.ACCESS_DETAILS\">Access details</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"SURVEY.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\">\n<md-input-container class=\"md-block\"><label translate=\"PROCESS.DAYS_RATING\">Days</label><input name=\"days\" \nng-model=\"vm.accessData.proposal_days\" type=\"number\" required><div ng-messages=\"processDataForm.title.$error\"><div \nng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">Required field</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"PROCESS.PARTICIPANTS_REQUIRED\">Participants</label><input \nname=\"participants\" ng-model=\"vm.accessData.proposal_participants\" type=\"number\" required><div \nng-messages=\"processDataForm.answerType.$error\"><div ng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">\nRequired field</span></div></div></md-input-container><div flex layout=\"row\"><div layout-align=\"start center\" \nclass=\"padding-top-5\"><label translate=\"PROCESS.ALLOW_ANONYMOUS\">Allow anonymous</label></div><div \nclass=\"padding-left-20\"><md-radio-group name=\"anonymous\" ng-model=\"vm.accessData.anonymous\" layout=\"row\" required>\n<md-radio-button value=\"1\"><span translate=\"SHARED.YES\">Yes</span></md-radio-button><md-radio-button value=\"0\"><span \ntranslate=\"SHARED.NO\">No</span></md-radio-button></md-radio-group></div></div><div><label><strong>{{vm.errorMsg}}\n</strong></label></div></md-dialog-content><md-dialog-actions layout=\"row\"><div flex=\"80\" layout=\"row\"><div \nlayout-align=\"start center\" class=\"padding-top-5\"><label translate=\"PROCESS.ACCESS\">Mandatory</label></div><div \nclass=\"padding-left-20\"><md-radio-group name=\"mandatory\" ng-model=\"vm.accessData.private\" layout=\"row\" required>\n<md-radio-button value=\"0\"><span translate=\"PROCESS.PUBLIC\">Yes</span></md-radio-button><md-radio-button value=\"1\">\n<span translate=\"PROCESS.PRIVATE\">No</span></md-radio-button></md-radio-group></div></div><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"send-button gray2-btn md-raised\" aria-label=\"Close\" \ntranslate=\"SURVEY.CLOSE\" ng-click=\"vm.closeDialog()\">Close</md-button><md-button class=\"md-primary md-raised\" \naria-label=\"Send\" translate=\"SURVEY.SAVE\" ng-click=\"vm.save()\" ng-disabled=\"processDataForm.$invalid\">Save</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/question/views/dialogs/question-preview/question-preview-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" md-theme=\"{{vm.theme}}\"><form name=\"surveyDetailsForm\">\n<md-toolbar class=\"gray2-bg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"QUESTION.QUESTION_PREVIEW\">Question preview</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"SURVEY.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\"><div \nlayout=\"row\"><strong><span translate=\"SURVEY.LANGUAGE\"></span></strong> <span>: {{vm.languages[vm.question.language]}}\n</span></div><div layout=\"row\"><strong><span translate=\"QUESTION.QUESTION\"></span></strong> <span>\n: {{vm.question.question}}</span></div><div layout=\"column\" class=\"padding-top-15\"><div \nng-if=\"vm.question.answer_type == \'likert\'\"><div layout=\"row\"><span flex=\"5\" class=\"slider-label\">1</span><md-slider \nflex ng-model=\"surveyConf.slider\" min=\"1\" max=\"5\" aria-label=\"green\" class=\"md-accent\"></md-slider><span flex=\"5\" \nclass=\"padding-left-15 slider-label\">5</span></div></div><div layout=\"column\" \nng-if=\"vm.question.answer_type == \'single_choice\'\"><md-radio-group ng-model=\"vm.question.radioGroup\"><md-radio-button \nng-repeat=\"choice in vm.question.survey_choices\" ng-value=\"choice.id\" aria-label=\"choice\">{{choice.choice}}\n</md-radio-button></md-radio-group></div><div layout=\"column\" ng-if=\"vm.question.answer_type == \'multiple_choice\'\"><div\n ng-repeat=\"choice in vm.question.survey_choices\"><md-checkbox aria-label=\"checkbox\">{{choice.choice}}</md-checkbox>\n</div></div><div layout=\"column\" ng-if=\"vm.question.answer_type == \'input\'\"><md-input-container class=\"md-block\">\n<label></label><input ng-model=\"surveyConf.input\" type=\"text\" aria-label=\"input\"></md-input-container></div><div \nlayout=\"column\" ng-if=\"vm.question.answer_type == \'boolean\'\"><md-radio-group ng-model=\"surveyConf.radioGroup\">\n<md-radio-button ng-value=\"true\" aria-label=\"radio\"><span translate=\"QUESTION.YES\"></span></md-radio-button>\n<md-radio-button ng-value=\"false\" aria-label=\"radio\"><span translate=\"QUESTION.NO\"></span></md-radio-button>\n</md-radio-group></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"send-button gray2-btn md-raised\" aria-label=\"Close\" \ntranslate=\"SURVEY.CLOSE\" ng-click=\"vm.closeDialog()\">Close</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/question/views/dialogs/question-import/question-import-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" md-theme=\"{{vm.theme}}\"><form name=\"surveyDetailsForm\">\n<md-toolbar class=\"gray2-bg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"QUESTION.QUESTION_IMPORT\">Question import</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"SURVEY.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\"><h3 \ntranslate=\"SURVEY.SELECT_SURVEY_TO_IMPORT\">Please select the survey to import the selected questions</h3><br>\n<md-input-container class=\"md-block\"><label translate=\"QUESTION.SURVEY\"></label><md-select name=\"survey\" \nng-model=\"vm.survey\" required><md-option ng-repeat=\"survey in vm.surveys\" ng-value=\"survey\" \nng-if=\"survey.status == \'edit\'\">{{survey.title}}</md-option></md-select><div \nng-messages=\"surveyDetailsForm.answerType.$error\"><div ng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">\nRequired field</span></div></div></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><div \nflex=\"100\" layout=\"row\" layout-align=\"end center\"><md-button class=\"send-button gray2-btn md-raised\" \naria-label=\"Close\" translate=\"SURVEY.CLOSE\" ng-click=\"vm.closeDialog()\">Close</md-button><md-button \nclass=\"md-primary md-raised\" aria-label=\"Send\" translate=\"SURVEY.SAVE\" ng-click=\"vm.importQuestions()\" \nng-disabled=\"surveyDetailsForm.$invalid\">Save</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/reports/views/dialogs/report/report-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"Report details\" md-theme=\"{{vm.theme}}\"><form name=\"reportDetailsForm\">\n<md-toolbar class=\"gray2-bg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"REPORTS.DETAILS\">Details</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" tranlate translate-aria-label=\"SURVEY.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\"><md-input-container \nclass=\"md-block\"><label translate=\"SHARED.TITLE\">Title</label><input name=\"title\" ng-model=\"vm.reportDetails.title\" \ntype=\"text\" required><div ng-messages=\"reportDetailsForm.title.$error\"><div ng-message=\"required\"><span \ntranslate=\"SHARED.REQUIRED_FIELD\">Required field</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"SHARED.YEAR\">year</label><input name=\"year\" ng-model=\"vm.reportDetails.year\" \ntype=\"number\" required><div ng-messages=\"reportDetailsForm.year.$error\"><div ng-message=\"required\"><span \ntranslate=\"SHARED.REQUIRED_FIELD\">Required field</span></div></div></md-input-container><div ngf-drop ngf-select \nng-model=\"vm.file\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"false\" ngf-allow-dir=\"false\" \naccept=\"text/html\" ngf-pattern=\"\'text/html\'\">Drop html file here or click to select one</div><div ngf-no-file-drop>\nFile Drag/Drop is not supported for this browser</div><div ng-if=\"vm.file\">Selected file:<ul><li style=\"font:smaller\">\n{{vm.file.name}} {{vm.file.$error}} {{vm.file.$errorParam}}</li></ul></div><div><label><strong>{{vm.errorMsg}}</strong>\n</label></div></md-dialog-content><md-dialog-actions layout=\"row\"><div flex=\"80\" layout=\"row\"><div \nlayout-align=\"start center\" class=\"padding-top-5\"><label translate=\"SHARED.PUBLIC\">Public</label></div><div \nclass=\"padding-left-20\"><md-radio-group name=\"mandatory\" ng-model=\"vm.accessData.private\" layout=\"row\" required>\n<md-radio-button value=\"0\"><span translate=\"SHARED.YES\">Yes</span></md-radio-button><md-radio-button value=\"1\"><span \ntranslate=\"SHARED.NO\">No</span></md-radio-button></md-radio-group></div></div><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\" ng-if=\"!vm.saveInProgress || true\"><md-button class=\"send-button gray2-btn md-raised\" \naria-label=\"Close\" translate=\"SHARED.CLOSE\" ng-click=\"vm.closeDialog(false)\">Close</md-button><md-button \nclass=\"md-primary md-raised\" aria-label=\"Send\" translate=\"SHARED.SAVE\" ng-click=\"vm.upload()\" \nng-disabled=\"reportDetailsForm.$invalid || !vm.file\">Save</md-button></div><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\" ng-if=\"vm.saveInProgress\" style=\"padding-right: 15px\"><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/survey/views/dialogs/question/question-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Question\" md-theme=\"{{vm.theme}}\"><form name=\"questionDataForm\">\n<md-toolbar class=\"gray2-bg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"QUESTION.DIALOG_TITLE\">Question details</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"SURVEY.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\">\n<md-input-container class=\"md-block\"><label><span translate=\"QUESTION.QUESTION\">Question</span>\n ({{vm.selectedSurvey.language}})</label><input name=\"title\" ng-model=\"vm.questionData.question\" type=\"text\" required>\n<div ng-messages=\"questionDataForm.title.$error\"><div ng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">\nRequired field</span></div></div></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"QUESTION.ANSWER_TYPE\">Answer type</label><md-select name=\"answerType\" \nng-model=\"vm.questionData.answer_type\" ng-change=\"vm.changeAnswerType()\" required><md-option \nng-repeat=\"type in vm.answerTypes\" ng-value=\"type.code\">{{type.answer}}</md-option></md-select><div \nng-messages=\"surveyDetailsForm.answerType.$error\"><div ng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">\nRequired field</span></div></div></md-input-container><div ng-if=\"vm.showChoices\"><md-card><md-toolbar \nclass=\"blue-300-bg\"><h2 class=\"md-toolbar-tools\"><span translate=\"QUESTION.CHOICES_DETAILS\">Choices details</span></h2>\n</md-toolbar><md-card-content><div layout=\"row\"><md-input-container flex=\"80\" class=\"md-block\"><label><span \ntranslate=\"QUESTION.CHOICE\">Choice</span></label><input name=\"choice\" ng-model=\"vm.questionChoice\" type=\"text\"><div \nng-messages=\"questionDataForm.choice.$error\"><div ng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">\nRequired field</span></div></div></md-input-container><md-button flex=\"20\" class=\"md-secondary\" \nng-click=\"vm.addChoice(choice)\" aria-label=\"Add choice\"><span translate=\"QUESTION.ADD\">Add</span></md-button></div>\n<md-list ng-if=\"vm.questionData.choices.length > 0\"><md-subheader><span translate=\"QUESTION.ANSWER_CHOICES\">\nAnswer choices</span></md-subheader><md-list-item ng-repeat=\"choice in vm.questionData.choices\"><p>{{choice.text}}</p>\n<md-button class=\"md-secondary\" ng-click=\"vm.removeChoice(choice)\" aria-label=\"Delete choice\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s16\"></md-icon></md-button></md-list-item></md-list></md-card-content></md-card>\n</div><div><label><strong>{{vm.errorMsg}}</strong></label></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<div flex=\"80\" layout=\"row\"><div layout-align=\"start center\" class=\"padding-top-5\"><label \ntranslate=\"QUESTION.MANDATORY\">Mandatory</label></div><div class=\"padding-left-20\"><md-radio-group name=\"mandatory\" \nng-model=\"vm.mandatoryQuestion\" layout=\"row\" required><md-radio-button value=\"1\"><span translate=\"QUESTION.YES\">Yes\n</span></md-radio-button><md-radio-button value=\"0\"><span translate=\"QUESTION.NO\">No</span></md-radio-button>\n</md-radio-group></div></div><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"send-button gray2-btn md-raised\" aria-label=\"Close\" translate=\"SURVEY.CLOSE\" ng-click=\"vm.closeDialog()\">Close\n</md-button><md-button class=\"send-button md-primary md-raised\" aria-label=\"Send\" translate=\"SURVEY.SAVE\" \nng-click=\"vm.saveQuestion()\" ng-disabled=\"questionDataForm.$invalid\">Save</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/survey/views/dialogs/survey-preview/survey-preview-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" md-theme=\"{{vm.theme}}\"><form name=\"surveyQuestionsForm\">\n<md-toolbar class=\"gray2-bg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"SURVEY.SURVEY_PREVIEW\">Survey-form preview</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"SURVEY.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\"><div \nlayout=\"row\"><strong><span translate=\"SURVEY.TITLE\"></span></strong> <span>: {{vm.survey.title}}</span></div><div \nlayout=\"row\"><strong><span translate=\"SURVEY.DESCRIPTION\"></span></strong> <span>: {{vm.survey.description}}</span>\n</div><div layout=\"row\"><strong><span translate=\"SURVEY.LANGUAGE\"></span></strong> <span>\n: {{vm.languages[vm.survey.language]}}</span></div><div layout=\"row\"><strong><span translate=\"SURVEY.SHARE\"></span>\n</strong> <span>: <span ng-if=\"vm.survey.share\" translate=\"QUESTION.YES\"></span> <span ng-if=\"!vm.survey.share\" \ntranslate=\"QUESTION.NO\"></span></span></div><div layout=\"row\" class=\"padding-top-15\"><strong><span \ntranslate=\"SURVEY.QUESTIONS\"></span></strong></div><div layout=\"column\" class=\"padding-top-15\" \nng-repeat=\"surveyConf in vm.survey.survey_configurations | objectToArray | orderBy: \'question_order\'\"><div \nlayout=\"row\" style=\"border-bottom: 1px solid #E6E6E6\"><div style=\"width: 60px; padding-top: 10px\"><input \nng-model=\"surveyConf.question_order\" type=\"number\" class=\"order-input\" required></div><div flex><div \nng-if=\"surveyConf.survey_question.answer_type == \'likert\'\"><strong><span>{{surveyConf.survey_question.question}}</span>\n</strong><div layout=\"row\"><span flex=\"5\" class=\"slider-label\">1</span><md-slider flex ng-model=\"surveyConf.slider\" \nmin=\"1\" max=\"5\" aria-label=\"green\" class=\"md-accent\"></md-slider><span flex=\"5\" class=\"padding-left-15 slider-label\">5\n</span></div></div><div layout=\"column\" ng-if=\"surveyConf.survey_question.answer_type == \'single_choice\'\"><div \nlayout=\"row\" class=\"padding-bottom-15\"><strong><span>{{surveyConf.survey_question.question}}</span></strong></div>\n<md-radio-group ng-model=\"surveyConf.radioGroup\"><md-radio-button \nng-repeat=\"choice in surveyConf.survey_question.survey_choices\" ng-value=\"choice.id\">{{choice.choice}}\n</md-radio-button></md-radio-group></div><div layout=\"column\" \nng-if=\"surveyConf.survey_question.answer_type == \'multiple_choice\'\"><div layout=\"row\" class=\"padding-bottom-15\">\n<strong><span>{{surveyConf.survey_question.question}}</span></strong></div><div \nng-repeat=\"choice in surveyConf.survey_question.survey_choices\"><md-checkbox>{{choice.choice}}</md-checkbox></div>\n</div><div layout=\"column\" ng-if=\"surveyConf.survey_question.answer_type == \'input\'\"><md-input-container \nclass=\"md-block\"><label>{{surveyConf.survey_question.question}}</label><input ng-model=\"surveyConf.input\" type=\"text\">\n</md-input-container></div><div layout=\"column\" ng-if=\"surveyConf.survey_question.answer_type == \'boolean\'\"><div \nlayout=\"row\" class=\"padding-bottom-15\"><strong><span>{{surveyConf.survey_question.question}}</span></strong></div>\n<md-radio-group ng-model=\"surveyConf.radioGroup\"><md-radio-button ng-value=\"true\"><span translate=\"QUESTION.YES\">\n</span></md-radio-button><md-radio-button ng-value=\"false\"><span translate=\"QUESTION.NO\"></span></md-radio-button>\n</md-radio-group></div><div layout=\"column\" ng-if=\"surveyConf.survey_question.answer_type == \'number\'\">\n<md-input-container class=\"md-block\"><label>{{surveyConf.survey_question.question}}</label><input \nng-model=\"surveyConf.input\" type=\"number\"></md-input-container></div><div layout=\"column\" \nng-if=\"surveyConf.survey_question.answer_type == \'headline\'\"><div layout=\"row\" class=\"padding-bottom-15\"><strong><span>\n{{surveyConf.survey_question.question}}</span></strong></div></div></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><div flex=\"100\" layout=\"row\" layout-align=\"end center\"><md-progress-circular \nmd-mode=\"indeterminate\" ng-if=\"vm.loading\" md-diameter=\"40\" class=\"md-primary\"></md-progress-circular><md-button \nclass=\"send-button gray2-btn md-raised\" aria-label=\"Close\" translate=\"SURVEY.CLOSE\" ng-click=\"vm.closeDialog()\">Close\n</md-button><md-button class=\"send-button md-primary md-raised\" aria-label=\"Send\" translate=\"SURVEY.CHANGE_ORDER\" \nng-click=\"vm.changeQuestionsOrder()\" ng-disabled=\"surveyQuestionsForm.$invalid\">Save</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/survey/views/dialogs/survey/survey-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" md-theme=\"{{vm.theme}}\"><form name=\"surveyDetailsForm\">\n<md-toolbar class=\"gray2-bg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"SURVEY.DIALOG_TITLE\">Survey-forms details</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"SURVEY.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\">\n<md-input-container class=\"md-block\"><label translate=\"SURVEY.TITLE\">Title</label><input name=\"title\" \nng-model=\"vm.surveyDetails.title\" type=\"text\" ng-disabled=\"vm.surveyDetails.status == \'started\'\" required><div \nng-messages=\"surveyDetailsForm.title.$error\"><div ng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">\nRequired field</span></div></div></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"SURVEY.DESCRIPTION\">Description</label><textarea name=\"description\" ng-model=\"vm.surveyDetails.description\" \nrows=\"2\" ng-disabled=\"vm.surveyDetails.status == \'started\'\" required></textarea><div \nng-messages=\"surveyDetailsForm.description.$error\"><div ng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">\nRequired field</span></div></div></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"SURVEY.FINAL_MSG\">Final Message</label><textarea name=\"finalmsg\" ng-model=\"vm.surveyDetails.final_msg\" \nrows=\"2\" ng-disabled=\"vm.surveyDetails.status == \'started\'\" maxlength=\"512\"></textarea></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"SURVEY.GROUPS\"></label><md-select name=\"group\" \nng-model=\"vm.surveyDetails.groupIds\" ng-disabled=\"vm.surveyDetails.status == \'started\'\" multiple=\"multiple\" required>\n<md-optgroup label=\"{{vm.groupsLabel}}\"><md-option ng-repeat=\"group in vm.groups | orderBy: \'name\'\" \nng-value=\"group.id\">{{group.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"surveyDetailsForm.group.$error\"><div ng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">\nRequired field</span></div></div></md-input-container><div layout=\"row\"><div flex><label translate=\"SURVEY.START\">Start\n</label><md-datepicker ng-model=\"vm.surveyDetails.start_at\" ng-disabled=\"true\" required></md-datepicker></div><div \nflex><label><span translate=\"SURVEY.END\">End</span> <span class=\"red-text\">*</span></label><md-datepicker \nng-model=\"vm.surveyDetails.end_at\" md-min-date=\"vm.surveyDetails.start_at\" md-open-on-focus ng-required=\"true\">\n</md-datepicker></div></div><div layout=\"row\"><div layout-align=\"start center\" class=\"padding-top-5\"><label \ntranslate=\"SURVEY.SHARE\">Share</label></div><div class=\"padding-left-20\"><md-radio-group name=\"share\" \nng-model=\"vm.surveyDetails.share\" ng-disabled=\"vm.surveyDetails.status == \'started\'\" required><md-radio-button \nvalue=\"1\"><span translate=\"SURVEY.PUBLIC\">Yes</span></md-radio-button><md-radio-button value=\"0\"><span \ntranslate=\"SURVEY.PRIVATE\">No (can only be used in your project)</span></md-radio-button></md-radio-group></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><div flex=\"100\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"send-button gray2-btn md-raised\" aria-label=\"Close\" translate=\"SURVEY.CLOSE\" ng-click=\"vm.closeDialog()\">Close\n</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Send\" translate=\"SURVEY.SAVE\" \nng-click=\"vm.saveSurvey()\" ng-disabled=\"surveyDetailsForm.$invalid\">Save</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/survey-new/views/dialogs/question/question-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Question\" md-theme=\"{{vm.theme}}\"><form name=\"questionDataForm\">\n<md-toolbar class=\"gray2-bg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"QUESTION.DIALOG_TITLE\">Question details</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"SURVEY.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\">\n<md-input-container class=\"md-block\"><label><span translate=\"QUESTION.QUESTION\">Question</span>\n ({{vm.selectedSurvey.language}})</label><input name=\"title\" ng-model=\"vm.questionData.question\" type=\"text\" required>\n<div ng-messages=\"questionDataForm.title.$error\"><div ng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">\nRequired field</span></div></div></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"QUESTION.ANSWER_TYPE\">Answer type</label><md-select name=\"answerType\" \nng-model=\"vm.questionData.answer_type\" ng-change=\"vm.changeAnswerType()\" required><md-option \nng-repeat=\"type in vm.answerTypes\" ng-value=\"type.code\">{{type.answer}}</md-option></md-select><div \nng-messages=\"surveyDetailsForm.answerType.$error\"><div ng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">\nRequired field</span></div></div></md-input-container><div ng-if=\"vm.showChoices\"><md-card><md-toolbar \nclass=\"blue-300-bg\"><h2 class=\"md-toolbar-tools\"><span translate=\"QUESTION.CHOICES_DETAILS\">Choices details</span></h2>\n</md-toolbar><md-card-content><div layout=\"row\"><md-input-container flex=\"80\" class=\"md-block\"><label><span \ntranslate=\"QUESTION.CHOICE\">Choice</span></label><input name=\"choice\" ng-model=\"vm.questionChoice\" type=\"text\"><div \nng-messages=\"questionDataForm.choice.$error\"><div ng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">\nRequired field</span></div></div></md-input-container><md-button flex=\"20\" class=\"md-secondary\" \nng-click=\"vm.addChoice(choice)\" aria-label=\"Add choice\"><span translate=\"QUESTION.ADD\">Add</span></md-button></div>\n<md-list ng-if=\"vm.questionData.choices.length > 0\"><md-subheader><span translate=\"QUESTION.ANSWER_CHOICES\">\nAnswer choices</span></md-subheader><md-list-item ng-repeat=\"choice in vm.questionData.choices\"><p>{{choice.text}}</p>\n<md-button class=\"md-secondary\" ng-click=\"vm.removeChoice(choice)\" aria-label=\"Delete choice\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s16\"></md-icon></md-button></md-list-item></md-list></md-card-content></md-card>\n</div><div><label><strong>{{vm.errorMsg}}</strong></label></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<div flex=\"80\" layout=\"row\"><div layout-align=\"start center\" class=\"padding-top-5\"><label \ntranslate=\"QUESTION.MANDATORY\">Mandatory</label></div><div class=\"padding-left-20\"><md-radio-group name=\"mandatory\" \nng-model=\"vm.mandatoryQuestion\" layout=\"row\" required><md-radio-button value=\"1\"><span translate=\"QUESTION.YES\">Yes\n</span></md-radio-button><md-radio-button value=\"0\"><span translate=\"QUESTION.NO\">No</span></md-radio-button>\n</md-radio-group></div></div><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"send-button gray2-btn md-raised\" aria-label=\"Close\" translate=\"SURVEY.CLOSE\" ng-click=\"vm.closeDialog()\">Close\n</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Send\" translate=\"SURVEY.SAVE\" \nng-click=\"vm.saveQuestion()\" ng-disabled=\"questionDataForm.$invalid\">Save</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/survey-new/views/dialogs/rounds/rounds-dialog.html","<md-dialog class=\"rounds-dialog\" aria-label=\"New Message\" md-theme=\"{{vm.theme}}\"><form name=\"surveyRoundsForm\">\n<md-toolbar class=\"gray2-bg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span><span\n class=\"title\" translate=\"SURVEY.ROUNDS\"></span> <span class=\"title\" translate=\"SURVEY.OF\"></span>\n {{ vm.survey.title }}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" \ntranlate translate-aria-label=\"SURVEY.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll layout=\"column\"><div layout=\"row\" layout-align=\"end center\"><md-button \naria-label=\"Add\" class=\"md-icon-button md-accent\" ng-click=\"vm.addRound()\"><md-icon md-font-icon=\"icon-plus-circle\" \naria-label=\"Add\"></md-icon></md-button></div><div layout=\"row\"><div flex layout=\"row\"><h3 translate=\"SURVEY.ROUNDS\">\n</h3></div><div flex layout=\"row\"><div flex class=\"padding-left-15\"><h3 translate=\"SURVEY.START\">Start</h3></div><div \nflex class=\"padding-left-15\"><h3 translate=\"SURVEY.END\"></h3></div></div><div style=\"width: 50px\"></div></div><div \nlayout=\"row\" ng-repeat=\"round in vm.rounds\"><div flex layout=\"row\"><md-input-container style=\"width: 90%\"><input \nname=\"round-{{round.id}}\" ng-model=\"round.round\" required></md-input-container></div><div flex layout=\"row\"><div flex \nclass=\"padding-top-10\"><md-datepicker ng-model=\"round.start_at\" required></md-datepicker></div><div flex \nclass=\"padding-top-10\"><md-datepicker ng-model=\"round.end_at\" md-min-date=\"round.start_at\" md-open-on-focus required>\n</md-datepicker></div></div><div style=\"width: 50px\" class=\"padding-top-10\"><md-button aria-label=\"Delete\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.deleteRound(round)\" ng-if=\"round.survey_pendings_count == 0\"><md-icon \nmd-font-icon=\"icon-delete\" aria-label=\"Delete\"></md-icon></md-button></div></div></md-dialog-content><md-dialog-actions\n layout=\"row\"><div flex=\"100\" layout=\"row\" layout-align=\"end center\"><md-progress-circular md-mode=\"indeterminate\" \nng-if=\"vm.loading\" md-diameter=\"40\" class=\"md-primary\"></md-progress-circular><md-button \nclass=\"send-button gray2-btn md-raised\" aria-label=\"Close\" translate=\"SURVEY.CLOSE\" ng-click=\"vm.closeDialog()\">Close\n</md-button><md-button class=\"send-button md-primary md-raised\" aria-label=\"Send\" translate=\"SHARED.SAVE\" \nng-click=\"vm.saveRounds()\" ng-disabled=\"surveyRoundsForm.$invalid || vm.rounds.length == 0\">Save</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/survey-new/views/dialogs/survey/survey-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" md-theme=\"{{vm.theme}}\"><form name=\"surveyDetailsForm\">\n<md-toolbar class=\"gray2-bg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"SURVEY.DIALOG_TITLE\">Survey-forms details</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"SURVEY.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\">\n<md-input-container class=\"md-block\"><label translate=\"SURVEY.TITLE\">Title</label><input name=\"title\" \nng-model=\"vm.surveyDetails.title\" type=\"text\" ng-disabled=\"vm.surveyDetails.status == \'started\'\" required><div \nng-messages=\"surveyDetailsForm.title.$error\"><div ng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">\nRequired field</span></div></div></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"SURVEY.DESCRIPTION\">Description</label><textarea name=\"description\" ng-model=\"vm.surveyDetails.description\" \nrows=\"2\" ng-disabled=\"vm.surveyDetails.status == \'started\'\" required></textarea><div \nng-messages=\"surveyDetailsForm.description.$error\"><div ng-message=\"required\"><span translate=\"SURVEY.REQUIRED_FIELD\">\nRequired field</span></div></div></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"SURVEY.FINAL_MSG\">Final Message</label><textarea name=\"finalmsg\" ng-model=\"vm.surveyDetails.final_msg\" \nrows=\"2\" ng-disabled=\"vm.surveyDetails.status == \'started\'\" maxlength=\"512\"></textarea></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"vm.api.useGroups\"><label translate=\"SURVEY.GROUPS\"></label><md-select \nname=\"group\" ng-model=\"vm.surveyDetails.groupIds\" ng-disabled=\"vm.surveyDetails.status == \'started\'\" \nmultiple=\"multiple\"><md-optgroup label=\"{{vm.groupsLabel}}\"><md-option \nng-repeat=\"group in vm.groups | orderBy: \'name\'\" ng-value=\"group.id\">{{group.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"surveyDetailsForm.group.$error\"><div ng-message=\"required\"><span \ntranslate=\"SURVEY.REQUIRED_FIELD\">Required field</span></div></div></md-input-container><div layout=\"row\"><div flex>\n<label translate=\"SURVEY.START\">Start</label><md-datepicker ng-model=\"vm.surveyDetails.start_at\" ng-disabled=\"true\" \nrequired></md-datepicker></div><div flex><label><span translate=\"SURVEY.END\">End</span> <span class=\"red-text\">*</span>\n</label><md-datepicker ng-model=\"vm.surveyDetails.end_at\" md-min-date=\"vm.surveyDetails.start_at\" md-open-on-focus \nng-required=\"true\"></md-datepicker></div></div><div layout=\"row\"><div flex layout=\"row\"><div \nlayout-align=\"start center\" class=\"padding-top-5\"><label translate=\"SURVEY.SHARE\">Share</label></div><div \nclass=\"padding-left-20\"><md-radio-group name=\"share\" ng-model=\"vm.surveyDetails.share\" \nng-disabled=\"vm.surveyDetails.status == \'started\'\" required><md-radio-button value=\"1\"><span translate=\"SURVEY.PUBLIC\">\nYes</span></md-radio-button><md-radio-button value=\"0\"><span translate=\"SURVEY.PRIVATE\">\nNo (can only be used in your project)</span></md-radio-button></md-radio-group></div></div><div flex layout=\"row\" \nng-if=\"!vm.api.useGroups\"><div layout-align=\"start center\" class=\"padding-top-5\"><label translate=\"SURVEY.ASSIGN\">\nAssign</label></div><div class=\"padding-left-20\"><md-radio-group name=\"share\" ng-model=\"vm.surveyDetails.default\" \nng-required=\"!vm.api.useGroups\"><md-radio-button value=\"1\"><span translate=\"SURVEY.ASSIGN_TO_ALL\">To all(default)\n</span></md-radio-button><md-radio-button value=\"0\"><span translate=\"SURVEY.MANUALLY\">Manually</span></md-radio-button>\n</md-radio-group></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"send-button gray2-btn md-raised\" aria-label=\"Close\" \ntranslate=\"SURVEY.CLOSE\" ng-click=\"vm.closeDialog()\">Close</md-button><md-button class=\"md-primary md-raised\" \naria-label=\"Send\" translate=\"SURVEY.SAVE\" ng-click=\"vm.saveSurvey()\" ng-disabled=\"surveyDetailsForm.$invalid\">Save\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/survey-new/views/dialogs/survey-preview/survey-preview-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" md-theme=\"{{vm.theme}}\"><form name=\"surveyQuestionsForm\">\n<md-toolbar class=\"gray2-bg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"SURVEY.SURVEY_PREVIEW\">Survey-form preview</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"SURVEY.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\"><div \nlayout=\"row\"><strong><span translate=\"SURVEY.TITLE\"></span></strong> <span>: {{vm.survey.title}}</span></div><div \nlayout=\"row\"><strong><span translate=\"SURVEY.DESCRIPTION\"></span></strong> <span>: {{vm.survey.description}}</span>\n</div><div layout=\"row\"><strong><span translate=\"SURVEY.LANGUAGE\"></span></strong> <span>\n: {{vm.languages[vm.survey.language]}}</span></div><div layout=\"row\"><strong><span translate=\"SURVEY.SHARE\"></span>\n</strong> <span>: <span ng-if=\"vm.survey.share\" translate=\"QUESTION.YES\"></span> <span ng-if=\"!vm.survey.share\" \ntranslate=\"QUESTION.NO\"></span></span></div><div layout=\"row\" class=\"padding-top-15\"><strong><span \ntranslate=\"SURVEY.QUESTIONS\"></span></strong></div><div layout=\"column\" class=\"padding-top-15\" \nng-repeat=\"surveyConf in vm.survey.survey_configurations | objectToArray | orderBy: \'question_order\'\"><div \nlayout=\"row\" style=\"border-bottom: 1px solid #E6E6E6\"><div style=\"width: 60px; padding-top: 10px\"><input \nng-model=\"surveyConf.question_order\" type=\"number\" class=\"order-input\" required></div><div flex><div \nng-if=\"surveyConf.survey_question.answer_type == \'likert\'\"><strong><span>{{surveyConf.survey_question.question}}</span>\n</strong><div layout=\"row\"><span flex=\"5\" class=\"slider-label\">1</span><md-slider flex ng-model=\"surveyConf.slider\" \nmin=\"1\" max=\"5\" aria-label=\"green\" class=\"md-accent\"></md-slider><span flex=\"5\" class=\"padding-left-15 slider-label\">5\n</span></div></div><div layout=\"column\" ng-if=\"surveyConf.survey_question.answer_type == \'single_choice\'\"><div \nlayout=\"row\" class=\"padding-bottom-15\"><strong><span>{{surveyConf.survey_question.question}}</span></strong></div>\n<md-radio-group ng-model=\"surveyConf.radioGroup\"><md-radio-button \nng-repeat=\"choice in surveyConf.survey_question.survey_choices\" ng-value=\"choice.id\">{{choice.choice}}\n</md-radio-button></md-radio-group></div><div layout=\"column\" \nng-if=\"surveyConf.survey_question.answer_type == \'multiple_choice\'\"><div layout=\"row\" class=\"padding-bottom-15\">\n<strong><span>{{surveyConf.survey_question.question}}</span></strong></div><div \nng-repeat=\"choice in surveyConf.survey_question.survey_choices\"><md-checkbox>{{choice.choice}}</md-checkbox></div>\n</div><div layout=\"column\" ng-if=\"surveyConf.survey_question.answer_type == \'input\'\"><md-input-container \nclass=\"md-block\"><label>{{surveyConf.survey_question.question}}</label><input ng-model=\"surveyConf.input\" type=\"text\">\n</md-input-container></div><div layout=\"column\" ng-if=\"surveyConf.survey_question.answer_type == \'boolean\'\"><div \nlayout=\"row\" class=\"padding-bottom-15\"><strong><span>{{surveyConf.survey_question.question}}</span></strong></div>\n<md-radio-group ng-model=\"surveyConf.radioGroup\"><md-radio-button ng-value=\"true\"><span translate=\"QUESTION.YES\">\n</span></md-radio-button><md-radio-button ng-value=\"false\"><span translate=\"QUESTION.NO\"></span></md-radio-button>\n</md-radio-group></div><div layout=\"column\" ng-if=\"surveyConf.survey_question.answer_type == \'number\'\">\n<md-input-container class=\"md-block\"><label>{{surveyConf.survey_question.question}}</label><input \nng-model=\"surveyConf.input\" type=\"number\"></md-input-container></div><div layout=\"column\" \nng-if=\"surveyConf.survey_question.answer_type == \'headline\'\"><div layout=\"row\" class=\"padding-bottom-15\"><strong><span>\n{{surveyConf.survey_question.question}}</span></strong></div></div></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><div flex=\"100\" layout=\"row\" layout-align=\"end center\"><md-progress-circular \nmd-mode=\"indeterminate\" ng-if=\"vm.loading\" md-diameter=\"40\" class=\"md-primary\"></md-progress-circular><md-button \nclass=\"send-button gray2-btn md-raised\" aria-label=\"Close\" translate=\"SURVEY.CLOSE\" ng-click=\"vm.closeDialog()\">Close\n</md-button><md-button class=\"send-button md-primary md-raised\" aria-label=\"Send\" translate=\"SURVEY.CHANGE_ORDER\" \nng-click=\"vm.changeQuestionsOrder()\" ng-disabled=\"surveyQuestionsForm.$invalid\">Save</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/workflow/views/dialogs/variable/variable-dialog.html","<md-dialog class=\"variable-dialog\" aria-label=\"New Message\" md-theme=\"{{vm.theme}}\"><form name=\"variableDetailForm\">\n<md-toolbar class=\"gray2-bg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"WORKFLOW.VARIABLE_DETAILS\">Variable details</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"SHARED.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\">\n<md-input-container class=\"md-block\"><label translate=\"SHARED.NAME\">Name</label><input name=\"name\" \nng-model=\"vm.variableDetails.name\" type=\"text\" required><div ng-messages=\"variableDetailForm.title.$error\"><div \nng-message=\"required\"><span translate=\"SHARED.REQUIRED_FIELD\">Required field</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"WORKFLOW.VARIABLE_TYPE\">Variable type</label><md-select \nname=\"variableType\" ng-model=\"vm.variableDetails.data_type\" required><md-option ng-repeat=\"type in vm.variableTypes\" \nng-value=\"type.value\">{{type.description}}</md-option></md-select><div \nng-messages=\"variableDetailForm.variableType.$error\"><div ng-message=\"required\"><span \ntranslate=\"SURVEY.REQUIRED_FIELD\">Required field</span></div></div></md-input-container><h3 \ntranslate=\"WORKFLOW.DATA_SUBSET\"></h3><div class=\"pb-10\"><div id=\"mathquillDiv\" style=\"width: 100%\">\n{{ vm.variableDetails.definition }}</div></div><div layout=\"row\" layout-align=\"start center\" class=\"pt-10\"><div flex>\n<md-input-container class=\"md-block\"><label translate=\"WORKFLOW.OTHER_VARIABLES\">Other variables</label><md-select \nname=\"otherVariables\" ng-model=\"vm.otherVariableSelected\"><md-option \nng-repeat=\"variable in vm.otherVariables | orderBy:\'name\'\" ng-value=\"variable\">{{variable.name}}</md-option>\n</md-select></md-input-container></div><div flex=\"50px\"><md-button aria-label=\"Add\" class=\"md-icon-button md-accent\" \nng-click=\"vm.addOtherVariable()\" ng-disabled=\"!vm.otherVariableSelected\"><md-icon md-font-icon=\"icon-plus-circle\" \naria-label=\"Add\"></md-icon></md-button></div></div><h4 translate=\"WORKFLOW.EQUATION_SYMBOLS\"></h4><div \nclass=\"calc-buttons\" layout=\"row\" layout-align=\"start center\"><div flex ng-click=\"vm.addSymbol(\'+\', false)\">+</div><div\n flex class=\"ml-10\" ng-click=\"vm.addSymbol(\'-\', false)\">-</div><div flex class=\"ml-10\" \nng-click=\"vm.addSymbol(\'cdot\', true)\">*</div><div flex class=\"ml-10\" ng-click=\"vm.addSymbol(\'frac\', true)\">÷</div>\n</div><div class=\"calc-buttons pt-10\" layout=\"row\" layout-align=\"center center\"><div flex \nng-click=\"vm.addSymbol(\'(\', false)\">(</div><div flex class=\"ml-10\" ng-click=\"vm.addSymbol(\')\', false)\">)</div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><div flex=\"100\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"send-button gray2-btn md-raised\" aria-label=\"Close\" translate=\"SHARED.CLOSE\" ng-click=\"vm.closeDialog()\">Close\n</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Send\" translate=\"SHARED.SAVE\" \nng-click=\"vm.saveVariable()\" ng-disabled=\"variableDetailForm.$invalid\">Save</md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/workflow/views/dialogs/workflow/workflow-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" md-theme=\"{{vm.theme}}\"><form name=\"workflowDetailsForm\">\n<md-toolbar class=\"gray2-bg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"WORKFLOW.DIALOG_TITLE\">Workflow details</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"SHARED.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\">\n<md-input-container class=\"md-block\"><label translate=\"WORKFLOW.NAME\">Name</label><input name=\"name\" \nng-model=\"vm.workflowDetails.name\" type=\"text\" required><div ng-messages=\"workflowDetailsForm.name.$error\"><div \nng-message=\"required\"><span translate=\"SHARED.REQUIRED_FIELD\">Required field</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"SHARED.DESCRIPTION\">Description</label><textarea \nname=\"description\" ng-model=\"vm.workflowDetails.description\" rows=\"2\" required></textarea><div \nng-messages=\"workflowDetailsForm.description.$error\"><div ng-message=\"required\"><span \ntranslate=\"SHARED.REQUIRED_FIELD\">Required field</span></div></div></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\"><div flex=\"100\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"send-button gray2-btn md-raised\" aria-label=\"Close\" translate=\"SHARED.CLOSE\" ng-click=\"vm.closeDialog()\">Close\n</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Send\" translate=\"SHARED.SAVE\" \nng-click=\"vm.saveWorkflow()\" ng-disabled=\"workflowDetailsForm.$invalid\">Save</md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" layout=\"row\" layout-align=\"start center\"><div class=\"step\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">\nOptional</div></div></md-button><div class=\"ms-stepper-step-content\" ng-transclude></div><div \nclass=\"ms-stepper-controls\" layout=\"row\" layout-align=\"start center\" \nng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button class=\"md-accent md-raised\" \nng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);